/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as SignedOutRouteImport } from './routes/signed-out'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as ViewAsRouteImport } from './routes/view-as'
import { Route as AppAccountRouteImport } from './routes/_app.account'
import { Route as AppAdminRouteImport } from './routes/_app.admin'
import { Route as AppApprovalsRouteImport } from './routes/_app.approvals'
import { Route as AppCompaniesRouteImport } from './routes/_app.companies'
import { Route as AppDirectoryRouteImport } from './routes/_app.directory'
import { Route as AppHomeRouteImport } from './routes/_app.home'
import { Route as AppMeRouteImport } from './routes/_app.me'
import { Route as AppNotificationsRouteImport } from './routes/_app.notifications'
import { Route as AppOrdersRouteImport } from './routes/_app.orders'
import { Route as AppPortfolioRouteImport } from './routes/_app.portfolio'
import { Route as AppProfileRouteImport } from './routes/_app.profile'
import { Route as AppSettingsRouteImport } from './routes/_app.settings'
import { Route as AppSupportRouteImport } from './routes/_app.support'
import { Route as AppSyncRouteImport } from './routes/_app.sync'
import { Route as AuthAdminSigninRouteImport } from './routes/auth.admin-signin'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as CSlugRouteImport } from './routes/c.$slug'
import { Route as InvitationsAcceptRouteImport } from './routes/invitations.accept'
import { Route as PSlugRouteImport } from './routes/p.$slug'
import { Route as TendersAcceptRouteImport } from './routes/tenders.accept'
import { Route as AppAccountAccountingRouteImport } from './routes/_app.account.accounting'
import { Route as AppAccountApprovalRulesRouteImport } from './routes/_app.account.approval-rules'
import { Route as AppAccountShortlistRouteImport } from './routes/_app.account.shortlist'
import { Route as AppBillingReturnRouteImport } from './routes/_app.billing.return'
import { Route as AppLandIndexRouteImport } from './routes/_app.land.index'
import { Route as AppLandListingIdRouteImport } from './routes/_app.land.$listingId'
import { Route as AppLandEnquiriesRouteImport } from './routes/_app.land.enquiries'
import { Route as AppMarketplaceIndexRouteImport } from './routes/_app.marketplace.index'
import { Route as AppMarketplaceLabourRatesRouteImport } from './routes/_app.marketplace.labour-rates'
import { Route as AppMarketplaceProfessionalsRouteImport } from './routes/_app.marketplace.professionals'
import { Route as AppMeIndexRouteImport } from './routes/_app.me.index'
import { Route as AppMeAttendanceRouteImport } from './routes/_app.me.attendance'
import { Route as AppMeEarningsRouteImport } from './routes/_app.me.earnings'
import { Route as AppMeProfileRouteImport } from './routes/_app.me.profile'
import { Route as AppMessagesIndexRouteImport } from './routes/_app.messages.index'
import { Route as AppMessagesConversationIdRouteImport } from './routes/_app.messages.$conversationId'
import { Route as AppOnboardingIndexRouteImport } from './routes/_app.onboarding.index'
import { Route as AppOnboardingFlowRouteImport } from './routes/_app.onboarding.$flow'
import { Route as AppOrgOrgIdRouteImport } from './routes/_app.org.$orgId'
import { Route as AppOrgNewRouteImport } from './routes/_app.org.new'
import { Route as AppProjectsIndexRouteImport } from './routes/_app.projects.index'
import { Route as AppProjectsProjectIdRouteImport } from './routes/_app.projects.$projectId'
import { Route as AppProjectsNewRouteImport } from './routes/_app.projects.new'
import { Route as AppSupplierOrgIdRouteImport } from './routes/_app.supplier.$orgId'
import { Route as AppSupplierRegisterRouteImport } from './routes/_app.supplier.register'
import { Route as OrganizationsInvitationsAcceptRouteImport } from './routes/organizations.invitations.accept'
import { Route as AppLandSellIndexRouteImport } from './routes/_app.land.sell.index'
import { Route as AppMarketplacePricesIndexRouteImport } from './routes/_app.marketplace.prices.index'
import { Route as AppMarketplacePricesProductIdRouteImport } from './routes/_app.marketplace.prices.$productId'
import { Route as AppMarketplaceSuppliersIndexRouteImport } from './routes/_app.marketplace.suppliers.index'
import { Route as AppMarketplaceSuppliersOrgIdRouteImport } from './routes/_app.marketplace.suppliers.$orgId'
import { Route as AppMarketplaceWorkersIndexRouteImport } from './routes/_app.marketplace.workers.index'
import { Route as AppMarketplaceWorkersWorkerIdRouteImport } from './routes/_app.marketplace.workers.$workerId'
import { Route as AppMarketplaceWorkersRequestsRouteImport } from './routes/_app.marketplace.workers.requests'
import { Route as AppMeServicesIndexRouteImport } from './routes/_app.me.services.index'
import { Route as AppMeServicesApplicationsRouteImport } from './routes/_app.me.services.applications'
import { Route as AppMeServicesInvitationsRouteImport } from './routes/_app.me.services.invitations'
import { Route as AppMeServicesOpeningsRouteImport } from './routes/_app.me.services.openings'
import { Route as AppMeWorkIndexRouteImport } from './routes/_app.me.work.index'
import { Route as AppMeWorkCertificatesRouteImport } from './routes/_app.me.work.certificates'
import { Route as AppMeWorkJobsRouteImport } from './routes/_app.me.work.jobs'
import { Route as AppMeWorkListingRouteImport } from './routes/_app.me.work.listing'
import { Route as AppMeWorkRequestsRouteImport } from './routes/_app.me.work.requests'
import { Route as AppMeWorkReviewsRouteImport } from './routes/_app.me.work.reviews'
import { Route as AppOrgOrgIdIndexRouteImport } from './routes/_app.org.$orgId.index'
import { Route as AppOrgOrgIdApprovalRulesRouteImport } from './routes/_app.org.$orgId.approval-rules'
import { Route as AppOrgOrgIdAuditRouteImport } from './routes/_app.org.$orgId.audit'
import { Route as AppOrgOrgIdBillingRouteImport } from './routes/_app.org.$orgId.billing'
import { Route as AppOrgOrgIdClientsRouteImport } from './routes/_app.org.$orgId.clients'
import { Route as AppOrgOrgIdFeesRouteImport } from './routes/_app.org.$orgId.fees'
import { Route as AppOrgOrgIdIntegrationsRouteImport } from './routes/_app.org.$orgId.integrations'
import { Route as AppOrgOrgIdJobsRouteImport } from './routes/_app.org.$orgId.jobs'
import { Route as AppOrgOrgIdMembersRouteImport } from './routes/_app.org.$orgId.members'
import { Route as AppOrgOrgIdOverviewRouteImport } from './routes/_app.org.$orgId.overview'
import { Route as AppOrgOrgIdPortfolioRouteImport } from './routes/_app.org.$orgId.portfolio'
import { Route as AppOrgOrgIdProfileRouteImport } from './routes/_app.org.$orgId.profile'
import { Route as AppOrgOrgIdProjectsRouteImport } from './routes/_app.org.$orgId.projects'
import { Route as AppOrgOrgIdRolesRouteImport } from './routes/_app.org.$orgId.roles'
import { Route as AppOrgOrgIdSettingsRouteImport } from './routes/_app.org.$orgId.settings'
import { Route as AppOrgOrgIdShortlistRouteImport } from './routes/_app.org.$orgId.shortlist'
import { Route as AppOrgOrgIdTemplatesRouteImport } from './routes/_app.org.$orgId.templates'
import { Route as AppOrgOrgIdWorkloadRouteImport } from './routes/_app.org.$orgId.workload'
import { Route as AppProjectsProjectIdIndexRouteImport } from './routes/_app.projects.$projectId.index'
import { Route as AppProjectsProjectIdCloseoutRouteImport } from './routes/_app.projects.$projectId.closeout'
import { Route as AppProjectsProjectIdCommercialRouteImport } from './routes/_app.projects.$projectId.commercial'
import { Route as AppProjectsProjectIdCostRouteImport } from './routes/_app.projects.$projectId.cost'
import { Route as AppProjectsProjectIdDecisionsRouteImport } from './routes/_app.projects.$projectId.decisions'
import { Route as AppProjectsProjectIdDesignRouteImport } from './routes/_app.projects.$projectId.design'
import { Route as AppProjectsProjectIdDocumentsRouteImport } from './routes/_app.projects.$projectId.documents'
import { Route as AppProjectsProjectIdHandoverRouteImport } from './routes/_app.projects.$projectId.handover'
import { Route as AppProjectsProjectIdHiringRouteImport } from './routes/_app.projects.$projectId.hiring'
import { Route as AppProjectsProjectIdInsightsRouteImport } from './routes/_app.projects.$projectId.insights'
import { Route as AppProjectsProjectIdOverviewRouteImport } from './routes/_app.projects.$projectId.overview'
import { Route as AppProjectsProjectIdOwnerPlanRouteImport } from './routes/_app.projects.$projectId.owner-plan'
import { Route as AppProjectsProjectIdPlanRouteImport } from './routes/_app.projects.$projectId.plan'
import { Route as AppProjectsProjectIdProcurementRouteImport } from './routes/_app.projects.$projectId.procurement'
import { Route as AppProjectsProjectIdQualityRouteImport } from './routes/_app.projects.$projectId.quality'
import { Route as AppProjectsProjectIdResourcesRouteImport } from './routes/_app.projects.$projectId.resources'
import { Route as AppProjectsProjectIdRisksRouteImport } from './routes/_app.projects.$projectId.risks'
import { Route as AppProjectsProjectIdSafetyRouteImport } from './routes/_app.projects.$projectId.safety'
import { Route as AppProjectsProjectIdSettingsRouteImport } from './routes/_app.projects.$projectId.settings'
import { Route as AppProjectsProjectIdSiteRouteImport } from './routes/_app.projects.$projectId.site'
import { Route as AppProjectsProjectIdSubcontractsRouteImport } from './routes/_app.projects.$projectId.subcontracts'
import { Route as AppProjectsProjectIdTeamRouteImport } from './routes/_app.projects.$projectId.team'
import { Route as AppProjectsProjectIdTimelineRouteImport } from './routes/_app.projects.$projectId.timeline'
import { Route as AppProjectsProjectIdWorkforceRouteImport } from './routes/_app.projects.$projectId.workforce'
import { Route as AppSupplierOrgIdIndexRouteImport } from './routes/_app.supplier.$orgId.index'
import { Route as AppSupplierOrgIdAnalyticsRouteImport } from './routes/_app.supplier.$orgId.analytics'
import { Route as AppSupplierOrgIdBillingRouteImport } from './routes/_app.supplier.$orgId.billing'
import { Route as AppSupplierOrgIdBranchesRouteImport } from './routes/_app.supplier.$orgId.branches'
import { Route as AppSupplierOrgIdCatalogRouteImport } from './routes/_app.supplier.$orgId.catalog'
import { Route as AppSupplierOrgIdDashboardRouteImport } from './routes/_app.supplier.$orgId.dashboard'
import { Route as AppSupplierOrgIdDeliveriesRouteImport } from './routes/_app.supplier.$orgId.deliveries'
import { Route as AppSupplierOrgIdInvoicesRouteImport } from './routes/_app.supplier.$orgId.invoices'
import { Route as AppSupplierOrgIdNotificationsRouteImport } from './routes/_app.supplier.$orgId.notifications'
import { Route as AppSupplierOrgIdPaymentsRouteImport } from './routes/_app.supplier.$orgId.payments'
import { Route as AppSupplierOrgIdProfileRouteImport } from './routes/_app.supplier.$orgId.profile'
import { Route as AppSupplierOrgIdPublicRouteImport } from './routes/_app.supplier.$orgId.public'
import { Route as AppSupplierOrgIdQuotesRouteImport } from './routes/_app.supplier.$orgId.quotes'
import { Route as AppSupplierOrgIdTeamRouteImport } from './routes/_app.supplier.$orgId.team'
import { Route as AppLandSellOrgIdIndexRouteImport } from './routes/_app.land.sell.$orgId.index'
import { Route as AppMeServicesJobsIndexRouteImport } from './routes/_app.me.services.jobs.index'
import { Route as AppMeServicesJobsJobIdRouteImport } from './routes/_app.me.services.jobs.$jobId'
import { Route as AppMeServicesQuotesIndexRouteImport } from './routes/_app.me.services.quotes.index'
import { Route as AppMeServicesQuotesResponseIdRouteImport } from './routes/_app.me.services.quotes.$responseId'
import { Route as AppMeServicesTendersIndexRouteImport } from './routes/_app.me.services.tenders.index'
import { Route as AppMeServicesTendersPackageIdRouteImport } from './routes/_app.me.services.tenders.$packageId'
import { Route as AppOrgOrgIdReportsIndexRouteImport } from './routes/_app.org.$orgId.reports.index'
import { Route as AppOrgOrgIdReportsReportKeyRouteImport } from './routes/_app.org.$orgId.reports.$reportKey'
import { Route as AppOrgOrgIdTendersIndexRouteImport } from './routes/_app.org.$orgId.tenders.index'
import { Route as AppOrgOrgIdTendersPackageIdRouteImport } from './routes/_app.org.$orgId.tenders.$packageId'
import { Route as AppProjectsProjectIdCloseoutIndexRouteImport } from './routes/_app.projects.$projectId.closeout.index'
import { Route as AppProjectsProjectIdCloseoutOverviewRouteImport } from './routes/_app.projects.$projectId.closeout.overview'
import { Route as AppProjectsProjectIdCloseoutWarrantyRouteImport } from './routes/_app.projects.$projectId.closeout.warranty'
import { Route as AppProjectsProjectIdCommercialIndexRouteImport } from './routes/_app.projects.$projectId.commercial.index'
import { Route as AppProjectsProjectIdCommercialCertificatesRouteImport } from './routes/_app.projects.$projectId.commercial.certificates'
import { Route as AppProjectsProjectIdCommercialClaimsRouteImport } from './routes/_app.projects.$projectId.commercial.claims'
import { Route as AppProjectsProjectIdCommercialContractRouteImport } from './routes/_app.projects.$projectId.commercial.contract'
import { Route as AppProjectsProjectIdCommercialCostControlRouteImport } from './routes/_app.projects.$projectId.commercial.cost-control'
import { Route as AppProjectsProjectIdCommercialCostPlansRouteImport } from './routes/_app.projects.$projectId.commercial.cost-plans'
import { Route as AppProjectsProjectIdCommercialFinalAccountRouteImport } from './routes/_app.projects.$projectId.commercial.final-account'
import { Route as AppProjectsProjectIdCommercialOverviewRouteImport } from './routes/_app.projects.$projectId.commercial.overview'
import { Route as AppProjectsProjectIdCommercialPaymentsRouteImport } from './routes/_app.projects.$projectId.commercial.payments'
import { Route as AppProjectsProjectIdCommercialRetentionRouteImport } from './routes/_app.projects.$projectId.commercial.retention'
import { Route as AppProjectsProjectIdCommercialSumsRouteImport } from './routes/_app.projects.$projectId.commercial.sums'
import { Route as AppProjectsProjectIdCommercialVariationsRouteImport } from './routes/_app.projects.$projectId.commercial.variations'
import { Route as AppProjectsProjectIdCostIndexRouteImport } from './routes/_app.projects.$projectId.cost.index'
import { Route as AppProjectsProjectIdCostExpensesRouteImport } from './routes/_app.projects.$projectId.cost.expenses'
import { Route as AppProjectsProjectIdCostMaterialsOnSiteRouteImport } from './routes/_app.projects.$projectId.cost.materials-on-site'
import { Route as AppProjectsProjectIdCostOverviewRouteImport } from './routes/_app.projects.$projectId.cost.overview'
import { Route as AppProjectsProjectIdCostVariationsRouteImport } from './routes/_app.projects.$projectId.cost.variations'
import { Route as AppProjectsProjectIdDecisionsIndexRouteImport } from './routes/_app.projects.$projectId.decisions.index'
import { Route as AppProjectsProjectIdDecisionsChangeRequestsRouteImport } from './routes/_app.projects.$projectId.decisions.change-requests'
import { Route as AppProjectsProjectIdDecisionsSelectionsRouteImport } from './routes/_app.projects.$projectId.decisions.selections'
import { Route as AppProjectsProjectIdDesignIndexRouteImport } from './routes/_app.projects.$projectId.design.index'
import { Route as AppProjectsProjectIdDesignCompareRouteImport } from './routes/_app.projects.$projectId.design.compare'
import { Route as AppProjectsProjectIdDesignCompletionRouteImport } from './routes/_app.projects.$projectId.design.completion'
import { Route as AppProjectsProjectIdDesignCoordinationRouteImport } from './routes/_app.projects.$projectId.design.coordination'
import { Route as AppProjectsProjectIdDesignDeliverablesRouteImport } from './routes/_app.projects.$projectId.design.deliverables'
import { Route as AppProjectsProjectIdDesignDrawingsRouteImport } from './routes/_app.projects.$projectId.design.drawings'
import { Route as AppProjectsProjectIdDesignOverviewRouteImport } from './routes/_app.projects.$projectId.design.overview'
import { Route as AppProjectsProjectIdDesignRfisRouteImport } from './routes/_app.projects.$projectId.design.rfis'
import { Route as AppProjectsProjectIdDesignSiteVisitsRouteImport } from './routes/_app.projects.$projectId.design.site-visits'
import { Route as AppProjectsProjectIdDesignSpecificationsRouteImport } from './routes/_app.projects.$projectId.design.specifications'
import { Route as AppProjectsProjectIdDesignSubmittalsRouteImport } from './routes/_app.projects.$projectId.design.submittals'
import { Route as AppProjectsProjectIdDesignTransmittalsRouteImport } from './routes/_app.projects.$projectId.design.transmittals'
import { Route as AppProjectsProjectIdHiringIndexRouteImport } from './routes/_app.projects.$projectId.hiring.index'
import { Route as AppProjectsProjectIdInsightsIndexRouteImport } from './routes/_app.projects.$projectId.insights.index'
import { Route as AppProjectsProjectIdInsightsFlagsRouteImport } from './routes/_app.projects.$projectId.insights.flags'
import { Route as AppProjectsProjectIdInsightsForecastRouteImport } from './routes/_app.projects.$projectId.insights.forecast'
import { Route as AppProjectsProjectIdLabourEvidenceIndexRouteImport } from './routes/_app.projects.$projectId.labour-evidence.index'
import { Route as AppProjectsProjectIdLabourEvidenceTimesheetsRouteImport } from './routes/_app.projects.$projectId.labour-evidence.timesheets'
import { Route as AppProjectsProjectIdPlanIndexRouteImport } from './routes/_app.projects.$projectId.plan.index'
import { Route as AppProjectsProjectIdPlanBaselinesRouteImport } from './routes/_app.projects.$projectId.plan.baselines'
import { Route as AppProjectsProjectIdPlanConstraintsRouteImport } from './routes/_app.projects.$projectId.plan.constraints'
import { Route as AppProjectsProjectIdPlanLookaheadRouteImport } from './routes/_app.projects.$projectId.plan.lookahead'
import { Route as AppProjectsProjectIdPlanMilestonesRouteImport } from './routes/_app.projects.$projectId.plan.milestones'
import { Route as AppProjectsProjectIdPlanStagesRouteImport } from './routes/_app.projects.$projectId.plan.stages'
import { Route as AppProjectsProjectIdPlanTasksRouteImport } from './routes/_app.projects.$projectId.plan.tasks'
import { Route as AppProjectsProjectIdPlanWeeklyPlansRouteImport } from './routes/_app.projects.$projectId.plan.weekly-plans'
import { Route as AppProjectsProjectIdPlanZonesRouteImport } from './routes/_app.projects.$projectId.plan.zones'
import { Route as AppProjectsProjectIdProcurementIndexRouteImport } from './routes/_app.projects.$projectId.procurement.index'
import { Route as AppProjectsProjectIdProcurementCartRouteImport } from './routes/_app.projects.$projectId.procurement.cart'
import { Route as AppProjectsProjectIdProcurementDeliveriesRouteImport } from './routes/_app.projects.$projectId.procurement.deliveries'
import { Route as AppProjectsProjectIdProcurementInvoicesRouteImport } from './routes/_app.projects.$projectId.procurement.invoices'
import { Route as AppProjectsProjectIdProcurementRequisitionsRouteImport } from './routes/_app.projects.$projectId.procurement.requisitions'
import { Route as AppProjectsProjectIdQualityIndexRouteImport } from './routes/_app.projects.$projectId.quality.index'
import { Route as AppProjectsProjectIdQualityChecklistsRouteImport } from './routes/_app.projects.$projectId.quality.checklists'
import { Route as AppProjectsProjectIdQualityNcrsRouteImport } from './routes/_app.projects.$projectId.quality.ncrs'
import { Route as AppProjectsProjectIdQualityRectificationsRouteImport } from './routes/_app.projects.$projectId.quality.rectifications'
import { Route as AppProjectsProjectIdQualitySnagsRouteImport } from './routes/_app.projects.$projectId.quality.snags'
import { Route as AppProjectsProjectIdQualityTestsRouteImport } from './routes/_app.projects.$projectId.quality.tests'
import { Route as AppProjectsProjectIdReportsIndexRouteImport } from './routes/_app.projects.$projectId.reports.index'
import { Route as AppProjectsProjectIdReportsReportKeyRouteImport } from './routes/_app.projects.$projectId.reports.$reportKey'
import { Route as AppProjectsProjectIdResourcesIndexRouteImport } from './routes/_app.projects.$projectId.resources.index'
import { Route as AppProjectsProjectIdResourcesEquipmentRouteImport } from './routes/_app.projects.$projectId.resources.equipment'
import { Route as AppProjectsProjectIdResourcesEquipmentRequestsRouteImport } from './routes/_app.projects.$projectId.resources.equipment-requests'
import { Route as AppProjectsProjectIdResourcesRequestsRouteImport } from './routes/_app.projects.$projectId.resources.requests'
import { Route as AppProjectsProjectIdResourcesStoreRouteImport } from './routes/_app.projects.$projectId.resources.store'
import { Route as AppProjectsProjectIdResourcesSubmittalsRouteImport } from './routes/_app.projects.$projectId.resources.submittals'
import { Route as AppProjectsProjectIdSafetyIndexRouteImport } from './routes/_app.projects.$projectId.safety.index'
import { Route as AppProjectsProjectIdSafetyIncidentsRouteImport } from './routes/_app.projects.$projectId.safety.incidents'
import { Route as AppProjectsProjectIdSafetyOverviewRouteImport } from './routes/_app.projects.$projectId.safety.overview'
import { Route as AppProjectsProjectIdSafetyPpeRouteImport } from './routes/_app.projects.$projectId.safety.ppe'
import { Route as AppProjectsProjectIdSafetyToolboxRouteImport } from './routes/_app.projects.$projectId.safety.toolbox'
import { Route as AppProjectsProjectIdSiteIndexRouteImport } from './routes/_app.projects.$projectId.site.index'
import { Route as AppProjectsProjectIdSiteAttendanceRouteImport } from './routes/_app.projects.$projectId.site.attendance'
import { Route as AppProjectsProjectIdSiteDailyPlanRouteImport } from './routes/_app.projects.$projectId.site.daily-plan'
import { Route as AppProjectsProjectIdSiteDayCloseRouteImport } from './routes/_app.projects.$projectId.site.day-close'
import { Route as AppProjectsProjectIdSiteDiaryRouteImport } from './routes/_app.projects.$projectId.site.diary'
import { Route as AppProjectsProjectIdSiteInstructionsRouteImport } from './routes/_app.projects.$projectId.site.instructions'
import { Route as AppProjectsProjectIdSiteIssuesRouteImport } from './routes/_app.projects.$projectId.site.issues'
import { Route as AppProjectsProjectIdSiteMeetingsRouteImport } from './routes/_app.projects.$projectId.site.meetings'
import { Route as AppProjectsProjectIdSitePhotosRouteImport } from './routes/_app.projects.$projectId.site.photos'
import { Route as AppProjectsProjectIdSiteProgressRouteImport } from './routes/_app.projects.$projectId.site.progress'
import { Route as AppProjectsProjectIdSiteTodayRouteImport } from './routes/_app.projects.$projectId.site.today'
import { Route as AppProjectsProjectIdSiteVisitorsRouteImport } from './routes/_app.projects.$projectId.site.visitors'
import { Route as AppProjectsProjectIdSubcontractsIndexRouteImport } from './routes/_app.projects.$projectId.subcontracts.index'
import { Route as AppProjectsProjectIdSubcontractsChangesRouteImport } from './routes/_app.projects.$projectId.subcontracts.changes'
import { Route as AppProjectsProjectIdSubcontractsConsentsRouteImport } from './routes/_app.projects.$projectId.subcontracts.consents'
import { Route as AppProjectsProjectIdSubcontractsDailyReportsRouteImport } from './routes/_app.projects.$projectId.subcontracts.daily-reports'
import { Route as AppProjectsProjectIdSubcontractsOverviewRouteImport } from './routes/_app.projects.$projectId.subcontracts.overview'
import { Route as AppProjectsProjectIdSubcontractsOwnStockRouteImport } from './routes/_app.projects.$projectId.subcontracts.own-stock'
import { Route as AppProjectsProjectIdSubcontractsPaymentsRouteImport } from './routes/_app.projects.$projectId.subcontracts.payments'
import { Route as AppProjectsProjectIdSubcontractsPurchasesRouteImport } from './routes/_app.projects.$projectId.subcontracts.purchases'
import { Route as AppProjectsProjectIdTendersIndexRouteImport } from './routes/_app.projects.$projectId.tenders.index'
import { Route as AppProjectsProjectIdTendersPackageIdRouteImport } from './routes/_app.projects.$projectId.tenders.$packageId'
import { Route as AppProjectsProjectIdTimelineIndexRouteImport } from './routes/_app.projects.$projectId.timeline.index'
import { Route as AppProjectsProjectIdTimelineActivityRouteImport } from './routes/_app.projects.$projectId.timeline.activity'
import { Route as AppProjectsProjectIdTimelinePhotosRouteImport } from './routes/_app.projects.$projectId.timeline.photos'
import { Route as AppProjectsProjectIdWorkforceIndexRouteImport } from './routes/_app.projects.$projectId.workforce.index'
import { Route as AppProjectsProjectIdWorkforceCrewsRouteImport } from './routes/_app.projects.$projectId.workforce.crews'
import { Route as AppProjectsProjectIdWorkforceProductivityRouteImport } from './routes/_app.projects.$projectId.workforce.productivity'
import { Route as AppProjectsProjectIdWorkforceTimesheetsRouteImport } from './routes/_app.projects.$projectId.workforce.timesheets'
import { Route as AppSupplierOrgIdCustomersIndexRouteImport } from './routes/_app.supplier.$orgId.customers.index'
import { Route as AppSupplierOrgIdCustomersCustomerIdRouteImport } from './routes/_app.supplier.$orgId.customers.$customerId'
import { Route as AppSupplierOrgIdMessagesIndexRouteImport } from './routes/_app.supplier.$orgId.messages.index'
import { Route as AppSupplierOrgIdMessagesConversationIdRouteImport } from './routes/_app.supplier.$orgId.messages.$conversationId'
import { Route as AppSupplierOrgIdOrdersIndexRouteImport } from './routes/_app.supplier.$orgId.orders.index'
import { Route as AppSupplierOrgIdOrdersPoIdRouteImport } from './routes/_app.supplier.$orgId.orders.$poId'
import { Route as AppSupplierOrgIdRfqsIndexRouteImport } from './routes/_app.supplier.$orgId.rfqs.index'
import { Route as AppSupplierOrgIdRfqsRfqIdRouteImport } from './routes/_app.supplier.$orgId.rfqs.$rfqId'
import { Route as PrintOrgOrgIdReportsReportKeyRouteImport } from './routes/print.org.$orgId.reports.$reportKey'
import { Route as PrintProjectsProjectIdCertificatesCertificateIdRouteImport } from './routes/print.projects.$projectId.certificates.$certificateId'
import { Route as PrintProjectsProjectIdReportsReportKeyRouteImport } from './routes/print.projects.$projectId.reports.$reportKey'
import { Route as PrintProjectsProjectIdSiteVisitsVisitIdRouteImport } from './routes/print.projects.$projectId.site-visits.$visitId'
import { Route as AppLandSellOrgIdListingsListingIdRouteImport } from './routes/_app.land.sell.$orgId.listings.$listingId'
import { Route as AppProjectsProjectIdCommercialMeasureValuationIdRouteImport } from './routes/_app.projects.$projectId.commercial.measure.$valuationId'
import { Route as AppProjectsProjectIdCommercialValuationsIndexRouteImport } from './routes/_app.projects.$projectId.commercial.valuations.index'
import { Route as AppProjectsProjectIdCommercialValuationsValuationIdRouteImport } from './routes/_app.projects.$projectId.commercial.valuations.$valuationId'
import { Route as AppProjectsProjectIdCostBoqIndexRouteImport } from './routes/_app.projects.$projectId.cost.boq.index'
import { Route as AppProjectsProjectIdCostBoqBoqIdRouteImport } from './routes/_app.projects.$projectId.cost.boq.$boqId'
import { Route as AppProjectsProjectIdCostScansIndexRouteImport } from './routes/_app.projects.$projectId.cost.scans.index'
import { Route as AppProjectsProjectIdCostScansExtractionIdRouteImport } from './routes/_app.projects.$projectId.cost.scans.$extractionId'
import { Route as AppProjectsProjectIdHiringJobsIndexRouteImport } from './routes/_app.projects.$projectId.hiring.jobs.index'
import { Route as AppProjectsProjectIdHiringJobsJobIdRouteImport } from './routes/_app.projects.$projectId.hiring.jobs.$jobId'
import { Route as AppProjectsProjectIdHiringOpeningsIndexRouteImport } from './routes/_app.projects.$projectId.hiring.openings.index'
import { Route as AppProjectsProjectIdHiringOpeningsOpeningIdRouteImport } from './routes/_app.projects.$projectId.hiring.openings.$openingId'
import { Route as AppProjectsProjectIdHiringQuotesIndexRouteImport } from './routes/_app.projects.$projectId.hiring.quotes.index'
import { Route as AppProjectsProjectIdHiringQuotesQuoteIdRouteImport } from './routes/_app.projects.$projectId.hiring.quotes.$quoteId'
import { Route as AppProjectsProjectIdInsightsWeeklyIndexRouteImport } from './routes/_app.projects.$projectId.insights.weekly.index'
import { Route as AppProjectsProjectIdInsightsWeeklySummaryIdRouteImport } from './routes/_app.projects.$projectId.insights.weekly.$summaryId'
import { Route as AppProjectsProjectIdLabourEvidencePayrollIndexRouteImport } from './routes/_app.projects.$projectId.labour-evidence.payroll.index'
import { Route as AppProjectsProjectIdLabourEvidencePayrollRunIdRouteImport } from './routes/_app.projects.$projectId.labour-evidence.payroll.$runId'
import { Route as AppProjectsProjectIdProcurementOrdersIndexRouteImport } from './routes/_app.projects.$projectId.procurement.orders.index'
import { Route as AppProjectsProjectIdProcurementOrdersPoIdRouteImport } from './routes/_app.projects.$projectId.procurement.orders.$poId'
import { Route as AppProjectsProjectIdProcurementRfqsIndexRouteImport } from './routes/_app.projects.$projectId.procurement.rfqs.index'
import { Route as AppProjectsProjectIdProcurementRfqsRfqIdRouteImport } from './routes/_app.projects.$projectId.procurement.rfqs.$rfqId'
import { Route as AppProjectsProjectIdProcurementShopIndexRouteImport } from './routes/_app.projects.$projectId.procurement.shop.index'
import { Route as AppProjectsProjectIdProcurementShopOrgIdRouteImport } from './routes/_app.projects.$projectId.procurement.shop.$orgId'
import { Route as AppProjectsProjectIdQualityInspectionsIndexRouteImport } from './routes/_app.projects.$projectId.quality.inspections.index'
import { Route as AppProjectsProjectIdQualityInspectionsInspectionIdRouteImport } from './routes/_app.projects.$projectId.quality.inspections.$inspectionId'
import { Route as AppProjectsProjectIdSafetyWalksIndexRouteImport } from './routes/_app.projects.$projectId.safety.walks.index'
import { Route as AppProjectsProjectIdSafetyWalksInspectionIdRouteImport } from './routes/_app.projects.$projectId.safety.walks.$inspectionId'
import { Route as AppProjectsProjectIdSubcontractsContractsSubcontractIdRouteImport } from './routes/_app.projects.$projectId.subcontracts.contracts.$subcontractId'
import { Route as AppProjectsProjectIdSubcontractsPackagesIndexRouteImport } from './routes/_app.projects.$projectId.subcontracts.packages.index'
import { Route as AppProjectsProjectIdSubcontractsPackagesPackageIdRouteImport } from './routes/_app.projects.$projectId.subcontracts.packages.$packageId'
import { Route as AppProjectsProjectIdWorkforceCrewIndexRouteImport } from './routes/_app.projects.$projectId.workforce.crew.index'
import { Route as AppProjectsProjectIdWorkforceCrewEngagementIdRouteImport } from './routes/_app.projects.$projectId.workforce.crew.$engagementId'
import { Route as AppProjectsProjectIdWorkforcePayrollIndexRouteImport } from './routes/_app.projects.$projectId.workforce.payroll.index'
import { Route as AppProjectsProjectIdWorkforcePayrollRunIdRouteImport } from './routes/_app.projects.$projectId.workforce.payroll.$runId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const SignedOutRoute = SignedOutRouteImport.update({
  id: '/signed-out',
  path: '/signed-out',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninRoute = SigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const ViewAsRoute = ViewAsRouteImport.update({
  id: '/view-as',
  path: '/view-as',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAccountRoute = AppAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppApprovalsRoute = AppApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => AppRoute,
} as any)
const AppCompaniesRoute = AppCompaniesRouteImport.update({
  id: '/companies',
  path: '/companies',
  getParentRoute: () => AppRoute,
} as any)
const AppDirectoryRoute = AppDirectoryRouteImport.update({
  id: '/directory',
  path: '/directory',
  getParentRoute: () => AppRoute,
} as any)
const AppHomeRoute = AppHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AppRoute,
} as any)
const AppMeRoute = AppMeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => AppRoute,
} as any)
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersRoute = AppOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AppRoute,
} as any)
const AppPortfolioRoute = AppPortfolioRouteImport.update({
  id: '/portfolio',
  path: '/portfolio',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppSupportRoute = AppSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => AppRoute,
} as any)
const AppSyncRoute = AppSyncRouteImport.update({
  id: '/sync',
  path: '/sync',
  getParentRoute: () => AppRoute,
} as any)
const AuthAdminSigninRoute = AuthAdminSigninRouteImport.update({
  id: '/auth/admin-signin',
  path: '/auth/admin-signin',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const CSlugRoute = CSlugRouteImport.update({
  id: '/c/$slug',
  path: '/c/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitationsAcceptRoute = InvitationsAcceptRouteImport.update({
  id: '/invitations/accept',
  path: '/invitations/accept',
  getParentRoute: () => rootRouteImport,
} as any)
const PSlugRoute = PSlugRouteImport.update({
  id: '/p/$slug',
  path: '/p/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const TendersAcceptRoute = TendersAcceptRouteImport.update({
  id: '/tenders/accept',
  path: '/tenders/accept',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAccountAccountingRoute = AppAccountAccountingRouteImport.update({
  id: '/accounting',
  path: '/accounting',
  getParentRoute: () => AppAccountRoute,
} as any)
const AppAccountApprovalRulesRoute = AppAccountApprovalRulesRouteImport.update({
  id: '/approval-rules',
  path: '/approval-rules',
  getParentRoute: () => AppAccountRoute,
} as any)
const AppAccountShortlistRoute = AppAccountShortlistRouteImport.update({
  id: '/shortlist',
  path: '/shortlist',
  getParentRoute: () => AppAccountRoute,
} as any)
const AppBillingReturnRoute = AppBillingReturnRouteImport.update({
  id: '/billing/return',
  path: '/billing/return',
  getParentRoute: () => AppRoute,
} as any)
const AppLandIndexRoute = AppLandIndexRouteImport.update({
  id: '/land/',
  path: '/land/',
  getParentRoute: () => AppRoute,
} as any)
const AppLandListingIdRoute = AppLandListingIdRouteImport.update({
  id: '/land/$listingId',
  path: '/land/$listingId',
  getParentRoute: () => AppRoute,
} as any)
const AppLandEnquiriesRoute = AppLandEnquiriesRouteImport.update({
  id: '/land/enquiries',
  path: '/land/enquiries',
  getParentRoute: () => AppRoute,
} as any)
const AppMarketplaceIndexRoute = AppMarketplaceIndexRouteImport.update({
  id: '/marketplace/',
  path: '/marketplace/',
  getParentRoute: () => AppRoute,
} as any)
const AppMarketplaceLabourRatesRoute =
  AppMarketplaceLabourRatesRouteImport.update({
    id: '/marketplace/labour-rates',
    path: '/marketplace/labour-rates',
    getParentRoute: () => AppRoute,
  } as any)
const AppMarketplaceProfessionalsRoute =
  AppMarketplaceProfessionalsRouteImport.update({
    id: '/marketplace/professionals',
    path: '/marketplace/professionals',
    getParentRoute: () => AppRoute,
  } as any)
const AppMeIndexRoute = AppMeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppMeRoute,
} as any)
const AppMeAttendanceRoute = AppMeAttendanceRouteImport.update({
  id: '/attendance',
  path: '/attendance',
  getParentRoute: () => AppMeRoute,
} as any)
const AppMeEarningsRoute = AppMeEarningsRouteImport.update({
  id: '/earnings',
  path: '/earnings',
  getParentRoute: () => AppMeRoute,
} as any)
const AppMeProfileRoute = AppMeProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppMeRoute,
} as any)
const AppMessagesIndexRoute = AppMessagesIndexRouteImport.update({
  id: '/messages/',
  path: '/messages/',
  getParentRoute: () => AppRoute,
} as any)
const AppMessagesConversationIdRoute =
  AppMessagesConversationIdRouteImport.update({
    id: '/messages/$conversationId',
    path: '/messages/$conversationId',
    getParentRoute: () => AppRoute,
  } as any)
const AppOnboardingIndexRoute = AppOnboardingIndexRouteImport.update({
  id: '/onboarding/',
  path: '/onboarding/',
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingFlowRoute = AppOnboardingFlowRouteImport.update({
  id: '/onboarding/$flow',
  path: '/onboarding/$flow',
  getParentRoute: () => AppRoute,
} as any)
const AppOrgOrgIdRoute = AppOrgOrgIdRouteImport.update({
  id: '/org/$orgId',
  path: '/org/$orgId',
  getParentRoute: () => AppRoute,
} as any)
const AppOrgNewRoute = AppOrgNewRouteImport.update({
  id: '/org/new',
  path: '/org/new',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsIndexRoute = AppProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsProjectIdRoute = AppProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsNewRoute = AppProjectsNewRouteImport.update({
  id: '/projects/new',
  path: '/projects/new',
  getParentRoute: () => AppRoute,
} as any)
const AppSupplierOrgIdRoute = AppSupplierOrgIdRouteImport.update({
  id: '/supplier/$orgId',
  path: '/supplier/$orgId',
  getParentRoute: () => AppRoute,
} as any)
const AppSupplierRegisterRoute = AppSupplierRegisterRouteImport.update({
  id: '/supplier/register',
  path: '/supplier/register',
  getParentRoute: () => AppRoute,
} as any)
const OrganizationsInvitationsAcceptRoute =
  OrganizationsInvitationsAcceptRouteImport.update({
    id: '/organizations/invitations/accept',
    path: '/organizations/invitations/accept',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppLandSellIndexRoute = AppLandSellIndexRouteImport.update({
  id: '/land/sell/',
  path: '/land/sell/',
  getParentRoute: () => AppRoute,
} as any)
const AppMarketplacePricesIndexRoute =
  AppMarketplacePricesIndexRouteImport.update({
    id: '/marketplace/prices/',
    path: '/marketplace/prices/',
    getParentRoute: () => AppRoute,
  } as any)
const AppMarketplacePricesProductIdRoute =
  AppMarketplacePricesProductIdRouteImport.update({
    id: '/marketplace/prices/$productId',
    path: '/marketplace/prices/$productId',
    getParentRoute: () => AppRoute,
  } as any)
const AppMarketplaceSuppliersIndexRoute =
  AppMarketplaceSuppliersIndexRouteImport.update({
    id: '/marketplace/suppliers/',
    path: '/marketplace/suppliers/',
    getParentRoute: () => AppRoute,
  } as any)
const AppMarketplaceSuppliersOrgIdRoute =
  AppMarketplaceSuppliersOrgIdRouteImport.update({
    id: '/marketplace/suppliers/$orgId',
    path: '/marketplace/suppliers/$orgId',
    getParentRoute: () => AppRoute,
  } as any)
const AppMarketplaceWorkersIndexRoute =
  AppMarketplaceWorkersIndexRouteImport.update({
    id: '/marketplace/workers/',
    path: '/marketplace/workers/',
    getParentRoute: () => AppRoute,
  } as any)
const AppMarketplaceWorkersWorkerIdRoute =
  AppMarketplaceWorkersWorkerIdRouteImport.update({
    id: '/marketplace/workers/$workerId',
    path: '/marketplace/workers/$workerId',
    getParentRoute: () => AppRoute,
  } as any)
const AppMarketplaceWorkersRequestsRoute =
  AppMarketplaceWorkersRequestsRouteImport.update({
    id: '/marketplace/workers/requests',
    path: '/marketplace/workers/requests',
    getParentRoute: () => AppRoute,
  } as any)
const AppMeServicesIndexRoute = AppMeServicesIndexRouteImport.update({
  id: '/services/',
  path: '/services/',
  getParentRoute: () => AppMeRoute,
} as any)
const AppMeServicesApplicationsRoute =
  AppMeServicesApplicationsRouteImport.update({
    id: '/services/applications',
    path: '/services/applications',
    getParentRoute: () => AppMeRoute,
  } as any)
const AppMeServicesInvitationsRoute =
  AppMeServicesInvitationsRouteImport.update({
    id: '/services/invitations',
    path: '/services/invitations',
    getParentRoute: () => AppMeRoute,
  } as any)
const AppMeServicesOpeningsRoute = AppMeServicesOpeningsRouteImport.update({
  id: '/services/openings',
  path: '/services/openings',
  getParentRoute: () => AppMeRoute,
} as any)
const AppMeWorkIndexRoute = AppMeWorkIndexRouteImport.update({
  id: '/work/',
  path: '/work/',
  getParentRoute: () => AppMeRoute,
} as any)
const AppMeWorkCertificatesRoute = AppMeWorkCertificatesRouteImport.update({
  id: '/work/certificates',
  path: '/work/certificates',
  getParentRoute: () => AppMeRoute,
} as any)
const AppMeWorkJobsRoute = AppMeWorkJobsRouteImport.update({
  id: '/work/jobs',
  path: '/work/jobs',
  getParentRoute: () => AppMeRoute,
} as any)
const AppMeWorkListingRoute = AppMeWorkListingRouteImport.update({
  id: '/work/listing',
  path: '/work/listing',
  getParentRoute: () => AppMeRoute,
} as any)
const AppMeWorkRequestsRoute = AppMeWorkRequestsRouteImport.update({
  id: '/work/requests',
  path: '/work/requests',
  getParentRoute: () => AppMeRoute,
} as any)
const AppMeWorkReviewsRoute = AppMeWorkReviewsRouteImport.update({
  id: '/work/reviews',
  path: '/work/reviews',
  getParentRoute: () => AppMeRoute,
} as any)
const AppOrgOrgIdIndexRoute = AppOrgOrgIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppOrgOrgIdRoute,
} as any)
const AppOrgOrgIdApprovalRulesRoute =
  AppOrgOrgIdApprovalRulesRouteImport.update({
    id: '/approval-rules',
    path: '/approval-rules',
    getParentRoute: () => AppOrgOrgIdRoute,
  } as any)
const AppOrgOrgIdAuditRoute = AppOrgOrgIdAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppOrgOrgIdRoute,
} as any)
const AppOrgOrgIdBillingRoute = AppOrgOrgIdBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppOrgOrgIdRoute,
} as any)
const AppOrgOrgIdClientsRoute = AppOrgOrgIdClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => AppOrgOrgIdRoute,
} as any)
const AppOrgOrgIdFeesRoute = AppOrgOrgIdFeesRouteImport.update({
  id: '/fees',
  path: '/fees',
  getParentRoute: () => AppOrgOrgIdRoute,
} as any)
const AppOrgOrgIdIntegrationsRoute = AppOrgOrgIdIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => AppOrgOrgIdRoute,
} as any)
const AppOrgOrgIdJobsRoute = AppOrgOrgIdJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => AppOrgOrgIdRoute,
} as any)
const AppOrgOrgIdMembersRoute = AppOrgOrgIdMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AppOrgOrgIdRoute,
} as any)
const AppOrgOrgIdOverviewRoute = AppOrgOrgIdOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => AppOrgOrgIdRoute,
} as any)
const AppOrgOrgIdPortfolioRoute = AppOrgOrgIdPortfolioRouteImport.update({
  id: '/portfolio',
  path: '/portfolio',
  getParentRoute: () => AppOrgOrgIdRoute,
} as any)
const AppOrgOrgIdProfileRoute = AppOrgOrgIdProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppOrgOrgIdRoute,
} as any)
const AppOrgOrgIdProjectsRoute = AppOrgOrgIdProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => AppOrgOrgIdRoute,
} as any)
const AppOrgOrgIdRolesRoute = AppOrgOrgIdRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AppOrgOrgIdRoute,
} as any)
const AppOrgOrgIdSettingsRoute = AppOrgOrgIdSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppOrgOrgIdRoute,
} as any)
const AppOrgOrgIdShortlistRoute = AppOrgOrgIdShortlistRouteImport.update({
  id: '/shortlist',
  path: '/shortlist',
  getParentRoute: () => AppOrgOrgIdRoute,
} as any)
const AppOrgOrgIdTemplatesRoute = AppOrgOrgIdTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => AppOrgOrgIdRoute,
} as any)
const AppOrgOrgIdWorkloadRoute = AppOrgOrgIdWorkloadRouteImport.update({
  id: '/workload',
  path: '/workload',
  getParentRoute: () => AppOrgOrgIdRoute,
} as any)
const AppProjectsProjectIdIndexRoute =
  AppProjectsProjectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdCloseoutRoute =
  AppProjectsProjectIdCloseoutRouteImport.update({
    id: '/closeout',
    path: '/closeout',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdCommercialRoute =
  AppProjectsProjectIdCommercialRouteImport.update({
    id: '/commercial',
    path: '/commercial',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdCostRoute =
  AppProjectsProjectIdCostRouteImport.update({
    id: '/cost',
    path: '/cost',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdDecisionsRoute =
  AppProjectsProjectIdDecisionsRouteImport.update({
    id: '/decisions',
    path: '/decisions',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdDesignRoute =
  AppProjectsProjectIdDesignRouteImport.update({
    id: '/design',
    path: '/design',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdDocumentsRoute =
  AppProjectsProjectIdDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdHandoverRoute =
  AppProjectsProjectIdHandoverRouteImport.update({
    id: '/handover',
    path: '/handover',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdHiringRoute =
  AppProjectsProjectIdHiringRouteImport.update({
    id: '/hiring',
    path: '/hiring',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdInsightsRoute =
  AppProjectsProjectIdInsightsRouteImport.update({
    id: '/insights',
    path: '/insights',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdOverviewRoute =
  AppProjectsProjectIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdOwnerPlanRoute =
  AppProjectsProjectIdOwnerPlanRouteImport.update({
    id: '/owner-plan',
    path: '/owner-plan',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdPlanRoute =
  AppProjectsProjectIdPlanRouteImport.update({
    id: '/plan',
    path: '/plan',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdProcurementRoute =
  AppProjectsProjectIdProcurementRouteImport.update({
    id: '/procurement',
    path: '/procurement',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdQualityRoute =
  AppProjectsProjectIdQualityRouteImport.update({
    id: '/quality',
    path: '/quality',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdResourcesRoute =
  AppProjectsProjectIdResourcesRouteImport.update({
    id: '/resources',
    path: '/resources',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdRisksRoute =
  AppProjectsProjectIdRisksRouteImport.update({
    id: '/risks',
    path: '/risks',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdSafetyRoute =
  AppProjectsProjectIdSafetyRouteImport.update({
    id: '/safety',
    path: '/safety',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdSettingsRoute =
  AppProjectsProjectIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdSiteRoute =
  AppProjectsProjectIdSiteRouteImport.update({
    id: '/site',
    path: '/site',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdSubcontractsRoute =
  AppProjectsProjectIdSubcontractsRouteImport.update({
    id: '/subcontracts',
    path: '/subcontracts',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdTeamRoute =
  AppProjectsProjectIdTeamRouteImport.update({
    id: '/team',
    path: '/team',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdTimelineRoute =
  AppProjectsProjectIdTimelineRouteImport.update({
    id: '/timeline',
    path: '/timeline',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdWorkforceRoute =
  AppProjectsProjectIdWorkforceRouteImport.update({
    id: '/workforce',
    path: '/workforce',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppSupplierOrgIdIndexRoute = AppSupplierOrgIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSupplierOrgIdRoute,
} as any)
const AppSupplierOrgIdAnalyticsRoute =
  AppSupplierOrgIdAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AppSupplierOrgIdRoute,
  } as any)
const AppSupplierOrgIdBillingRoute = AppSupplierOrgIdBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppSupplierOrgIdRoute,
} as any)
const AppSupplierOrgIdBranchesRoute =
  AppSupplierOrgIdBranchesRouteImport.update({
    id: '/branches',
    path: '/branches',
    getParentRoute: () => AppSupplierOrgIdRoute,
  } as any)
const AppSupplierOrgIdCatalogRoute = AppSupplierOrgIdCatalogRouteImport.update({
  id: '/catalog',
  path: '/catalog',
  getParentRoute: () => AppSupplierOrgIdRoute,
} as any)
const AppSupplierOrgIdDashboardRoute =
  AppSupplierOrgIdDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AppSupplierOrgIdRoute,
  } as any)
const AppSupplierOrgIdDeliveriesRoute =
  AppSupplierOrgIdDeliveriesRouteImport.update({
    id: '/deliveries',
    path: '/deliveries',
    getParentRoute: () => AppSupplierOrgIdRoute,
  } as any)
const AppSupplierOrgIdInvoicesRoute =
  AppSupplierOrgIdInvoicesRouteImport.update({
    id: '/invoices',
    path: '/invoices',
    getParentRoute: () => AppSupplierOrgIdRoute,
  } as any)
const AppSupplierOrgIdNotificationsRoute =
  AppSupplierOrgIdNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AppSupplierOrgIdRoute,
  } as any)
const AppSupplierOrgIdPaymentsRoute =
  AppSupplierOrgIdPaymentsRouteImport.update({
    id: '/payments',
    path: '/payments',
    getParentRoute: () => AppSupplierOrgIdRoute,
  } as any)
const AppSupplierOrgIdProfileRoute = AppSupplierOrgIdProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppSupplierOrgIdRoute,
} as any)
const AppSupplierOrgIdPublicRoute = AppSupplierOrgIdPublicRouteImport.update({
  id: '/public',
  path: '/public',
  getParentRoute: () => AppSupplierOrgIdRoute,
} as any)
const AppSupplierOrgIdQuotesRoute = AppSupplierOrgIdQuotesRouteImport.update({
  id: '/quotes',
  path: '/quotes',
  getParentRoute: () => AppSupplierOrgIdRoute,
} as any)
const AppSupplierOrgIdTeamRoute = AppSupplierOrgIdTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AppSupplierOrgIdRoute,
} as any)
const AppLandSellOrgIdIndexRoute = AppLandSellOrgIdIndexRouteImport.update({
  id: '/land/sell/$orgId/',
  path: '/land/sell/$orgId/',
  getParentRoute: () => AppRoute,
} as any)
const AppMeServicesJobsIndexRoute = AppMeServicesJobsIndexRouteImport.update({
  id: '/services/jobs/',
  path: '/services/jobs/',
  getParentRoute: () => AppMeRoute,
} as any)
const AppMeServicesJobsJobIdRoute = AppMeServicesJobsJobIdRouteImport.update({
  id: '/services/jobs/$jobId',
  path: '/services/jobs/$jobId',
  getParentRoute: () => AppMeRoute,
} as any)
const AppMeServicesQuotesIndexRoute =
  AppMeServicesQuotesIndexRouteImport.update({
    id: '/services/quotes/',
    path: '/services/quotes/',
    getParentRoute: () => AppMeRoute,
  } as any)
const AppMeServicesQuotesResponseIdRoute =
  AppMeServicesQuotesResponseIdRouteImport.update({
    id: '/services/quotes/$responseId',
    path: '/services/quotes/$responseId',
    getParentRoute: () => AppMeRoute,
  } as any)
const AppMeServicesTendersIndexRoute =
  AppMeServicesTendersIndexRouteImport.update({
    id: '/services/tenders/',
    path: '/services/tenders/',
    getParentRoute: () => AppMeRoute,
  } as any)
const AppMeServicesTendersPackageIdRoute =
  AppMeServicesTendersPackageIdRouteImport.update({
    id: '/services/tenders/$packageId',
    path: '/services/tenders/$packageId',
    getParentRoute: () => AppMeRoute,
  } as any)
const AppOrgOrgIdReportsIndexRoute = AppOrgOrgIdReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => AppOrgOrgIdRoute,
} as any)
const AppOrgOrgIdReportsReportKeyRoute =
  AppOrgOrgIdReportsReportKeyRouteImport.update({
    id: '/reports/$reportKey',
    path: '/reports/$reportKey',
    getParentRoute: () => AppOrgOrgIdRoute,
  } as any)
const AppOrgOrgIdTendersIndexRoute = AppOrgOrgIdTendersIndexRouteImport.update({
  id: '/tenders/',
  path: '/tenders/',
  getParentRoute: () => AppOrgOrgIdRoute,
} as any)
const AppOrgOrgIdTendersPackageIdRoute =
  AppOrgOrgIdTendersPackageIdRouteImport.update({
    id: '/tenders/$packageId',
    path: '/tenders/$packageId',
    getParentRoute: () => AppOrgOrgIdRoute,
  } as any)
const AppProjectsProjectIdCloseoutIndexRoute =
  AppProjectsProjectIdCloseoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProjectsProjectIdCloseoutRoute,
  } as any)
const AppProjectsProjectIdCloseoutOverviewRoute =
  AppProjectsProjectIdCloseoutOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AppProjectsProjectIdCloseoutRoute,
  } as any)
const AppProjectsProjectIdCloseoutWarrantyRoute =
  AppProjectsProjectIdCloseoutWarrantyRouteImport.update({
    id: '/warranty',
    path: '/warranty',
    getParentRoute: () => AppProjectsProjectIdCloseoutRoute,
  } as any)
const AppProjectsProjectIdCommercialIndexRoute =
  AppProjectsProjectIdCommercialIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProjectsProjectIdCommercialRoute,
  } as any)
const AppProjectsProjectIdCommercialCertificatesRoute =
  AppProjectsProjectIdCommercialCertificatesRouteImport.update({
    id: '/certificates',
    path: '/certificates',
    getParentRoute: () => AppProjectsProjectIdCommercialRoute,
  } as any)
const AppProjectsProjectIdCommercialClaimsRoute =
  AppProjectsProjectIdCommercialClaimsRouteImport.update({
    id: '/claims',
    path: '/claims',
    getParentRoute: () => AppProjectsProjectIdCommercialRoute,
  } as any)
const AppProjectsProjectIdCommercialContractRoute =
  AppProjectsProjectIdCommercialContractRouteImport.update({
    id: '/contract',
    path: '/contract',
    getParentRoute: () => AppProjectsProjectIdCommercialRoute,
  } as any)
const AppProjectsProjectIdCommercialCostControlRoute =
  AppProjectsProjectIdCommercialCostControlRouteImport.update({
    id: '/cost-control',
    path: '/cost-control',
    getParentRoute: () => AppProjectsProjectIdCommercialRoute,
  } as any)
const AppProjectsProjectIdCommercialCostPlansRoute =
  AppProjectsProjectIdCommercialCostPlansRouteImport.update({
    id: '/cost-plans',
    path: '/cost-plans',
    getParentRoute: () => AppProjectsProjectIdCommercialRoute,
  } as any)
const AppProjectsProjectIdCommercialFinalAccountRoute =
  AppProjectsProjectIdCommercialFinalAccountRouteImport.update({
    id: '/final-account',
    path: '/final-account',
    getParentRoute: () => AppProjectsProjectIdCommercialRoute,
  } as any)
const AppProjectsProjectIdCommercialOverviewRoute =
  AppProjectsProjectIdCommercialOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AppProjectsProjectIdCommercialRoute,
  } as any)
const AppProjectsProjectIdCommercialPaymentsRoute =
  AppProjectsProjectIdCommercialPaymentsRouteImport.update({
    id: '/payments',
    path: '/payments',
    getParentRoute: () => AppProjectsProjectIdCommercialRoute,
  } as any)
const AppProjectsProjectIdCommercialRetentionRoute =
  AppProjectsProjectIdCommercialRetentionRouteImport.update({
    id: '/retention',
    path: '/retention',
    getParentRoute: () => AppProjectsProjectIdCommercialRoute,
  } as any)
const AppProjectsProjectIdCommercialSumsRoute =
  AppProjectsProjectIdCommercialSumsRouteImport.update({
    id: '/sums',
    path: '/sums',
    getParentRoute: () => AppProjectsProjectIdCommercialRoute,
  } as any)
const AppProjectsProjectIdCommercialVariationsRoute =
  AppProjectsProjectIdCommercialVariationsRouteImport.update({
    id: '/variations',
    path: '/variations',
    getParentRoute: () => AppProjectsProjectIdCommercialRoute,
  } as any)
const AppProjectsProjectIdCostIndexRoute =
  AppProjectsProjectIdCostIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProjectsProjectIdCostRoute,
  } as any)
const AppProjectsProjectIdCostExpensesRoute =
  AppProjectsProjectIdCostExpensesRouteImport.update({
    id: '/expenses',
    path: '/expenses',
    getParentRoute: () => AppProjectsProjectIdCostRoute,
  } as any)
const AppProjectsProjectIdCostMaterialsOnSiteRoute =
  AppProjectsProjectIdCostMaterialsOnSiteRouteImport.update({
    id: '/materials-on-site',
    path: '/materials-on-site',
    getParentRoute: () => AppProjectsProjectIdCostRoute,
  } as any)
const AppProjectsProjectIdCostOverviewRoute =
  AppProjectsProjectIdCostOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AppProjectsProjectIdCostRoute,
  } as any)
const AppProjectsProjectIdCostVariationsRoute =
  AppProjectsProjectIdCostVariationsRouteImport.update({
    id: '/variations',
    path: '/variations',
    getParentRoute: () => AppProjectsProjectIdCostRoute,
  } as any)
const AppProjectsProjectIdDecisionsIndexRoute =
  AppProjectsProjectIdDecisionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProjectsProjectIdDecisionsRoute,
  } as any)
const AppProjectsProjectIdDecisionsChangeRequestsRoute =
  AppProjectsProjectIdDecisionsChangeRequestsRouteImport.update({
    id: '/change-requests',
    path: '/change-requests',
    getParentRoute: () => AppProjectsProjectIdDecisionsRoute,
  } as any)
const AppProjectsProjectIdDecisionsSelectionsRoute =
  AppProjectsProjectIdDecisionsSelectionsRouteImport.update({
    id: '/selections',
    path: '/selections',
    getParentRoute: () => AppProjectsProjectIdDecisionsRoute,
  } as any)
const AppProjectsProjectIdDesignIndexRoute =
  AppProjectsProjectIdDesignIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProjectsProjectIdDesignRoute,
  } as any)
const AppProjectsProjectIdDesignCompareRoute =
  AppProjectsProjectIdDesignCompareRouteImport.update({
    id: '/compare',
    path: '/compare',
    getParentRoute: () => AppProjectsProjectIdDesignRoute,
  } as any)
const AppProjectsProjectIdDesignCompletionRoute =
  AppProjectsProjectIdDesignCompletionRouteImport.update({
    id: '/completion',
    path: '/completion',
    getParentRoute: () => AppProjectsProjectIdDesignRoute,
  } as any)
const AppProjectsProjectIdDesignCoordinationRoute =
  AppProjectsProjectIdDesignCoordinationRouteImport.update({
    id: '/coordination',
    path: '/coordination',
    getParentRoute: () => AppProjectsProjectIdDesignRoute,
  } as any)
const AppProjectsProjectIdDesignDeliverablesRoute =
  AppProjectsProjectIdDesignDeliverablesRouteImport.update({
    id: '/deliverables',
    path: '/deliverables',
    getParentRoute: () => AppProjectsProjectIdDesignRoute,
  } as any)
const AppProjectsProjectIdDesignDrawingsRoute =
  AppProjectsProjectIdDesignDrawingsRouteImport.update({
    id: '/drawings',
    path: '/drawings',
    getParentRoute: () => AppProjectsProjectIdDesignRoute,
  } as any)
const AppProjectsProjectIdDesignOverviewRoute =
  AppProjectsProjectIdDesignOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AppProjectsProjectIdDesignRoute,
  } as any)
const AppProjectsProjectIdDesignRfisRoute =
  AppProjectsProjectIdDesignRfisRouteImport.update({
    id: '/rfis',
    path: '/rfis',
    getParentRoute: () => AppProjectsProjectIdDesignRoute,
  } as any)
const AppProjectsProjectIdDesignSiteVisitsRoute =
  AppProjectsProjectIdDesignSiteVisitsRouteImport.update({
    id: '/site-visits',
    path: '/site-visits',
    getParentRoute: () => AppProjectsProjectIdDesignRoute,
  } as any)
const AppProjectsProjectIdDesignSpecificationsRoute =
  AppProjectsProjectIdDesignSpecificationsRouteImport.update({
    id: '/specifications',
    path: '/specifications',
    getParentRoute: () => AppProjectsProjectIdDesignRoute,
  } as any)
const AppProjectsProjectIdDesignSubmittalsRoute =
  AppProjectsProjectIdDesignSubmittalsRouteImport.update({
    id: '/submittals',
    path: '/submittals',
    getParentRoute: () => AppProjectsProjectIdDesignRoute,
  } as any)
const AppProjectsProjectIdDesignTransmittalsRoute =
  AppProjectsProjectIdDesignTransmittalsRouteImport.update({
    id: '/transmittals',
    path: '/transmittals',
    getParentRoute: () => AppProjectsProjectIdDesignRoute,
  } as any)
const AppProjectsProjectIdHiringIndexRoute =
  AppProjectsProjectIdHiringIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProjectsProjectIdHiringRoute,
  } as any)
const AppProjectsProjectIdInsightsIndexRoute =
  AppProjectsProjectIdInsightsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProjectsProjectIdInsightsRoute,
  } as any)
const AppProjectsProjectIdInsightsFlagsRoute =
  AppProjectsProjectIdInsightsFlagsRouteImport.update({
    id: '/flags',
    path: '/flags',
    getParentRoute: () => AppProjectsProjectIdInsightsRoute,
  } as any)
const AppProjectsProjectIdInsightsForecastRoute =
  AppProjectsProjectIdInsightsForecastRouteImport.update({
    id: '/forecast',
    path: '/forecast',
    getParentRoute: () => AppProjectsProjectIdInsightsRoute,
  } as any)
const AppProjectsProjectIdLabourEvidenceIndexRoute =
  AppProjectsProjectIdLabourEvidenceIndexRouteImport.update({
    id: '/labour-evidence/',
    path: '/labour-evidence/',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdLabourEvidenceTimesheetsRoute =
  AppProjectsProjectIdLabourEvidenceTimesheetsRouteImport.update({
    id: '/labour-evidence/timesheets',
    path: '/labour-evidence/timesheets',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdPlanIndexRoute =
  AppProjectsProjectIdPlanIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProjectsProjectIdPlanRoute,
  } as any)
const AppProjectsProjectIdPlanBaselinesRoute =
  AppProjectsProjectIdPlanBaselinesRouteImport.update({
    id: '/baselines',
    path: '/baselines',
    getParentRoute: () => AppProjectsProjectIdPlanRoute,
  } as any)
const AppProjectsProjectIdPlanConstraintsRoute =
  AppProjectsProjectIdPlanConstraintsRouteImport.update({
    id: '/constraints',
    path: '/constraints',
    getParentRoute: () => AppProjectsProjectIdPlanRoute,
  } as any)
const AppProjectsProjectIdPlanLookaheadRoute =
  AppProjectsProjectIdPlanLookaheadRouteImport.update({
    id: '/lookahead',
    path: '/lookahead',
    getParentRoute: () => AppProjectsProjectIdPlanRoute,
  } as any)
const AppProjectsProjectIdPlanMilestonesRoute =
  AppProjectsProjectIdPlanMilestonesRouteImport.update({
    id: '/milestones',
    path: '/milestones',
    getParentRoute: () => AppProjectsProjectIdPlanRoute,
  } as any)
const AppProjectsProjectIdPlanStagesRoute =
  AppProjectsProjectIdPlanStagesRouteImport.update({
    id: '/stages',
    path: '/stages',
    getParentRoute: () => AppProjectsProjectIdPlanRoute,
  } as any)
const AppProjectsProjectIdPlanTasksRoute =
  AppProjectsProjectIdPlanTasksRouteImport.update({
    id: '/tasks',
    path: '/tasks',
    getParentRoute: () => AppProjectsProjectIdPlanRoute,
  } as any)
const AppProjectsProjectIdPlanWeeklyPlansRoute =
  AppProjectsProjectIdPlanWeeklyPlansRouteImport.update({
    id: '/weekly-plans',
    path: '/weekly-plans',
    getParentRoute: () => AppProjectsProjectIdPlanRoute,
  } as any)
const AppProjectsProjectIdPlanZonesRoute =
  AppProjectsProjectIdPlanZonesRouteImport.update({
    id: '/zones',
    path: '/zones',
    getParentRoute: () => AppProjectsProjectIdPlanRoute,
  } as any)
const AppProjectsProjectIdProcurementIndexRoute =
  AppProjectsProjectIdProcurementIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProjectsProjectIdProcurementRoute,
  } as any)
const AppProjectsProjectIdProcurementCartRoute =
  AppProjectsProjectIdProcurementCartRouteImport.update({
    id: '/cart',
    path: '/cart',
    getParentRoute: () => AppProjectsProjectIdProcurementRoute,
  } as any)
const AppProjectsProjectIdProcurementDeliveriesRoute =
  AppProjectsProjectIdProcurementDeliveriesRouteImport.update({
    id: '/deliveries',
    path: '/deliveries',
    getParentRoute: () => AppProjectsProjectIdProcurementRoute,
  } as any)
const AppProjectsProjectIdProcurementInvoicesRoute =
  AppProjectsProjectIdProcurementInvoicesRouteImport.update({
    id: '/invoices',
    path: '/invoices',
    getParentRoute: () => AppProjectsProjectIdProcurementRoute,
  } as any)
const AppProjectsProjectIdProcurementRequisitionsRoute =
  AppProjectsProjectIdProcurementRequisitionsRouteImport.update({
    id: '/requisitions',
    path: '/requisitions',
    getParentRoute: () => AppProjectsProjectIdProcurementRoute,
  } as any)
const AppProjectsProjectIdQualityIndexRoute =
  AppProjectsProjectIdQualityIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProjectsProjectIdQualityRoute,
  } as any)
const AppProjectsProjectIdQualityChecklistsRoute =
  AppProjectsProjectIdQualityChecklistsRouteImport.update({
    id: '/checklists',
    path: '/checklists',
    getParentRoute: () => AppProjectsProjectIdQualityRoute,
  } as any)
const AppProjectsProjectIdQualityNcrsRoute =
  AppProjectsProjectIdQualityNcrsRouteImport.update({
    id: '/ncrs',
    path: '/ncrs',
    getParentRoute: () => AppProjectsProjectIdQualityRoute,
  } as any)
const AppProjectsProjectIdQualityRectificationsRoute =
  AppProjectsProjectIdQualityRectificationsRouteImport.update({
    id: '/rectifications',
    path: '/rectifications',
    getParentRoute: () => AppProjectsProjectIdQualityRoute,
  } as any)
const AppProjectsProjectIdQualitySnagsRoute =
  AppProjectsProjectIdQualitySnagsRouteImport.update({
    id: '/snags',
    path: '/snags',
    getParentRoute: () => AppProjectsProjectIdQualityRoute,
  } as any)
const AppProjectsProjectIdQualityTestsRoute =
  AppProjectsProjectIdQualityTestsRouteImport.update({
    id: '/tests',
    path: '/tests',
    getParentRoute: () => AppProjectsProjectIdQualityRoute,
  } as any)
const AppProjectsProjectIdReportsIndexRoute =
  AppProjectsProjectIdReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdReportsReportKeyRoute =
  AppProjectsProjectIdReportsReportKeyRouteImport.update({
    id: '/reports/$reportKey',
    path: '/reports/$reportKey',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdResourcesIndexRoute =
  AppProjectsProjectIdResourcesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProjectsProjectIdResourcesRoute,
  } as any)
const AppProjectsProjectIdResourcesEquipmentRoute =
  AppProjectsProjectIdResourcesEquipmentRouteImport.update({
    id: '/equipment',
    path: '/equipment',
    getParentRoute: () => AppProjectsProjectIdResourcesRoute,
  } as any)
const AppProjectsProjectIdResourcesEquipmentRequestsRoute =
  AppProjectsProjectIdResourcesEquipmentRequestsRouteImport.update({
    id: '/equipment-requests',
    path: '/equipment-requests',
    getParentRoute: () => AppProjectsProjectIdResourcesRoute,
  } as any)
const AppProjectsProjectIdResourcesRequestsRoute =
  AppProjectsProjectIdResourcesRequestsRouteImport.update({
    id: '/requests',
    path: '/requests',
    getParentRoute: () => AppProjectsProjectIdResourcesRoute,
  } as any)
const AppProjectsProjectIdResourcesStoreRoute =
  AppProjectsProjectIdResourcesStoreRouteImport.update({
    id: '/store',
    path: '/store',
    getParentRoute: () => AppProjectsProjectIdResourcesRoute,
  } as any)
const AppProjectsProjectIdResourcesSubmittalsRoute =
  AppProjectsProjectIdResourcesSubmittalsRouteImport.update({
    id: '/submittals',
    path: '/submittals',
    getParentRoute: () => AppProjectsProjectIdResourcesRoute,
  } as any)
const AppProjectsProjectIdSafetyIndexRoute =
  AppProjectsProjectIdSafetyIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProjectsProjectIdSafetyRoute,
  } as any)
const AppProjectsProjectIdSafetyIncidentsRoute =
  AppProjectsProjectIdSafetyIncidentsRouteImport.update({
    id: '/incidents',
    path: '/incidents',
    getParentRoute: () => AppProjectsProjectIdSafetyRoute,
  } as any)
const AppProjectsProjectIdSafetyOverviewRoute =
  AppProjectsProjectIdSafetyOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AppProjectsProjectIdSafetyRoute,
  } as any)
const AppProjectsProjectIdSafetyPpeRoute =
  AppProjectsProjectIdSafetyPpeRouteImport.update({
    id: '/ppe',
    path: '/ppe',
    getParentRoute: () => AppProjectsProjectIdSafetyRoute,
  } as any)
const AppProjectsProjectIdSafetyToolboxRoute =
  AppProjectsProjectIdSafetyToolboxRouteImport.update({
    id: '/toolbox',
    path: '/toolbox',
    getParentRoute: () => AppProjectsProjectIdSafetyRoute,
  } as any)
const AppProjectsProjectIdSiteIndexRoute =
  AppProjectsProjectIdSiteIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProjectsProjectIdSiteRoute,
  } as any)
const AppProjectsProjectIdSiteAttendanceRoute =
  AppProjectsProjectIdSiteAttendanceRouteImport.update({
    id: '/attendance',
    path: '/attendance',
    getParentRoute: () => AppProjectsProjectIdSiteRoute,
  } as any)
const AppProjectsProjectIdSiteDailyPlanRoute =
  AppProjectsProjectIdSiteDailyPlanRouteImport.update({
    id: '/daily-plan',
    path: '/daily-plan',
    getParentRoute: () => AppProjectsProjectIdSiteRoute,
  } as any)
const AppProjectsProjectIdSiteDayCloseRoute =
  AppProjectsProjectIdSiteDayCloseRouteImport.update({
    id: '/day-close',
    path: '/day-close',
    getParentRoute: () => AppProjectsProjectIdSiteRoute,
  } as any)
const AppProjectsProjectIdSiteDiaryRoute =
  AppProjectsProjectIdSiteDiaryRouteImport.update({
    id: '/diary',
    path: '/diary',
    getParentRoute: () => AppProjectsProjectIdSiteRoute,
  } as any)
const AppProjectsProjectIdSiteInstructionsRoute =
  AppProjectsProjectIdSiteInstructionsRouteImport.update({
    id: '/instructions',
    path: '/instructions',
    getParentRoute: () => AppProjectsProjectIdSiteRoute,
  } as any)
const AppProjectsProjectIdSiteIssuesRoute =
  AppProjectsProjectIdSiteIssuesRouteImport.update({
    id: '/issues',
    path: '/issues',
    getParentRoute: () => AppProjectsProjectIdSiteRoute,
  } as any)
const AppProjectsProjectIdSiteMeetingsRoute =
  AppProjectsProjectIdSiteMeetingsRouteImport.update({
    id: '/meetings',
    path: '/meetings',
    getParentRoute: () => AppProjectsProjectIdSiteRoute,
  } as any)
const AppProjectsProjectIdSitePhotosRoute =
  AppProjectsProjectIdSitePhotosRouteImport.update({
    id: '/photos',
    path: '/photos',
    getParentRoute: () => AppProjectsProjectIdSiteRoute,
  } as any)
const AppProjectsProjectIdSiteProgressRoute =
  AppProjectsProjectIdSiteProgressRouteImport.update({
    id: '/progress',
    path: '/progress',
    getParentRoute: () => AppProjectsProjectIdSiteRoute,
  } as any)
const AppProjectsProjectIdSiteTodayRoute =
  AppProjectsProjectIdSiteTodayRouteImport.update({
    id: '/today',
    path: '/today',
    getParentRoute: () => AppProjectsProjectIdSiteRoute,
  } as any)
const AppProjectsProjectIdSiteVisitorsRoute =
  AppProjectsProjectIdSiteVisitorsRouteImport.update({
    id: '/visitors',
    path: '/visitors',
    getParentRoute: () => AppProjectsProjectIdSiteRoute,
  } as any)
const AppProjectsProjectIdSubcontractsIndexRoute =
  AppProjectsProjectIdSubcontractsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProjectsProjectIdSubcontractsRoute,
  } as any)
const AppProjectsProjectIdSubcontractsChangesRoute =
  AppProjectsProjectIdSubcontractsChangesRouteImport.update({
    id: '/changes',
    path: '/changes',
    getParentRoute: () => AppProjectsProjectIdSubcontractsRoute,
  } as any)
const AppProjectsProjectIdSubcontractsConsentsRoute =
  AppProjectsProjectIdSubcontractsConsentsRouteImport.update({
    id: '/consents',
    path: '/consents',
    getParentRoute: () => AppProjectsProjectIdSubcontractsRoute,
  } as any)
const AppProjectsProjectIdSubcontractsDailyReportsRoute =
  AppProjectsProjectIdSubcontractsDailyReportsRouteImport.update({
    id: '/daily-reports',
    path: '/daily-reports',
    getParentRoute: () => AppProjectsProjectIdSubcontractsRoute,
  } as any)
const AppProjectsProjectIdSubcontractsOverviewRoute =
  AppProjectsProjectIdSubcontractsOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AppProjectsProjectIdSubcontractsRoute,
  } as any)
const AppProjectsProjectIdSubcontractsOwnStockRoute =
  AppProjectsProjectIdSubcontractsOwnStockRouteImport.update({
    id: '/own-stock',
    path: '/own-stock',
    getParentRoute: () => AppProjectsProjectIdSubcontractsRoute,
  } as any)
const AppProjectsProjectIdSubcontractsPaymentsRoute =
  AppProjectsProjectIdSubcontractsPaymentsRouteImport.update({
    id: '/payments',
    path: '/payments',
    getParentRoute: () => AppProjectsProjectIdSubcontractsRoute,
  } as any)
const AppProjectsProjectIdSubcontractsPurchasesRoute =
  AppProjectsProjectIdSubcontractsPurchasesRouteImport.update({
    id: '/purchases',
    path: '/purchases',
    getParentRoute: () => AppProjectsProjectIdSubcontractsRoute,
  } as any)
const AppProjectsProjectIdTendersIndexRoute =
  AppProjectsProjectIdTendersIndexRouteImport.update({
    id: '/tenders/',
    path: '/tenders/',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdTendersPackageIdRoute =
  AppProjectsProjectIdTendersPackageIdRouteImport.update({
    id: '/tenders/$packageId',
    path: '/tenders/$packageId',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdTimelineIndexRoute =
  AppProjectsProjectIdTimelineIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProjectsProjectIdTimelineRoute,
  } as any)
const AppProjectsProjectIdTimelineActivityRoute =
  AppProjectsProjectIdTimelineActivityRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => AppProjectsProjectIdTimelineRoute,
  } as any)
const AppProjectsProjectIdTimelinePhotosRoute =
  AppProjectsProjectIdTimelinePhotosRouteImport.update({
    id: '/photos',
    path: '/photos',
    getParentRoute: () => AppProjectsProjectIdTimelineRoute,
  } as any)
const AppProjectsProjectIdWorkforceIndexRoute =
  AppProjectsProjectIdWorkforceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProjectsProjectIdWorkforceRoute,
  } as any)
const AppProjectsProjectIdWorkforceCrewsRoute =
  AppProjectsProjectIdWorkforceCrewsRouteImport.update({
    id: '/crews',
    path: '/crews',
    getParentRoute: () => AppProjectsProjectIdWorkforceRoute,
  } as any)
const AppProjectsProjectIdWorkforceProductivityRoute =
  AppProjectsProjectIdWorkforceProductivityRouteImport.update({
    id: '/productivity',
    path: '/productivity',
    getParentRoute: () => AppProjectsProjectIdWorkforceRoute,
  } as any)
const AppProjectsProjectIdWorkforceTimesheetsRoute =
  AppProjectsProjectIdWorkforceTimesheetsRouteImport.update({
    id: '/timesheets',
    path: '/timesheets',
    getParentRoute: () => AppProjectsProjectIdWorkforceRoute,
  } as any)
const AppSupplierOrgIdCustomersIndexRoute =
  AppSupplierOrgIdCustomersIndexRouteImport.update({
    id: '/customers/',
    path: '/customers/',
    getParentRoute: () => AppSupplierOrgIdRoute,
  } as any)
const AppSupplierOrgIdCustomersCustomerIdRoute =
  AppSupplierOrgIdCustomersCustomerIdRouteImport.update({
    id: '/customers/$customerId',
    path: '/customers/$customerId',
    getParentRoute: () => AppSupplierOrgIdRoute,
  } as any)
const AppSupplierOrgIdMessagesIndexRoute =
  AppSupplierOrgIdMessagesIndexRouteImport.update({
    id: '/messages/',
    path: '/messages/',
    getParentRoute: () => AppSupplierOrgIdRoute,
  } as any)
const AppSupplierOrgIdMessagesConversationIdRoute =
  AppSupplierOrgIdMessagesConversationIdRouteImport.update({
    id: '/messages/$conversationId',
    path: '/messages/$conversationId',
    getParentRoute: () => AppSupplierOrgIdRoute,
  } as any)
const AppSupplierOrgIdOrdersIndexRoute =
  AppSupplierOrgIdOrdersIndexRouteImport.update({
    id: '/orders/',
    path: '/orders/',
    getParentRoute: () => AppSupplierOrgIdRoute,
  } as any)
const AppSupplierOrgIdOrdersPoIdRoute =
  AppSupplierOrgIdOrdersPoIdRouteImport.update({
    id: '/orders/$poId',
    path: '/orders/$poId',
    getParentRoute: () => AppSupplierOrgIdRoute,
  } as any)
const AppSupplierOrgIdRfqsIndexRoute =
  AppSupplierOrgIdRfqsIndexRouteImport.update({
    id: '/rfqs/',
    path: '/rfqs/',
    getParentRoute: () => AppSupplierOrgIdRoute,
  } as any)
const AppSupplierOrgIdRfqsRfqIdRoute =
  AppSupplierOrgIdRfqsRfqIdRouteImport.update({
    id: '/rfqs/$rfqId',
    path: '/rfqs/$rfqId',
    getParentRoute: () => AppSupplierOrgIdRoute,
  } as any)
const PrintOrgOrgIdReportsReportKeyRoute =
  PrintOrgOrgIdReportsReportKeyRouteImport.update({
    id: '/print/org/$orgId/reports/$reportKey',
    path: '/print/org/$orgId/reports/$reportKey',
    getParentRoute: () => rootRouteImport,
  } as any)
const PrintProjectsProjectIdCertificatesCertificateIdRoute =
  PrintProjectsProjectIdCertificatesCertificateIdRouteImport.update({
    id: '/print/projects/$projectId/certificates/$certificateId',
    path: '/print/projects/$projectId/certificates/$certificateId',
    getParentRoute: () => rootRouteImport,
  } as any)
const PrintProjectsProjectIdReportsReportKeyRoute =
  PrintProjectsProjectIdReportsReportKeyRouteImport.update({
    id: '/print/projects/$projectId/reports/$reportKey',
    path: '/print/projects/$projectId/reports/$reportKey',
    getParentRoute: () => rootRouteImport,
  } as any)
const PrintProjectsProjectIdSiteVisitsVisitIdRoute =
  PrintProjectsProjectIdSiteVisitsVisitIdRouteImport.update({
    id: '/print/projects/$projectId/site-visits/$visitId',
    path: '/print/projects/$projectId/site-visits/$visitId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppLandSellOrgIdListingsListingIdRoute =
  AppLandSellOrgIdListingsListingIdRouteImport.update({
    id: '/land/sell/$orgId/listings/$listingId',
    path: '/land/sell/$orgId/listings/$listingId',
    getParentRoute: () => AppRoute,
  } as any)
const AppProjectsProjectIdCommercialMeasureValuationIdRoute =
  AppProjectsProjectIdCommercialMeasureValuationIdRouteImport.update({
    id: '/measure/$valuationId',
    path: '/measure/$valuationId',
    getParentRoute: () => AppProjectsProjectIdCommercialRoute,
  } as any)
const AppProjectsProjectIdCommercialValuationsIndexRoute =
  AppProjectsProjectIdCommercialValuationsIndexRouteImport.update({
    id: '/valuations/',
    path: '/valuations/',
    getParentRoute: () => AppProjectsProjectIdCommercialRoute,
  } as any)
const AppProjectsProjectIdCommercialValuationsValuationIdRoute =
  AppProjectsProjectIdCommercialValuationsValuationIdRouteImport.update({
    id: '/valuations/$valuationId',
    path: '/valuations/$valuationId',
    getParentRoute: () => AppProjectsProjectIdCommercialRoute,
  } as any)
const AppProjectsProjectIdCostBoqIndexRoute =
  AppProjectsProjectIdCostBoqIndexRouteImport.update({
    id: '/boq/',
    path: '/boq/',
    getParentRoute: () => AppProjectsProjectIdCostRoute,
  } as any)
const AppProjectsProjectIdCostBoqBoqIdRoute =
  AppProjectsProjectIdCostBoqBoqIdRouteImport.update({
    id: '/boq/$boqId',
    path: '/boq/$boqId',
    getParentRoute: () => AppProjectsProjectIdCostRoute,
  } as any)
const AppProjectsProjectIdCostScansIndexRoute =
  AppProjectsProjectIdCostScansIndexRouteImport.update({
    id: '/scans/',
    path: '/scans/',
    getParentRoute: () => AppProjectsProjectIdCostRoute,
  } as any)
const AppProjectsProjectIdCostScansExtractionIdRoute =
  AppProjectsProjectIdCostScansExtractionIdRouteImport.update({
    id: '/scans/$extractionId',
    path: '/scans/$extractionId',
    getParentRoute: () => AppProjectsProjectIdCostRoute,
  } as any)
const AppProjectsProjectIdHiringJobsIndexRoute =
  AppProjectsProjectIdHiringJobsIndexRouteImport.update({
    id: '/jobs/',
    path: '/jobs/',
    getParentRoute: () => AppProjectsProjectIdHiringRoute,
  } as any)
const AppProjectsProjectIdHiringJobsJobIdRoute =
  AppProjectsProjectIdHiringJobsJobIdRouteImport.update({
    id: '/jobs/$jobId',
    path: '/jobs/$jobId',
    getParentRoute: () => AppProjectsProjectIdHiringRoute,
  } as any)
const AppProjectsProjectIdHiringOpeningsIndexRoute =
  AppProjectsProjectIdHiringOpeningsIndexRouteImport.update({
    id: '/openings/',
    path: '/openings/',
    getParentRoute: () => AppProjectsProjectIdHiringRoute,
  } as any)
const AppProjectsProjectIdHiringOpeningsOpeningIdRoute =
  AppProjectsProjectIdHiringOpeningsOpeningIdRouteImport.update({
    id: '/openings/$openingId',
    path: '/openings/$openingId',
    getParentRoute: () => AppProjectsProjectIdHiringRoute,
  } as any)
const AppProjectsProjectIdHiringQuotesIndexRoute =
  AppProjectsProjectIdHiringQuotesIndexRouteImport.update({
    id: '/quotes/',
    path: '/quotes/',
    getParentRoute: () => AppProjectsProjectIdHiringRoute,
  } as any)
const AppProjectsProjectIdHiringQuotesQuoteIdRoute =
  AppProjectsProjectIdHiringQuotesQuoteIdRouteImport.update({
    id: '/quotes/$quoteId',
    path: '/quotes/$quoteId',
    getParentRoute: () => AppProjectsProjectIdHiringRoute,
  } as any)
const AppProjectsProjectIdInsightsWeeklyIndexRoute =
  AppProjectsProjectIdInsightsWeeklyIndexRouteImport.update({
    id: '/weekly/',
    path: '/weekly/',
    getParentRoute: () => AppProjectsProjectIdInsightsRoute,
  } as any)
const AppProjectsProjectIdInsightsWeeklySummaryIdRoute =
  AppProjectsProjectIdInsightsWeeklySummaryIdRouteImport.update({
    id: '/weekly/$summaryId',
    path: '/weekly/$summaryId',
    getParentRoute: () => AppProjectsProjectIdInsightsRoute,
  } as any)
const AppProjectsProjectIdLabourEvidencePayrollIndexRoute =
  AppProjectsProjectIdLabourEvidencePayrollIndexRouteImport.update({
    id: '/labour-evidence/payroll/',
    path: '/labour-evidence/payroll/',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdLabourEvidencePayrollRunIdRoute =
  AppProjectsProjectIdLabourEvidencePayrollRunIdRouteImport.update({
    id: '/labour-evidence/payroll/$runId',
    path: '/labour-evidence/payroll/$runId',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdProcurementOrdersIndexRoute =
  AppProjectsProjectIdProcurementOrdersIndexRouteImport.update({
    id: '/orders/',
    path: '/orders/',
    getParentRoute: () => AppProjectsProjectIdProcurementRoute,
  } as any)
const AppProjectsProjectIdProcurementOrdersPoIdRoute =
  AppProjectsProjectIdProcurementOrdersPoIdRouteImport.update({
    id: '/orders/$poId',
    path: '/orders/$poId',
    getParentRoute: () => AppProjectsProjectIdProcurementRoute,
  } as any)
const AppProjectsProjectIdProcurementRfqsIndexRoute =
  AppProjectsProjectIdProcurementRfqsIndexRouteImport.update({
    id: '/rfqs/',
    path: '/rfqs/',
    getParentRoute: () => AppProjectsProjectIdProcurementRoute,
  } as any)
const AppProjectsProjectIdProcurementRfqsRfqIdRoute =
  AppProjectsProjectIdProcurementRfqsRfqIdRouteImport.update({
    id: '/rfqs/$rfqId',
    path: '/rfqs/$rfqId',
    getParentRoute: () => AppProjectsProjectIdProcurementRoute,
  } as any)
const AppProjectsProjectIdProcurementShopIndexRoute =
  AppProjectsProjectIdProcurementShopIndexRouteImport.update({
    id: '/shop/',
    path: '/shop/',
    getParentRoute: () => AppProjectsProjectIdProcurementRoute,
  } as any)
const AppProjectsProjectIdProcurementShopOrgIdRoute =
  AppProjectsProjectIdProcurementShopOrgIdRouteImport.update({
    id: '/shop/$orgId',
    path: '/shop/$orgId',
    getParentRoute: () => AppProjectsProjectIdProcurementRoute,
  } as any)
const AppProjectsProjectIdQualityInspectionsIndexRoute =
  AppProjectsProjectIdQualityInspectionsIndexRouteImport.update({
    id: '/inspections/',
    path: '/inspections/',
    getParentRoute: () => AppProjectsProjectIdQualityRoute,
  } as any)
const AppProjectsProjectIdQualityInspectionsInspectionIdRoute =
  AppProjectsProjectIdQualityInspectionsInspectionIdRouteImport.update({
    id: '/inspections/$inspectionId',
    path: '/inspections/$inspectionId',
    getParentRoute: () => AppProjectsProjectIdQualityRoute,
  } as any)
const AppProjectsProjectIdSafetyWalksIndexRoute =
  AppProjectsProjectIdSafetyWalksIndexRouteImport.update({
    id: '/walks/',
    path: '/walks/',
    getParentRoute: () => AppProjectsProjectIdSafetyRoute,
  } as any)
const AppProjectsProjectIdSafetyWalksInspectionIdRoute =
  AppProjectsProjectIdSafetyWalksInspectionIdRouteImport.update({
    id: '/walks/$inspectionId',
    path: '/walks/$inspectionId',
    getParentRoute: () => AppProjectsProjectIdSafetyRoute,
  } as any)
const AppProjectsProjectIdSubcontractsContractsSubcontractIdRoute =
  AppProjectsProjectIdSubcontractsContractsSubcontractIdRouteImport.update({
    id: '/contracts/$subcontractId',
    path: '/contracts/$subcontractId',
    getParentRoute: () => AppProjectsProjectIdSubcontractsRoute,
  } as any)
const AppProjectsProjectIdSubcontractsPackagesIndexRoute =
  AppProjectsProjectIdSubcontractsPackagesIndexRouteImport.update({
    id: '/packages/',
    path: '/packages/',
    getParentRoute: () => AppProjectsProjectIdSubcontractsRoute,
  } as any)
const AppProjectsProjectIdSubcontractsPackagesPackageIdRoute =
  AppProjectsProjectIdSubcontractsPackagesPackageIdRouteImport.update({
    id: '/packages/$packageId',
    path: '/packages/$packageId',
    getParentRoute: () => AppProjectsProjectIdSubcontractsRoute,
  } as any)
const AppProjectsProjectIdWorkforceCrewIndexRoute =
  AppProjectsProjectIdWorkforceCrewIndexRouteImport.update({
    id: '/crew/',
    path: '/crew/',
    getParentRoute: () => AppProjectsProjectIdWorkforceRoute,
  } as any)
const AppProjectsProjectIdWorkforceCrewEngagementIdRoute =
  AppProjectsProjectIdWorkforceCrewEngagementIdRouteImport.update({
    id: '/crew/$engagementId',
    path: '/crew/$engagementId',
    getParentRoute: () => AppProjectsProjectIdWorkforceRoute,
  } as any)
const AppProjectsProjectIdWorkforcePayrollIndexRoute =
  AppProjectsProjectIdWorkforcePayrollIndexRouteImport.update({
    id: '/payroll/',
    path: '/payroll/',
    getParentRoute: () => AppProjectsProjectIdWorkforceRoute,
  } as any)
const AppProjectsProjectIdWorkforcePayrollRunIdRoute =
  AppProjectsProjectIdWorkforcePayrollRunIdRouteImport.update({
    id: '/payroll/$runId',
    path: '/payroll/$runId',
    getParentRoute: () => AppProjectsProjectIdWorkforceRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/signed-out': typeof SignedOutRoute
  '/signin': typeof SigninRoute
  '/view-as': typeof ViewAsRoute
  '/account': typeof AppAccountRouteWithChildren
  '/admin': typeof AppAdminRoute
  '/approvals': typeof AppApprovalsRoute
  '/companies': typeof AppCompaniesRoute
  '/directory': typeof AppDirectoryRoute
  '/home': typeof AppHomeRoute
  '/me': typeof AppMeRouteWithChildren
  '/notifications': typeof AppNotificationsRoute
  '/orders': typeof AppOrdersRoute
  '/portfolio': typeof AppPortfolioRoute
  '/profile': typeof AppProfileRoute
  '/settings': typeof AppSettingsRoute
  '/support': typeof AppSupportRoute
  '/sync': typeof AppSyncRoute
  '/auth/admin-signin': typeof AuthAdminSigninRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/c/$slug': typeof CSlugRoute
  '/invitations/accept': typeof InvitationsAcceptRoute
  '/p/$slug': typeof PSlugRoute
  '/tenders/accept': typeof TendersAcceptRoute
  '/account/accounting': typeof AppAccountAccountingRoute
  '/account/approval-rules': typeof AppAccountApprovalRulesRoute
  '/account/shortlist': typeof AppAccountShortlistRoute
  '/billing/return': typeof AppBillingReturnRoute
  '/land/$listingId': typeof AppLandListingIdRoute
  '/land/enquiries': typeof AppLandEnquiriesRoute
  '/marketplace/labour-rates': typeof AppMarketplaceLabourRatesRoute
  '/marketplace/professionals': typeof AppMarketplaceProfessionalsRoute
  '/me/attendance': typeof AppMeAttendanceRoute
  '/me/earnings': typeof AppMeEarningsRoute
  '/me/profile': typeof AppMeProfileRoute
  '/messages/$conversationId': typeof AppMessagesConversationIdRoute
  '/onboarding/$flow': typeof AppOnboardingFlowRoute
  '/org/$orgId': typeof AppOrgOrgIdRouteWithChildren
  '/org/new': typeof AppOrgNewRoute
  '/projects/$projectId': typeof AppProjectsProjectIdRouteWithChildren
  '/projects/new': typeof AppProjectsNewRoute
  '/supplier/$orgId': typeof AppSupplierOrgIdRouteWithChildren
  '/supplier/register': typeof AppSupplierRegisterRoute
  '/organizations/invitations/accept': typeof OrganizationsInvitationsAcceptRoute
  '/land/': typeof AppLandIndexRoute
  '/marketplace/': typeof AppMarketplaceIndexRoute
  '/me/': typeof AppMeIndexRoute
  '/messages/': typeof AppMessagesIndexRoute
  '/onboarding/': typeof AppOnboardingIndexRoute
  '/projects/': typeof AppProjectsIndexRoute
  '/marketplace/prices/$productId': typeof AppMarketplacePricesProductIdRoute
  '/marketplace/suppliers/$orgId': typeof AppMarketplaceSuppliersOrgIdRoute
  '/marketplace/workers/$workerId': typeof AppMarketplaceWorkersWorkerIdRoute
  '/marketplace/workers/requests': typeof AppMarketplaceWorkersRequestsRoute
  '/me/services/applications': typeof AppMeServicesApplicationsRoute
  '/me/services/invitations': typeof AppMeServicesInvitationsRoute
  '/me/services/openings': typeof AppMeServicesOpeningsRoute
  '/me/work/certificates': typeof AppMeWorkCertificatesRoute
  '/me/work/jobs': typeof AppMeWorkJobsRoute
  '/me/work/listing': typeof AppMeWorkListingRoute
  '/me/work/requests': typeof AppMeWorkRequestsRoute
  '/me/work/reviews': typeof AppMeWorkReviewsRoute
  '/org/$orgId/approval-rules': typeof AppOrgOrgIdApprovalRulesRoute
  '/org/$orgId/audit': typeof AppOrgOrgIdAuditRoute
  '/org/$orgId/billing': typeof AppOrgOrgIdBillingRoute
  '/org/$orgId/clients': typeof AppOrgOrgIdClientsRoute
  '/org/$orgId/fees': typeof AppOrgOrgIdFeesRoute
  '/org/$orgId/integrations': typeof AppOrgOrgIdIntegrationsRoute
  '/org/$orgId/jobs': typeof AppOrgOrgIdJobsRoute
  '/org/$orgId/members': typeof AppOrgOrgIdMembersRoute
  '/org/$orgId/overview': typeof AppOrgOrgIdOverviewRoute
  '/org/$orgId/portfolio': typeof AppOrgOrgIdPortfolioRoute
  '/org/$orgId/profile': typeof AppOrgOrgIdProfileRoute
  '/org/$orgId/projects': typeof AppOrgOrgIdProjectsRoute
  '/org/$orgId/roles': typeof AppOrgOrgIdRolesRoute
  '/org/$orgId/settings': typeof AppOrgOrgIdSettingsRoute
  '/org/$orgId/shortlist': typeof AppOrgOrgIdShortlistRoute
  '/org/$orgId/templates': typeof AppOrgOrgIdTemplatesRoute
  '/org/$orgId/workload': typeof AppOrgOrgIdWorkloadRoute
  '/projects/$projectId/closeout': typeof AppProjectsProjectIdCloseoutRouteWithChildren
  '/projects/$projectId/commercial': typeof AppProjectsProjectIdCommercialRouteWithChildren
  '/projects/$projectId/cost': typeof AppProjectsProjectIdCostRouteWithChildren
  '/projects/$projectId/decisions': typeof AppProjectsProjectIdDecisionsRouteWithChildren
  '/projects/$projectId/design': typeof AppProjectsProjectIdDesignRouteWithChildren
  '/projects/$projectId/documents': typeof AppProjectsProjectIdDocumentsRoute
  '/projects/$projectId/handover': typeof AppProjectsProjectIdHandoverRoute
  '/projects/$projectId/hiring': typeof AppProjectsProjectIdHiringRouteWithChildren
  '/projects/$projectId/insights': typeof AppProjectsProjectIdInsightsRouteWithChildren
  '/projects/$projectId/overview': typeof AppProjectsProjectIdOverviewRoute
  '/projects/$projectId/owner-plan': typeof AppProjectsProjectIdOwnerPlanRoute
  '/projects/$projectId/plan': typeof AppProjectsProjectIdPlanRouteWithChildren
  '/projects/$projectId/procurement': typeof AppProjectsProjectIdProcurementRouteWithChildren
  '/projects/$projectId/quality': typeof AppProjectsProjectIdQualityRouteWithChildren
  '/projects/$projectId/resources': typeof AppProjectsProjectIdResourcesRouteWithChildren
  '/projects/$projectId/risks': typeof AppProjectsProjectIdRisksRoute
  '/projects/$projectId/safety': typeof AppProjectsProjectIdSafetyRouteWithChildren
  '/projects/$projectId/settings': typeof AppProjectsProjectIdSettingsRoute
  '/projects/$projectId/site': typeof AppProjectsProjectIdSiteRouteWithChildren
  '/projects/$projectId/subcontracts': typeof AppProjectsProjectIdSubcontractsRouteWithChildren
  '/projects/$projectId/team': typeof AppProjectsProjectIdTeamRoute
  '/projects/$projectId/timeline': typeof AppProjectsProjectIdTimelineRouteWithChildren
  '/projects/$projectId/workforce': typeof AppProjectsProjectIdWorkforceRouteWithChildren
  '/supplier/$orgId/analytics': typeof AppSupplierOrgIdAnalyticsRoute
  '/supplier/$orgId/billing': typeof AppSupplierOrgIdBillingRoute
  '/supplier/$orgId/branches': typeof AppSupplierOrgIdBranchesRoute
  '/supplier/$orgId/catalog': typeof AppSupplierOrgIdCatalogRoute
  '/supplier/$orgId/dashboard': typeof AppSupplierOrgIdDashboardRoute
  '/supplier/$orgId/deliveries': typeof AppSupplierOrgIdDeliveriesRoute
  '/supplier/$orgId/invoices': typeof AppSupplierOrgIdInvoicesRoute
  '/supplier/$orgId/notifications': typeof AppSupplierOrgIdNotificationsRoute
  '/supplier/$orgId/payments': typeof AppSupplierOrgIdPaymentsRoute
  '/supplier/$orgId/profile': typeof AppSupplierOrgIdProfileRoute
  '/supplier/$orgId/public': typeof AppSupplierOrgIdPublicRoute
  '/supplier/$orgId/quotes': typeof AppSupplierOrgIdQuotesRoute
  '/supplier/$orgId/team': typeof AppSupplierOrgIdTeamRoute
  '/land/sell/': typeof AppLandSellIndexRoute
  '/marketplace/prices/': typeof AppMarketplacePricesIndexRoute
  '/marketplace/suppliers/': typeof AppMarketplaceSuppliersIndexRoute
  '/marketplace/workers/': typeof AppMarketplaceWorkersIndexRoute
  '/me/services/': typeof AppMeServicesIndexRoute
  '/me/work/': typeof AppMeWorkIndexRoute
  '/org/$orgId/': typeof AppOrgOrgIdIndexRoute
  '/projects/$projectId/': typeof AppProjectsProjectIdIndexRoute
  '/supplier/$orgId/': typeof AppSupplierOrgIdIndexRoute
  '/me/services/jobs/$jobId': typeof AppMeServicesJobsJobIdRoute
  '/me/services/quotes/$responseId': typeof AppMeServicesQuotesResponseIdRoute
  '/me/services/tenders/$packageId': typeof AppMeServicesTendersPackageIdRoute
  '/org/$orgId/reports/$reportKey': typeof AppOrgOrgIdReportsReportKeyRoute
  '/org/$orgId/tenders/$packageId': typeof AppOrgOrgIdTendersPackageIdRoute
  '/projects/$projectId/closeout/overview': typeof AppProjectsProjectIdCloseoutOverviewRoute
  '/projects/$projectId/closeout/warranty': typeof AppProjectsProjectIdCloseoutWarrantyRoute
  '/projects/$projectId/commercial/certificates': typeof AppProjectsProjectIdCommercialCertificatesRoute
  '/projects/$projectId/commercial/claims': typeof AppProjectsProjectIdCommercialClaimsRoute
  '/projects/$projectId/commercial/contract': typeof AppProjectsProjectIdCommercialContractRoute
  '/projects/$projectId/commercial/cost-control': typeof AppProjectsProjectIdCommercialCostControlRoute
  '/projects/$projectId/commercial/cost-plans': typeof AppProjectsProjectIdCommercialCostPlansRoute
  '/projects/$projectId/commercial/final-account': typeof AppProjectsProjectIdCommercialFinalAccountRoute
  '/projects/$projectId/commercial/overview': typeof AppProjectsProjectIdCommercialOverviewRoute
  '/projects/$projectId/commercial/payments': typeof AppProjectsProjectIdCommercialPaymentsRoute
  '/projects/$projectId/commercial/retention': typeof AppProjectsProjectIdCommercialRetentionRoute
  '/projects/$projectId/commercial/sums': typeof AppProjectsProjectIdCommercialSumsRoute
  '/projects/$projectId/commercial/variations': typeof AppProjectsProjectIdCommercialVariationsRoute
  '/projects/$projectId/cost/expenses': typeof AppProjectsProjectIdCostExpensesRoute
  '/projects/$projectId/cost/materials-on-site': typeof AppProjectsProjectIdCostMaterialsOnSiteRoute
  '/projects/$projectId/cost/overview': typeof AppProjectsProjectIdCostOverviewRoute
  '/projects/$projectId/cost/variations': typeof AppProjectsProjectIdCostVariationsRoute
  '/projects/$projectId/decisions/change-requests': typeof AppProjectsProjectIdDecisionsChangeRequestsRoute
  '/projects/$projectId/decisions/selections': typeof AppProjectsProjectIdDecisionsSelectionsRoute
  '/projects/$projectId/design/compare': typeof AppProjectsProjectIdDesignCompareRoute
  '/projects/$projectId/design/completion': typeof AppProjectsProjectIdDesignCompletionRoute
  '/projects/$projectId/design/coordination': typeof AppProjectsProjectIdDesignCoordinationRoute
  '/projects/$projectId/design/deliverables': typeof AppProjectsProjectIdDesignDeliverablesRoute
  '/projects/$projectId/design/drawings': typeof AppProjectsProjectIdDesignDrawingsRoute
  '/projects/$projectId/design/overview': typeof AppProjectsProjectIdDesignOverviewRoute
  '/projects/$projectId/design/rfis': typeof AppProjectsProjectIdDesignRfisRoute
  '/projects/$projectId/design/site-visits': typeof AppProjectsProjectIdDesignSiteVisitsRoute
  '/projects/$projectId/design/specifications': typeof AppProjectsProjectIdDesignSpecificationsRoute
  '/projects/$projectId/design/submittals': typeof AppProjectsProjectIdDesignSubmittalsRoute
  '/projects/$projectId/design/transmittals': typeof AppProjectsProjectIdDesignTransmittalsRoute
  '/projects/$projectId/insights/flags': typeof AppProjectsProjectIdInsightsFlagsRoute
  '/projects/$projectId/insights/forecast': typeof AppProjectsProjectIdInsightsForecastRoute
  '/projects/$projectId/labour-evidence/timesheets': typeof AppProjectsProjectIdLabourEvidenceTimesheetsRoute
  '/projects/$projectId/plan/baselines': typeof AppProjectsProjectIdPlanBaselinesRoute
  '/projects/$projectId/plan/constraints': typeof AppProjectsProjectIdPlanConstraintsRoute
  '/projects/$projectId/plan/lookahead': typeof AppProjectsProjectIdPlanLookaheadRoute
  '/projects/$projectId/plan/milestones': typeof AppProjectsProjectIdPlanMilestonesRoute
  '/projects/$projectId/plan/stages': typeof AppProjectsProjectIdPlanStagesRoute
  '/projects/$projectId/plan/tasks': typeof AppProjectsProjectIdPlanTasksRoute
  '/projects/$projectId/plan/weekly-plans': typeof AppProjectsProjectIdPlanWeeklyPlansRoute
  '/projects/$projectId/plan/zones': typeof AppProjectsProjectIdPlanZonesRoute
  '/projects/$projectId/procurement/cart': typeof AppProjectsProjectIdProcurementCartRoute
  '/projects/$projectId/procurement/deliveries': typeof AppProjectsProjectIdProcurementDeliveriesRoute
  '/projects/$projectId/procurement/invoices': typeof AppProjectsProjectIdProcurementInvoicesRoute
  '/projects/$projectId/procurement/requisitions': typeof AppProjectsProjectIdProcurementRequisitionsRoute
  '/projects/$projectId/quality/checklists': typeof AppProjectsProjectIdQualityChecklistsRoute
  '/projects/$projectId/quality/ncrs': typeof AppProjectsProjectIdQualityNcrsRoute
  '/projects/$projectId/quality/rectifications': typeof AppProjectsProjectIdQualityRectificationsRoute
  '/projects/$projectId/quality/snags': typeof AppProjectsProjectIdQualitySnagsRoute
  '/projects/$projectId/quality/tests': typeof AppProjectsProjectIdQualityTestsRoute
  '/projects/$projectId/reports/$reportKey': typeof AppProjectsProjectIdReportsReportKeyRoute
  '/projects/$projectId/resources/equipment': typeof AppProjectsProjectIdResourcesEquipmentRoute
  '/projects/$projectId/resources/equipment-requests': typeof AppProjectsProjectIdResourcesEquipmentRequestsRoute
  '/projects/$projectId/resources/requests': typeof AppProjectsProjectIdResourcesRequestsRoute
  '/projects/$projectId/resources/store': typeof AppProjectsProjectIdResourcesStoreRoute
  '/projects/$projectId/resources/submittals': typeof AppProjectsProjectIdResourcesSubmittalsRoute
  '/projects/$projectId/safety/incidents': typeof AppProjectsProjectIdSafetyIncidentsRoute
  '/projects/$projectId/safety/overview': typeof AppProjectsProjectIdSafetyOverviewRoute
  '/projects/$projectId/safety/ppe': typeof AppProjectsProjectIdSafetyPpeRoute
  '/projects/$projectId/safety/toolbox': typeof AppProjectsProjectIdSafetyToolboxRoute
  '/projects/$projectId/site/attendance': typeof AppProjectsProjectIdSiteAttendanceRoute
  '/projects/$projectId/site/daily-plan': typeof AppProjectsProjectIdSiteDailyPlanRoute
  '/projects/$projectId/site/day-close': typeof AppProjectsProjectIdSiteDayCloseRoute
  '/projects/$projectId/site/diary': typeof AppProjectsProjectIdSiteDiaryRoute
  '/projects/$projectId/site/instructions': typeof AppProjectsProjectIdSiteInstructionsRoute
  '/projects/$projectId/site/issues': typeof AppProjectsProjectIdSiteIssuesRoute
  '/projects/$projectId/site/meetings': typeof AppProjectsProjectIdSiteMeetingsRoute
  '/projects/$projectId/site/photos': typeof AppProjectsProjectIdSitePhotosRoute
  '/projects/$projectId/site/progress': typeof AppProjectsProjectIdSiteProgressRoute
  '/projects/$projectId/site/today': typeof AppProjectsProjectIdSiteTodayRoute
  '/projects/$projectId/site/visitors': typeof AppProjectsProjectIdSiteVisitorsRoute
  '/projects/$projectId/subcontracts/changes': typeof AppProjectsProjectIdSubcontractsChangesRoute
  '/projects/$projectId/subcontracts/consents': typeof AppProjectsProjectIdSubcontractsConsentsRoute
  '/projects/$projectId/subcontracts/daily-reports': typeof AppProjectsProjectIdSubcontractsDailyReportsRoute
  '/projects/$projectId/subcontracts/overview': typeof AppProjectsProjectIdSubcontractsOverviewRoute
  '/projects/$projectId/subcontracts/own-stock': typeof AppProjectsProjectIdSubcontractsOwnStockRoute
  '/projects/$projectId/subcontracts/payments': typeof AppProjectsProjectIdSubcontractsPaymentsRoute
  '/projects/$projectId/subcontracts/purchases': typeof AppProjectsProjectIdSubcontractsPurchasesRoute
  '/projects/$projectId/tenders/$packageId': typeof AppProjectsProjectIdTendersPackageIdRoute
  '/projects/$projectId/timeline/activity': typeof AppProjectsProjectIdTimelineActivityRoute
  '/projects/$projectId/timeline/photos': typeof AppProjectsProjectIdTimelinePhotosRoute
  '/projects/$projectId/workforce/crews': typeof AppProjectsProjectIdWorkforceCrewsRoute
  '/projects/$projectId/workforce/productivity': typeof AppProjectsProjectIdWorkforceProductivityRoute
  '/projects/$projectId/workforce/timesheets': typeof AppProjectsProjectIdWorkforceTimesheetsRoute
  '/supplier/$orgId/customers/$customerId': typeof AppSupplierOrgIdCustomersCustomerIdRoute
  '/supplier/$orgId/messages/$conversationId': typeof AppSupplierOrgIdMessagesConversationIdRoute
  '/supplier/$orgId/orders/$poId': typeof AppSupplierOrgIdOrdersPoIdRoute
  '/supplier/$orgId/rfqs/$rfqId': typeof AppSupplierOrgIdRfqsRfqIdRoute
  '/print/org/$orgId/reports/$reportKey': typeof PrintOrgOrgIdReportsReportKeyRoute
  '/print/projects/$projectId/certificates/$certificateId': typeof PrintProjectsProjectIdCertificatesCertificateIdRoute
  '/print/projects/$projectId/reports/$reportKey': typeof PrintProjectsProjectIdReportsReportKeyRoute
  '/print/projects/$projectId/site-visits/$visitId': typeof PrintProjectsProjectIdSiteVisitsVisitIdRoute
  '/land/sell/$orgId/': typeof AppLandSellOrgIdIndexRoute
  '/me/services/jobs/': typeof AppMeServicesJobsIndexRoute
  '/me/services/quotes/': typeof AppMeServicesQuotesIndexRoute
  '/me/services/tenders/': typeof AppMeServicesTendersIndexRoute
  '/org/$orgId/reports/': typeof AppOrgOrgIdReportsIndexRoute
  '/org/$orgId/tenders/': typeof AppOrgOrgIdTendersIndexRoute
  '/projects/$projectId/closeout/': typeof AppProjectsProjectIdCloseoutIndexRoute
  '/projects/$projectId/commercial/': typeof AppProjectsProjectIdCommercialIndexRoute
  '/projects/$projectId/cost/': typeof AppProjectsProjectIdCostIndexRoute
  '/projects/$projectId/decisions/': typeof AppProjectsProjectIdDecisionsIndexRoute
  '/projects/$projectId/design/': typeof AppProjectsProjectIdDesignIndexRoute
  '/projects/$projectId/hiring/': typeof AppProjectsProjectIdHiringIndexRoute
  '/projects/$projectId/insights/': typeof AppProjectsProjectIdInsightsIndexRoute
  '/projects/$projectId/labour-evidence/': typeof AppProjectsProjectIdLabourEvidenceIndexRoute
  '/projects/$projectId/plan/': typeof AppProjectsProjectIdPlanIndexRoute
  '/projects/$projectId/procurement/': typeof AppProjectsProjectIdProcurementIndexRoute
  '/projects/$projectId/quality/': typeof AppProjectsProjectIdQualityIndexRoute
  '/projects/$projectId/reports/': typeof AppProjectsProjectIdReportsIndexRoute
  '/projects/$projectId/resources/': typeof AppProjectsProjectIdResourcesIndexRoute
  '/projects/$projectId/safety/': typeof AppProjectsProjectIdSafetyIndexRoute
  '/projects/$projectId/site/': typeof AppProjectsProjectIdSiteIndexRoute
  '/projects/$projectId/subcontracts/': typeof AppProjectsProjectIdSubcontractsIndexRoute
  '/projects/$projectId/tenders/': typeof AppProjectsProjectIdTendersIndexRoute
  '/projects/$projectId/timeline/': typeof AppProjectsProjectIdTimelineIndexRoute
  '/projects/$projectId/workforce/': typeof AppProjectsProjectIdWorkforceIndexRoute
  '/supplier/$orgId/customers/': typeof AppSupplierOrgIdCustomersIndexRoute
  '/supplier/$orgId/messages/': typeof AppSupplierOrgIdMessagesIndexRoute
  '/supplier/$orgId/orders/': typeof AppSupplierOrgIdOrdersIndexRoute
  '/supplier/$orgId/rfqs/': typeof AppSupplierOrgIdRfqsIndexRoute
  '/land/sell/$orgId/listings/$listingId': typeof AppLandSellOrgIdListingsListingIdRoute
  '/projects/$projectId/commercial/measure/$valuationId': typeof AppProjectsProjectIdCommercialMeasureValuationIdRoute
  '/projects/$projectId/commercial/valuations/$valuationId': typeof AppProjectsProjectIdCommercialValuationsValuationIdRoute
  '/projects/$projectId/cost/boq/$boqId': typeof AppProjectsProjectIdCostBoqBoqIdRoute
  '/projects/$projectId/cost/scans/$extractionId': typeof AppProjectsProjectIdCostScansExtractionIdRoute
  '/projects/$projectId/hiring/jobs/$jobId': typeof AppProjectsProjectIdHiringJobsJobIdRoute
  '/projects/$projectId/hiring/openings/$openingId': typeof AppProjectsProjectIdHiringOpeningsOpeningIdRoute
  '/projects/$projectId/hiring/quotes/$quoteId': typeof AppProjectsProjectIdHiringQuotesQuoteIdRoute
  '/projects/$projectId/insights/weekly/$summaryId': typeof AppProjectsProjectIdInsightsWeeklySummaryIdRoute
  '/projects/$projectId/labour-evidence/payroll/$runId': typeof AppProjectsProjectIdLabourEvidencePayrollRunIdRoute
  '/projects/$projectId/procurement/orders/$poId': typeof AppProjectsProjectIdProcurementOrdersPoIdRoute
  '/projects/$projectId/procurement/rfqs/$rfqId': typeof AppProjectsProjectIdProcurementRfqsRfqIdRoute
  '/projects/$projectId/procurement/shop/$orgId': typeof AppProjectsProjectIdProcurementShopOrgIdRoute
  '/projects/$projectId/quality/inspections/$inspectionId': typeof AppProjectsProjectIdQualityInspectionsInspectionIdRoute
  '/projects/$projectId/safety/walks/$inspectionId': typeof AppProjectsProjectIdSafetyWalksInspectionIdRoute
  '/projects/$projectId/subcontracts/contracts/$subcontractId': typeof AppProjectsProjectIdSubcontractsContractsSubcontractIdRoute
  '/projects/$projectId/subcontracts/packages/$packageId': typeof AppProjectsProjectIdSubcontractsPackagesPackageIdRoute
  '/projects/$projectId/workforce/crew/$engagementId': typeof AppProjectsProjectIdWorkforceCrewEngagementIdRoute
  '/projects/$projectId/workforce/payroll/$runId': typeof AppProjectsProjectIdWorkforcePayrollRunIdRoute
  '/projects/$projectId/commercial/valuations/': typeof AppProjectsProjectIdCommercialValuationsIndexRoute
  '/projects/$projectId/cost/boq/': typeof AppProjectsProjectIdCostBoqIndexRoute
  '/projects/$projectId/cost/scans/': typeof AppProjectsProjectIdCostScansIndexRoute
  '/projects/$projectId/hiring/jobs/': typeof AppProjectsProjectIdHiringJobsIndexRoute
  '/projects/$projectId/hiring/openings/': typeof AppProjectsProjectIdHiringOpeningsIndexRoute
  '/projects/$projectId/hiring/quotes/': typeof AppProjectsProjectIdHiringQuotesIndexRoute
  '/projects/$projectId/insights/weekly/': typeof AppProjectsProjectIdInsightsWeeklyIndexRoute
  '/projects/$projectId/labour-evidence/payroll/': typeof AppProjectsProjectIdLabourEvidencePayrollIndexRoute
  '/projects/$projectId/procurement/orders/': typeof AppProjectsProjectIdProcurementOrdersIndexRoute
  '/projects/$projectId/procurement/rfqs/': typeof AppProjectsProjectIdProcurementRfqsIndexRoute
  '/projects/$projectId/procurement/shop/': typeof AppProjectsProjectIdProcurementShopIndexRoute
  '/projects/$projectId/quality/inspections/': typeof AppProjectsProjectIdQualityInspectionsIndexRoute
  '/projects/$projectId/safety/walks/': typeof AppProjectsProjectIdSafetyWalksIndexRoute
  '/projects/$projectId/subcontracts/packages/': typeof AppProjectsProjectIdSubcontractsPackagesIndexRoute
  '/projects/$projectId/workforce/crew/': typeof AppProjectsProjectIdWorkforceCrewIndexRoute
  '/projects/$projectId/workforce/payroll/': typeof AppProjectsProjectIdWorkforcePayrollIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/signed-out': typeof SignedOutRoute
  '/signin': typeof SigninRoute
  '/view-as': typeof ViewAsRoute
  '/account': typeof AppAccountRouteWithChildren
  '/admin': typeof AppAdminRoute
  '/approvals': typeof AppApprovalsRoute
  '/companies': typeof AppCompaniesRoute
  '/directory': typeof AppDirectoryRoute
  '/home': typeof AppHomeRoute
  '/notifications': typeof AppNotificationsRoute
  '/orders': typeof AppOrdersRoute
  '/portfolio': typeof AppPortfolioRoute
  '/profile': typeof AppProfileRoute
  '/settings': typeof AppSettingsRoute
  '/support': typeof AppSupportRoute
  '/sync': typeof AppSyncRoute
  '/auth/admin-signin': typeof AuthAdminSigninRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/c/$slug': typeof CSlugRoute
  '/invitations/accept': typeof InvitationsAcceptRoute
  '/p/$slug': typeof PSlugRoute
  '/tenders/accept': typeof TendersAcceptRoute
  '/account/accounting': typeof AppAccountAccountingRoute
  '/account/approval-rules': typeof AppAccountApprovalRulesRoute
  '/account/shortlist': typeof AppAccountShortlistRoute
  '/billing/return': typeof AppBillingReturnRoute
  '/land/$listingId': typeof AppLandListingIdRoute
  '/land/enquiries': typeof AppLandEnquiriesRoute
  '/marketplace/labour-rates': typeof AppMarketplaceLabourRatesRoute
  '/marketplace/professionals': typeof AppMarketplaceProfessionalsRoute
  '/me/attendance': typeof AppMeAttendanceRoute
  '/me/earnings': typeof AppMeEarningsRoute
  '/me/profile': typeof AppMeProfileRoute
  '/messages/$conversationId': typeof AppMessagesConversationIdRoute
  '/onboarding/$flow': typeof AppOnboardingFlowRoute
  '/org/new': typeof AppOrgNewRoute
  '/projects/new': typeof AppProjectsNewRoute
  '/supplier/register': typeof AppSupplierRegisterRoute
  '/organizations/invitations/accept': typeof OrganizationsInvitationsAcceptRoute
  '/land': typeof AppLandIndexRoute
  '/marketplace': typeof AppMarketplaceIndexRoute
  '/me': typeof AppMeIndexRoute
  '/messages': typeof AppMessagesIndexRoute
  '/onboarding': typeof AppOnboardingIndexRoute
  '/projects': typeof AppProjectsIndexRoute
  '/marketplace/prices/$productId': typeof AppMarketplacePricesProductIdRoute
  '/marketplace/suppliers/$orgId': typeof AppMarketplaceSuppliersOrgIdRoute
  '/marketplace/workers/$workerId': typeof AppMarketplaceWorkersWorkerIdRoute
  '/marketplace/workers/requests': typeof AppMarketplaceWorkersRequestsRoute
  '/me/services/applications': typeof AppMeServicesApplicationsRoute
  '/me/services/invitations': typeof AppMeServicesInvitationsRoute
  '/me/services/openings': typeof AppMeServicesOpeningsRoute
  '/me/work/certificates': typeof AppMeWorkCertificatesRoute
  '/me/work/jobs': typeof AppMeWorkJobsRoute
  '/me/work/listing': typeof AppMeWorkListingRoute
  '/me/work/requests': typeof AppMeWorkRequestsRoute
  '/me/work/reviews': typeof AppMeWorkReviewsRoute
  '/org/$orgId/approval-rules': typeof AppOrgOrgIdApprovalRulesRoute
  '/org/$orgId/audit': typeof AppOrgOrgIdAuditRoute
  '/org/$orgId/billing': typeof AppOrgOrgIdBillingRoute
  '/org/$orgId/clients': typeof AppOrgOrgIdClientsRoute
  '/org/$orgId/fees': typeof AppOrgOrgIdFeesRoute
  '/org/$orgId/integrations': typeof AppOrgOrgIdIntegrationsRoute
  '/org/$orgId/jobs': typeof AppOrgOrgIdJobsRoute
  '/org/$orgId/members': typeof AppOrgOrgIdMembersRoute
  '/org/$orgId/overview': typeof AppOrgOrgIdOverviewRoute
  '/org/$orgId/portfolio': typeof AppOrgOrgIdPortfolioRoute
  '/org/$orgId/profile': typeof AppOrgOrgIdProfileRoute
  '/org/$orgId/projects': typeof AppOrgOrgIdProjectsRoute
  '/org/$orgId/roles': typeof AppOrgOrgIdRolesRoute
  '/org/$orgId/settings': typeof AppOrgOrgIdSettingsRoute
  '/org/$orgId/shortlist': typeof AppOrgOrgIdShortlistRoute
  '/org/$orgId/templates': typeof AppOrgOrgIdTemplatesRoute
  '/org/$orgId/workload': typeof AppOrgOrgIdWorkloadRoute
  '/projects/$projectId/documents': typeof AppProjectsProjectIdDocumentsRoute
  '/projects/$projectId/handover': typeof AppProjectsProjectIdHandoverRoute
  '/projects/$projectId/overview': typeof AppProjectsProjectIdOverviewRoute
  '/projects/$projectId/owner-plan': typeof AppProjectsProjectIdOwnerPlanRoute
  '/projects/$projectId/risks': typeof AppProjectsProjectIdRisksRoute
  '/projects/$projectId/settings': typeof AppProjectsProjectIdSettingsRoute
  '/projects/$projectId/team': typeof AppProjectsProjectIdTeamRoute
  '/supplier/$orgId/analytics': typeof AppSupplierOrgIdAnalyticsRoute
  '/supplier/$orgId/billing': typeof AppSupplierOrgIdBillingRoute
  '/supplier/$orgId/branches': typeof AppSupplierOrgIdBranchesRoute
  '/supplier/$orgId/catalog': typeof AppSupplierOrgIdCatalogRoute
  '/supplier/$orgId/dashboard': typeof AppSupplierOrgIdDashboardRoute
  '/supplier/$orgId/deliveries': typeof AppSupplierOrgIdDeliveriesRoute
  '/supplier/$orgId/invoices': typeof AppSupplierOrgIdInvoicesRoute
  '/supplier/$orgId/notifications': typeof AppSupplierOrgIdNotificationsRoute
  '/supplier/$orgId/payments': typeof AppSupplierOrgIdPaymentsRoute
  '/supplier/$orgId/profile': typeof AppSupplierOrgIdProfileRoute
  '/supplier/$orgId/public': typeof AppSupplierOrgIdPublicRoute
  '/supplier/$orgId/quotes': typeof AppSupplierOrgIdQuotesRoute
  '/supplier/$orgId/team': typeof AppSupplierOrgIdTeamRoute
  '/land/sell': typeof AppLandSellIndexRoute
  '/marketplace/prices': typeof AppMarketplacePricesIndexRoute
  '/marketplace/suppliers': typeof AppMarketplaceSuppliersIndexRoute
  '/marketplace/workers': typeof AppMarketplaceWorkersIndexRoute
  '/me/services': typeof AppMeServicesIndexRoute
  '/me/work': typeof AppMeWorkIndexRoute
  '/org/$orgId': typeof AppOrgOrgIdIndexRoute
  '/projects/$projectId': typeof AppProjectsProjectIdIndexRoute
  '/supplier/$orgId': typeof AppSupplierOrgIdIndexRoute
  '/me/services/jobs/$jobId': typeof AppMeServicesJobsJobIdRoute
  '/me/services/quotes/$responseId': typeof AppMeServicesQuotesResponseIdRoute
  '/me/services/tenders/$packageId': typeof AppMeServicesTendersPackageIdRoute
  '/org/$orgId/reports/$reportKey': typeof AppOrgOrgIdReportsReportKeyRoute
  '/org/$orgId/tenders/$packageId': typeof AppOrgOrgIdTendersPackageIdRoute
  '/projects/$projectId/closeout/overview': typeof AppProjectsProjectIdCloseoutOverviewRoute
  '/projects/$projectId/closeout/warranty': typeof AppProjectsProjectIdCloseoutWarrantyRoute
  '/projects/$projectId/commercial/certificates': typeof AppProjectsProjectIdCommercialCertificatesRoute
  '/projects/$projectId/commercial/claims': typeof AppProjectsProjectIdCommercialClaimsRoute
  '/projects/$projectId/commercial/contract': typeof AppProjectsProjectIdCommercialContractRoute
  '/projects/$projectId/commercial/cost-control': typeof AppProjectsProjectIdCommercialCostControlRoute
  '/projects/$projectId/commercial/cost-plans': typeof AppProjectsProjectIdCommercialCostPlansRoute
  '/projects/$projectId/commercial/final-account': typeof AppProjectsProjectIdCommercialFinalAccountRoute
  '/projects/$projectId/commercial/overview': typeof AppProjectsProjectIdCommercialOverviewRoute
  '/projects/$projectId/commercial/payments': typeof AppProjectsProjectIdCommercialPaymentsRoute
  '/projects/$projectId/commercial/retention': typeof AppProjectsProjectIdCommercialRetentionRoute
  '/projects/$projectId/commercial/sums': typeof AppProjectsProjectIdCommercialSumsRoute
  '/projects/$projectId/commercial/variations': typeof AppProjectsProjectIdCommercialVariationsRoute
  '/projects/$projectId/cost/expenses': typeof AppProjectsProjectIdCostExpensesRoute
  '/projects/$projectId/cost/materials-on-site': typeof AppProjectsProjectIdCostMaterialsOnSiteRoute
  '/projects/$projectId/cost/overview': typeof AppProjectsProjectIdCostOverviewRoute
  '/projects/$projectId/cost/variations': typeof AppProjectsProjectIdCostVariationsRoute
  '/projects/$projectId/decisions/change-requests': typeof AppProjectsProjectIdDecisionsChangeRequestsRoute
  '/projects/$projectId/decisions/selections': typeof AppProjectsProjectIdDecisionsSelectionsRoute
  '/projects/$projectId/design/compare': typeof AppProjectsProjectIdDesignCompareRoute
  '/projects/$projectId/design/completion': typeof AppProjectsProjectIdDesignCompletionRoute
  '/projects/$projectId/design/coordination': typeof AppProjectsProjectIdDesignCoordinationRoute
  '/projects/$projectId/design/deliverables': typeof AppProjectsProjectIdDesignDeliverablesRoute
  '/projects/$projectId/design/drawings': typeof AppProjectsProjectIdDesignDrawingsRoute
  '/projects/$projectId/design/overview': typeof AppProjectsProjectIdDesignOverviewRoute
  '/projects/$projectId/design/rfis': typeof AppProjectsProjectIdDesignRfisRoute
  '/projects/$projectId/design/site-visits': typeof AppProjectsProjectIdDesignSiteVisitsRoute
  '/projects/$projectId/design/specifications': typeof AppProjectsProjectIdDesignSpecificationsRoute
  '/projects/$projectId/design/submittals': typeof AppProjectsProjectIdDesignSubmittalsRoute
  '/projects/$projectId/design/transmittals': typeof AppProjectsProjectIdDesignTransmittalsRoute
  '/projects/$projectId/insights/flags': typeof AppProjectsProjectIdInsightsFlagsRoute
  '/projects/$projectId/insights/forecast': typeof AppProjectsProjectIdInsightsForecastRoute
  '/projects/$projectId/labour-evidence/timesheets': typeof AppProjectsProjectIdLabourEvidenceTimesheetsRoute
  '/projects/$projectId/plan/baselines': typeof AppProjectsProjectIdPlanBaselinesRoute
  '/projects/$projectId/plan/constraints': typeof AppProjectsProjectIdPlanConstraintsRoute
  '/projects/$projectId/plan/lookahead': typeof AppProjectsProjectIdPlanLookaheadRoute
  '/projects/$projectId/plan/milestones': typeof AppProjectsProjectIdPlanMilestonesRoute
  '/projects/$projectId/plan/stages': typeof AppProjectsProjectIdPlanStagesRoute
  '/projects/$projectId/plan/tasks': typeof AppProjectsProjectIdPlanTasksRoute
  '/projects/$projectId/plan/weekly-plans': typeof AppProjectsProjectIdPlanWeeklyPlansRoute
  '/projects/$projectId/plan/zones': typeof AppProjectsProjectIdPlanZonesRoute
  '/projects/$projectId/procurement/cart': typeof AppProjectsProjectIdProcurementCartRoute
  '/projects/$projectId/procurement/deliveries': typeof AppProjectsProjectIdProcurementDeliveriesRoute
  '/projects/$projectId/procurement/invoices': typeof AppProjectsProjectIdProcurementInvoicesRoute
  '/projects/$projectId/procurement/requisitions': typeof AppProjectsProjectIdProcurementRequisitionsRoute
  '/projects/$projectId/quality/checklists': typeof AppProjectsProjectIdQualityChecklistsRoute
  '/projects/$projectId/quality/ncrs': typeof AppProjectsProjectIdQualityNcrsRoute
  '/projects/$projectId/quality/rectifications': typeof AppProjectsProjectIdQualityRectificationsRoute
  '/projects/$projectId/quality/snags': typeof AppProjectsProjectIdQualitySnagsRoute
  '/projects/$projectId/quality/tests': typeof AppProjectsProjectIdQualityTestsRoute
  '/projects/$projectId/reports/$reportKey': typeof AppProjectsProjectIdReportsReportKeyRoute
  '/projects/$projectId/resources/equipment': typeof AppProjectsProjectIdResourcesEquipmentRoute
  '/projects/$projectId/resources/equipment-requests': typeof AppProjectsProjectIdResourcesEquipmentRequestsRoute
  '/projects/$projectId/resources/requests': typeof AppProjectsProjectIdResourcesRequestsRoute
  '/projects/$projectId/resources/store': typeof AppProjectsProjectIdResourcesStoreRoute
  '/projects/$projectId/resources/submittals': typeof AppProjectsProjectIdResourcesSubmittalsRoute
  '/projects/$projectId/safety/incidents': typeof AppProjectsProjectIdSafetyIncidentsRoute
  '/projects/$projectId/safety/overview': typeof AppProjectsProjectIdSafetyOverviewRoute
  '/projects/$projectId/safety/ppe': typeof AppProjectsProjectIdSafetyPpeRoute
  '/projects/$projectId/safety/toolbox': typeof AppProjectsProjectIdSafetyToolboxRoute
  '/projects/$projectId/site/attendance': typeof AppProjectsProjectIdSiteAttendanceRoute
  '/projects/$projectId/site/daily-plan': typeof AppProjectsProjectIdSiteDailyPlanRoute
  '/projects/$projectId/site/day-close': typeof AppProjectsProjectIdSiteDayCloseRoute
  '/projects/$projectId/site/diary': typeof AppProjectsProjectIdSiteDiaryRoute
  '/projects/$projectId/site/instructions': typeof AppProjectsProjectIdSiteInstructionsRoute
  '/projects/$projectId/site/issues': typeof AppProjectsProjectIdSiteIssuesRoute
  '/projects/$projectId/site/meetings': typeof AppProjectsProjectIdSiteMeetingsRoute
  '/projects/$projectId/site/photos': typeof AppProjectsProjectIdSitePhotosRoute
  '/projects/$projectId/site/progress': typeof AppProjectsProjectIdSiteProgressRoute
  '/projects/$projectId/site/today': typeof AppProjectsProjectIdSiteTodayRoute
  '/projects/$projectId/site/visitors': typeof AppProjectsProjectIdSiteVisitorsRoute
  '/projects/$projectId/subcontracts/changes': typeof AppProjectsProjectIdSubcontractsChangesRoute
  '/projects/$projectId/subcontracts/consents': typeof AppProjectsProjectIdSubcontractsConsentsRoute
  '/projects/$projectId/subcontracts/daily-reports': typeof AppProjectsProjectIdSubcontractsDailyReportsRoute
  '/projects/$projectId/subcontracts/overview': typeof AppProjectsProjectIdSubcontractsOverviewRoute
  '/projects/$projectId/subcontracts/own-stock': typeof AppProjectsProjectIdSubcontractsOwnStockRoute
  '/projects/$projectId/subcontracts/payments': typeof AppProjectsProjectIdSubcontractsPaymentsRoute
  '/projects/$projectId/subcontracts/purchases': typeof AppProjectsProjectIdSubcontractsPurchasesRoute
  '/projects/$projectId/tenders/$packageId': typeof AppProjectsProjectIdTendersPackageIdRoute
  '/projects/$projectId/timeline/activity': typeof AppProjectsProjectIdTimelineActivityRoute
  '/projects/$projectId/timeline/photos': typeof AppProjectsProjectIdTimelinePhotosRoute
  '/projects/$projectId/workforce/crews': typeof AppProjectsProjectIdWorkforceCrewsRoute
  '/projects/$projectId/workforce/productivity': typeof AppProjectsProjectIdWorkforceProductivityRoute
  '/projects/$projectId/workforce/timesheets': typeof AppProjectsProjectIdWorkforceTimesheetsRoute
  '/supplier/$orgId/customers/$customerId': typeof AppSupplierOrgIdCustomersCustomerIdRoute
  '/supplier/$orgId/messages/$conversationId': typeof AppSupplierOrgIdMessagesConversationIdRoute
  '/supplier/$orgId/orders/$poId': typeof AppSupplierOrgIdOrdersPoIdRoute
  '/supplier/$orgId/rfqs/$rfqId': typeof AppSupplierOrgIdRfqsRfqIdRoute
  '/print/org/$orgId/reports/$reportKey': typeof PrintOrgOrgIdReportsReportKeyRoute
  '/print/projects/$projectId/certificates/$certificateId': typeof PrintProjectsProjectIdCertificatesCertificateIdRoute
  '/print/projects/$projectId/reports/$reportKey': typeof PrintProjectsProjectIdReportsReportKeyRoute
  '/print/projects/$projectId/site-visits/$visitId': typeof PrintProjectsProjectIdSiteVisitsVisitIdRoute
  '/land/sell/$orgId': typeof AppLandSellOrgIdIndexRoute
  '/me/services/jobs': typeof AppMeServicesJobsIndexRoute
  '/me/services/quotes': typeof AppMeServicesQuotesIndexRoute
  '/me/services/tenders': typeof AppMeServicesTendersIndexRoute
  '/org/$orgId/reports': typeof AppOrgOrgIdReportsIndexRoute
  '/org/$orgId/tenders': typeof AppOrgOrgIdTendersIndexRoute
  '/projects/$projectId/closeout': typeof AppProjectsProjectIdCloseoutIndexRoute
  '/projects/$projectId/commercial': typeof AppProjectsProjectIdCommercialIndexRoute
  '/projects/$projectId/cost': typeof AppProjectsProjectIdCostIndexRoute
  '/projects/$projectId/decisions': typeof AppProjectsProjectIdDecisionsIndexRoute
  '/projects/$projectId/design': typeof AppProjectsProjectIdDesignIndexRoute
  '/projects/$projectId/hiring': typeof AppProjectsProjectIdHiringIndexRoute
  '/projects/$projectId/insights': typeof AppProjectsProjectIdInsightsIndexRoute
  '/projects/$projectId/labour-evidence': typeof AppProjectsProjectIdLabourEvidenceIndexRoute
  '/projects/$projectId/plan': typeof AppProjectsProjectIdPlanIndexRoute
  '/projects/$projectId/procurement': typeof AppProjectsProjectIdProcurementIndexRoute
  '/projects/$projectId/quality': typeof AppProjectsProjectIdQualityIndexRoute
  '/projects/$projectId/reports': typeof AppProjectsProjectIdReportsIndexRoute
  '/projects/$projectId/resources': typeof AppProjectsProjectIdResourcesIndexRoute
  '/projects/$projectId/safety': typeof AppProjectsProjectIdSafetyIndexRoute
  '/projects/$projectId/site': typeof AppProjectsProjectIdSiteIndexRoute
  '/projects/$projectId/subcontracts': typeof AppProjectsProjectIdSubcontractsIndexRoute
  '/projects/$projectId/tenders': typeof AppProjectsProjectIdTendersIndexRoute
  '/projects/$projectId/timeline': typeof AppProjectsProjectIdTimelineIndexRoute
  '/projects/$projectId/workforce': typeof AppProjectsProjectIdWorkforceIndexRoute
  '/supplier/$orgId/customers': typeof AppSupplierOrgIdCustomersIndexRoute
  '/supplier/$orgId/messages': typeof AppSupplierOrgIdMessagesIndexRoute
  '/supplier/$orgId/orders': typeof AppSupplierOrgIdOrdersIndexRoute
  '/supplier/$orgId/rfqs': typeof AppSupplierOrgIdRfqsIndexRoute
  '/land/sell/$orgId/listings/$listingId': typeof AppLandSellOrgIdListingsListingIdRoute
  '/projects/$projectId/commercial/measure/$valuationId': typeof AppProjectsProjectIdCommercialMeasureValuationIdRoute
  '/projects/$projectId/commercial/valuations/$valuationId': typeof AppProjectsProjectIdCommercialValuationsValuationIdRoute
  '/projects/$projectId/cost/boq/$boqId': typeof AppProjectsProjectIdCostBoqBoqIdRoute
  '/projects/$projectId/cost/scans/$extractionId': typeof AppProjectsProjectIdCostScansExtractionIdRoute
  '/projects/$projectId/hiring/jobs/$jobId': typeof AppProjectsProjectIdHiringJobsJobIdRoute
  '/projects/$projectId/hiring/openings/$openingId': typeof AppProjectsProjectIdHiringOpeningsOpeningIdRoute
  '/projects/$projectId/hiring/quotes/$quoteId': typeof AppProjectsProjectIdHiringQuotesQuoteIdRoute
  '/projects/$projectId/insights/weekly/$summaryId': typeof AppProjectsProjectIdInsightsWeeklySummaryIdRoute
  '/projects/$projectId/labour-evidence/payroll/$runId': typeof AppProjectsProjectIdLabourEvidencePayrollRunIdRoute
  '/projects/$projectId/procurement/orders/$poId': typeof AppProjectsProjectIdProcurementOrdersPoIdRoute
  '/projects/$projectId/procurement/rfqs/$rfqId': typeof AppProjectsProjectIdProcurementRfqsRfqIdRoute
  '/projects/$projectId/procurement/shop/$orgId': typeof AppProjectsProjectIdProcurementShopOrgIdRoute
  '/projects/$projectId/quality/inspections/$inspectionId': typeof AppProjectsProjectIdQualityInspectionsInspectionIdRoute
  '/projects/$projectId/safety/walks/$inspectionId': typeof AppProjectsProjectIdSafetyWalksInspectionIdRoute
  '/projects/$projectId/subcontracts/contracts/$subcontractId': typeof AppProjectsProjectIdSubcontractsContractsSubcontractIdRoute
  '/projects/$projectId/subcontracts/packages/$packageId': typeof AppProjectsProjectIdSubcontractsPackagesPackageIdRoute
  '/projects/$projectId/workforce/crew/$engagementId': typeof AppProjectsProjectIdWorkforceCrewEngagementIdRoute
  '/projects/$projectId/workforce/payroll/$runId': typeof AppProjectsProjectIdWorkforcePayrollRunIdRoute
  '/projects/$projectId/commercial/valuations': typeof AppProjectsProjectIdCommercialValuationsIndexRoute
  '/projects/$projectId/cost/boq': typeof AppProjectsProjectIdCostBoqIndexRoute
  '/projects/$projectId/cost/scans': typeof AppProjectsProjectIdCostScansIndexRoute
  '/projects/$projectId/hiring/jobs': typeof AppProjectsProjectIdHiringJobsIndexRoute
  '/projects/$projectId/hiring/openings': typeof AppProjectsProjectIdHiringOpeningsIndexRoute
  '/projects/$projectId/hiring/quotes': typeof AppProjectsProjectIdHiringQuotesIndexRoute
  '/projects/$projectId/insights/weekly': typeof AppProjectsProjectIdInsightsWeeklyIndexRoute
  '/projects/$projectId/labour-evidence/payroll': typeof AppProjectsProjectIdLabourEvidencePayrollIndexRoute
  '/projects/$projectId/procurement/orders': typeof AppProjectsProjectIdProcurementOrdersIndexRoute
  '/projects/$projectId/procurement/rfqs': typeof AppProjectsProjectIdProcurementRfqsIndexRoute
  '/projects/$projectId/procurement/shop': typeof AppProjectsProjectIdProcurementShopIndexRoute
  '/projects/$projectId/quality/inspections': typeof AppProjectsProjectIdQualityInspectionsIndexRoute
  '/projects/$projectId/safety/walks': typeof AppProjectsProjectIdSafetyWalksIndexRoute
  '/projects/$projectId/subcontracts/packages': typeof AppProjectsProjectIdSubcontractsPackagesIndexRoute
  '/projects/$projectId/workforce/crew': typeof AppProjectsProjectIdWorkforceCrewIndexRoute
  '/projects/$projectId/workforce/payroll': typeof AppProjectsProjectIdWorkforcePayrollIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/signed-out': typeof SignedOutRoute
  '/signin': typeof SigninRoute
  '/view-as': typeof ViewAsRoute
  '/_app/account': typeof AppAccountRouteWithChildren
  '/_app/admin': typeof AppAdminRoute
  '/_app/approvals': typeof AppApprovalsRoute
  '/_app/companies': typeof AppCompaniesRoute
  '/_app/directory': typeof AppDirectoryRoute
  '/_app/home': typeof AppHomeRoute
  '/_app/me': typeof AppMeRouteWithChildren
  '/_app/notifications': typeof AppNotificationsRoute
  '/_app/orders': typeof AppOrdersRoute
  '/_app/portfolio': typeof AppPortfolioRoute
  '/_app/profile': typeof AppProfileRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/support': typeof AppSupportRoute
  '/_app/sync': typeof AppSyncRoute
  '/auth/admin-signin': typeof AuthAdminSigninRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/c/$slug': typeof CSlugRoute
  '/invitations/accept': typeof InvitationsAcceptRoute
  '/p/$slug': typeof PSlugRoute
  '/tenders/accept': typeof TendersAcceptRoute
  '/_app/account/accounting': typeof AppAccountAccountingRoute
  '/_app/account/approval-rules': typeof AppAccountApprovalRulesRoute
  '/_app/account/shortlist': typeof AppAccountShortlistRoute
  '/_app/billing/return': typeof AppBillingReturnRoute
  '/_app/land/$listingId': typeof AppLandListingIdRoute
  '/_app/land/enquiries': typeof AppLandEnquiriesRoute
  '/_app/marketplace/labour-rates': typeof AppMarketplaceLabourRatesRoute
  '/_app/marketplace/professionals': typeof AppMarketplaceProfessionalsRoute
  '/_app/me/attendance': typeof AppMeAttendanceRoute
  '/_app/me/earnings': typeof AppMeEarningsRoute
  '/_app/me/profile': typeof AppMeProfileRoute
  '/_app/messages/$conversationId': typeof AppMessagesConversationIdRoute
  '/_app/onboarding/$flow': typeof AppOnboardingFlowRoute
  '/_app/org/$orgId': typeof AppOrgOrgIdRouteWithChildren
  '/_app/org/new': typeof AppOrgNewRoute
  '/_app/projects/$projectId': typeof AppProjectsProjectIdRouteWithChildren
  '/_app/projects/new': typeof AppProjectsNewRoute
  '/_app/supplier/$orgId': typeof AppSupplierOrgIdRouteWithChildren
  '/_app/supplier/register': typeof AppSupplierRegisterRoute
  '/organizations/invitations/accept': typeof OrganizationsInvitationsAcceptRoute
  '/_app/land/': typeof AppLandIndexRoute
  '/_app/marketplace/': typeof AppMarketplaceIndexRoute
  '/_app/me/': typeof AppMeIndexRoute
  '/_app/messages/': typeof AppMessagesIndexRoute
  '/_app/onboarding/': typeof AppOnboardingIndexRoute
  '/_app/projects/': typeof AppProjectsIndexRoute
  '/_app/marketplace/prices/$productId': typeof AppMarketplacePricesProductIdRoute
  '/_app/marketplace/suppliers/$orgId': typeof AppMarketplaceSuppliersOrgIdRoute
  '/_app/marketplace/workers/$workerId': typeof AppMarketplaceWorkersWorkerIdRoute
  '/_app/marketplace/workers/requests': typeof AppMarketplaceWorkersRequestsRoute
  '/_app/me/services/applications': typeof AppMeServicesApplicationsRoute
  '/_app/me/services/invitations': typeof AppMeServicesInvitationsRoute
  '/_app/me/services/openings': typeof AppMeServicesOpeningsRoute
  '/_app/me/work/certificates': typeof AppMeWorkCertificatesRoute
  '/_app/me/work/jobs': typeof AppMeWorkJobsRoute
  '/_app/me/work/listing': typeof AppMeWorkListingRoute
  '/_app/me/work/requests': typeof AppMeWorkRequestsRoute
  '/_app/me/work/reviews': typeof AppMeWorkReviewsRoute
  '/_app/org/$orgId/approval-rules': typeof AppOrgOrgIdApprovalRulesRoute
  '/_app/org/$orgId/audit': typeof AppOrgOrgIdAuditRoute
  '/_app/org/$orgId/billing': typeof AppOrgOrgIdBillingRoute
  '/_app/org/$orgId/clients': typeof AppOrgOrgIdClientsRoute
  '/_app/org/$orgId/fees': typeof AppOrgOrgIdFeesRoute
  '/_app/org/$orgId/integrations': typeof AppOrgOrgIdIntegrationsRoute
  '/_app/org/$orgId/jobs': typeof AppOrgOrgIdJobsRoute
  '/_app/org/$orgId/members': typeof AppOrgOrgIdMembersRoute
  '/_app/org/$orgId/overview': typeof AppOrgOrgIdOverviewRoute
  '/_app/org/$orgId/portfolio': typeof AppOrgOrgIdPortfolioRoute
  '/_app/org/$orgId/profile': typeof AppOrgOrgIdProfileRoute
  '/_app/org/$orgId/projects': typeof AppOrgOrgIdProjectsRoute
  '/_app/org/$orgId/roles': typeof AppOrgOrgIdRolesRoute
  '/_app/org/$orgId/settings': typeof AppOrgOrgIdSettingsRoute
  '/_app/org/$orgId/shortlist': typeof AppOrgOrgIdShortlistRoute
  '/_app/org/$orgId/templates': typeof AppOrgOrgIdTemplatesRoute
  '/_app/org/$orgId/workload': typeof AppOrgOrgIdWorkloadRoute
  '/_app/projects/$projectId/closeout': typeof AppProjectsProjectIdCloseoutRouteWithChildren
  '/_app/projects/$projectId/commercial': typeof AppProjectsProjectIdCommercialRouteWithChildren
  '/_app/projects/$projectId/cost': typeof AppProjectsProjectIdCostRouteWithChildren
  '/_app/projects/$projectId/decisions': typeof AppProjectsProjectIdDecisionsRouteWithChildren
  '/_app/projects/$projectId/design': typeof AppProjectsProjectIdDesignRouteWithChildren
  '/_app/projects/$projectId/documents': typeof AppProjectsProjectIdDocumentsRoute
  '/_app/projects/$projectId/handover': typeof AppProjectsProjectIdHandoverRoute
  '/_app/projects/$projectId/hiring': typeof AppProjectsProjectIdHiringRouteWithChildren
  '/_app/projects/$projectId/insights': typeof AppProjectsProjectIdInsightsRouteWithChildren
  '/_app/projects/$projectId/overview': typeof AppProjectsProjectIdOverviewRoute
  '/_app/projects/$projectId/owner-plan': typeof AppProjectsProjectIdOwnerPlanRoute
  '/_app/projects/$projectId/plan': typeof AppProjectsProjectIdPlanRouteWithChildren
  '/_app/projects/$projectId/procurement': typeof AppProjectsProjectIdProcurementRouteWithChildren
  '/_app/projects/$projectId/quality': typeof AppProjectsProjectIdQualityRouteWithChildren
  '/_app/projects/$projectId/resources': typeof AppProjectsProjectIdResourcesRouteWithChildren
  '/_app/projects/$projectId/risks': typeof AppProjectsProjectIdRisksRoute
  '/_app/projects/$projectId/safety': typeof AppProjectsProjectIdSafetyRouteWithChildren
  '/_app/projects/$projectId/settings': typeof AppProjectsProjectIdSettingsRoute
  '/_app/projects/$projectId/site': typeof AppProjectsProjectIdSiteRouteWithChildren
  '/_app/projects/$projectId/subcontracts': typeof AppProjectsProjectIdSubcontractsRouteWithChildren
  '/_app/projects/$projectId/team': typeof AppProjectsProjectIdTeamRoute
  '/_app/projects/$projectId/timeline': typeof AppProjectsProjectIdTimelineRouteWithChildren
  '/_app/projects/$projectId/workforce': typeof AppProjectsProjectIdWorkforceRouteWithChildren
  '/_app/supplier/$orgId/analytics': typeof AppSupplierOrgIdAnalyticsRoute
  '/_app/supplier/$orgId/billing': typeof AppSupplierOrgIdBillingRoute
  '/_app/supplier/$orgId/branches': typeof AppSupplierOrgIdBranchesRoute
  '/_app/supplier/$orgId/catalog': typeof AppSupplierOrgIdCatalogRoute
  '/_app/supplier/$orgId/dashboard': typeof AppSupplierOrgIdDashboardRoute
  '/_app/supplier/$orgId/deliveries': typeof AppSupplierOrgIdDeliveriesRoute
  '/_app/supplier/$orgId/invoices': typeof AppSupplierOrgIdInvoicesRoute
  '/_app/supplier/$orgId/notifications': typeof AppSupplierOrgIdNotificationsRoute
  '/_app/supplier/$orgId/payments': typeof AppSupplierOrgIdPaymentsRoute
  '/_app/supplier/$orgId/profile': typeof AppSupplierOrgIdProfileRoute
  '/_app/supplier/$orgId/public': typeof AppSupplierOrgIdPublicRoute
  '/_app/supplier/$orgId/quotes': typeof AppSupplierOrgIdQuotesRoute
  '/_app/supplier/$orgId/team': typeof AppSupplierOrgIdTeamRoute
  '/_app/land/sell/': typeof AppLandSellIndexRoute
  '/_app/marketplace/prices/': typeof AppMarketplacePricesIndexRoute
  '/_app/marketplace/suppliers/': typeof AppMarketplaceSuppliersIndexRoute
  '/_app/marketplace/workers/': typeof AppMarketplaceWorkersIndexRoute
  '/_app/me/services/': typeof AppMeServicesIndexRoute
  '/_app/me/work/': typeof AppMeWorkIndexRoute
  '/_app/org/$orgId/': typeof AppOrgOrgIdIndexRoute
  '/_app/projects/$projectId/': typeof AppProjectsProjectIdIndexRoute
  '/_app/supplier/$orgId/': typeof AppSupplierOrgIdIndexRoute
  '/_app/me/services/jobs/$jobId': typeof AppMeServicesJobsJobIdRoute
  '/_app/me/services/quotes/$responseId': typeof AppMeServicesQuotesResponseIdRoute
  '/_app/me/services/tenders/$packageId': typeof AppMeServicesTendersPackageIdRoute
  '/_app/org/$orgId/reports/$reportKey': typeof AppOrgOrgIdReportsReportKeyRoute
  '/_app/org/$orgId/tenders/$packageId': typeof AppOrgOrgIdTendersPackageIdRoute
  '/_app/projects/$projectId/closeout/overview': typeof AppProjectsProjectIdCloseoutOverviewRoute
  '/_app/projects/$projectId/closeout/warranty': typeof AppProjectsProjectIdCloseoutWarrantyRoute
  '/_app/projects/$projectId/commercial/certificates': typeof AppProjectsProjectIdCommercialCertificatesRoute
  '/_app/projects/$projectId/commercial/claims': typeof AppProjectsProjectIdCommercialClaimsRoute
  '/_app/projects/$projectId/commercial/contract': typeof AppProjectsProjectIdCommercialContractRoute
  '/_app/projects/$projectId/commercial/cost-control': typeof AppProjectsProjectIdCommercialCostControlRoute
  '/_app/projects/$projectId/commercial/cost-plans': typeof AppProjectsProjectIdCommercialCostPlansRoute
  '/_app/projects/$projectId/commercial/final-account': typeof AppProjectsProjectIdCommercialFinalAccountRoute
  '/_app/projects/$projectId/commercial/overview': typeof AppProjectsProjectIdCommercialOverviewRoute
  '/_app/projects/$projectId/commercial/payments': typeof AppProjectsProjectIdCommercialPaymentsRoute
  '/_app/projects/$projectId/commercial/retention': typeof AppProjectsProjectIdCommercialRetentionRoute
  '/_app/projects/$projectId/commercial/sums': typeof AppProjectsProjectIdCommercialSumsRoute
  '/_app/projects/$projectId/commercial/variations': typeof AppProjectsProjectIdCommercialVariationsRoute
  '/_app/projects/$projectId/cost/expenses': typeof AppProjectsProjectIdCostExpensesRoute
  '/_app/projects/$projectId/cost/materials-on-site': typeof AppProjectsProjectIdCostMaterialsOnSiteRoute
  '/_app/projects/$projectId/cost/overview': typeof AppProjectsProjectIdCostOverviewRoute
  '/_app/projects/$projectId/cost/variations': typeof AppProjectsProjectIdCostVariationsRoute
  '/_app/projects/$projectId/decisions/change-requests': typeof AppProjectsProjectIdDecisionsChangeRequestsRoute
  '/_app/projects/$projectId/decisions/selections': typeof AppProjectsProjectIdDecisionsSelectionsRoute
  '/_app/projects/$projectId/design/compare': typeof AppProjectsProjectIdDesignCompareRoute
  '/_app/projects/$projectId/design/completion': typeof AppProjectsProjectIdDesignCompletionRoute
  '/_app/projects/$projectId/design/coordination': typeof AppProjectsProjectIdDesignCoordinationRoute
  '/_app/projects/$projectId/design/deliverables': typeof AppProjectsProjectIdDesignDeliverablesRoute
  '/_app/projects/$projectId/design/drawings': typeof AppProjectsProjectIdDesignDrawingsRoute
  '/_app/projects/$projectId/design/overview': typeof AppProjectsProjectIdDesignOverviewRoute
  '/_app/projects/$projectId/design/rfis': typeof AppProjectsProjectIdDesignRfisRoute
  '/_app/projects/$projectId/design/site-visits': typeof AppProjectsProjectIdDesignSiteVisitsRoute
  '/_app/projects/$projectId/design/specifications': typeof AppProjectsProjectIdDesignSpecificationsRoute
  '/_app/projects/$projectId/design/submittals': typeof AppProjectsProjectIdDesignSubmittalsRoute
  '/_app/projects/$projectId/design/transmittals': typeof AppProjectsProjectIdDesignTransmittalsRoute
  '/_app/projects/$projectId/insights/flags': typeof AppProjectsProjectIdInsightsFlagsRoute
  '/_app/projects/$projectId/insights/forecast': typeof AppProjectsProjectIdInsightsForecastRoute
  '/_app/projects/$projectId/labour-evidence/timesheets': typeof AppProjectsProjectIdLabourEvidenceTimesheetsRoute
  '/_app/projects/$projectId/plan/baselines': typeof AppProjectsProjectIdPlanBaselinesRoute
  '/_app/projects/$projectId/plan/constraints': typeof AppProjectsProjectIdPlanConstraintsRoute
  '/_app/projects/$projectId/plan/lookahead': typeof AppProjectsProjectIdPlanLookaheadRoute
  '/_app/projects/$projectId/plan/milestones': typeof AppProjectsProjectIdPlanMilestonesRoute
  '/_app/projects/$projectId/plan/stages': typeof AppProjectsProjectIdPlanStagesRoute
  '/_app/projects/$projectId/plan/tasks': typeof AppProjectsProjectIdPlanTasksRoute
  '/_app/projects/$projectId/plan/weekly-plans': typeof AppProjectsProjectIdPlanWeeklyPlansRoute
  '/_app/projects/$projectId/plan/zones': typeof AppProjectsProjectIdPlanZonesRoute
  '/_app/projects/$projectId/procurement/cart': typeof AppProjectsProjectIdProcurementCartRoute
  '/_app/projects/$projectId/procurement/deliveries': typeof AppProjectsProjectIdProcurementDeliveriesRoute
  '/_app/projects/$projectId/procurement/invoices': typeof AppProjectsProjectIdProcurementInvoicesRoute
  '/_app/projects/$projectId/procurement/requisitions': typeof AppProjectsProjectIdProcurementRequisitionsRoute
  '/_app/projects/$projectId/quality/checklists': typeof AppProjectsProjectIdQualityChecklistsRoute
  '/_app/projects/$projectId/quality/ncrs': typeof AppProjectsProjectIdQualityNcrsRoute
  '/_app/projects/$projectId/quality/rectifications': typeof AppProjectsProjectIdQualityRectificationsRoute
  '/_app/projects/$projectId/quality/snags': typeof AppProjectsProjectIdQualitySnagsRoute
  '/_app/projects/$projectId/quality/tests': typeof AppProjectsProjectIdQualityTestsRoute
  '/_app/projects/$projectId/reports/$reportKey': typeof AppProjectsProjectIdReportsReportKeyRoute
  '/_app/projects/$projectId/resources/equipment': typeof AppProjectsProjectIdResourcesEquipmentRoute
  '/_app/projects/$projectId/resources/equipment-requests': typeof AppProjectsProjectIdResourcesEquipmentRequestsRoute
  '/_app/projects/$projectId/resources/requests': typeof AppProjectsProjectIdResourcesRequestsRoute
  '/_app/projects/$projectId/resources/store': typeof AppProjectsProjectIdResourcesStoreRoute
  '/_app/projects/$projectId/resources/submittals': typeof AppProjectsProjectIdResourcesSubmittalsRoute
  '/_app/projects/$projectId/safety/incidents': typeof AppProjectsProjectIdSafetyIncidentsRoute
  '/_app/projects/$projectId/safety/overview': typeof AppProjectsProjectIdSafetyOverviewRoute
  '/_app/projects/$projectId/safety/ppe': typeof AppProjectsProjectIdSafetyPpeRoute
  '/_app/projects/$projectId/safety/toolbox': typeof AppProjectsProjectIdSafetyToolboxRoute
  '/_app/projects/$projectId/site/attendance': typeof AppProjectsProjectIdSiteAttendanceRoute
  '/_app/projects/$projectId/site/daily-plan': typeof AppProjectsProjectIdSiteDailyPlanRoute
  '/_app/projects/$projectId/site/day-close': typeof AppProjectsProjectIdSiteDayCloseRoute
  '/_app/projects/$projectId/site/diary': typeof AppProjectsProjectIdSiteDiaryRoute
  '/_app/projects/$projectId/site/instructions': typeof AppProjectsProjectIdSiteInstructionsRoute
  '/_app/projects/$projectId/site/issues': typeof AppProjectsProjectIdSiteIssuesRoute
  '/_app/projects/$projectId/site/meetings': typeof AppProjectsProjectIdSiteMeetingsRoute
  '/_app/projects/$projectId/site/photos': typeof AppProjectsProjectIdSitePhotosRoute
  '/_app/projects/$projectId/site/progress': typeof AppProjectsProjectIdSiteProgressRoute
  '/_app/projects/$projectId/site/today': typeof AppProjectsProjectIdSiteTodayRoute
  '/_app/projects/$projectId/site/visitors': typeof AppProjectsProjectIdSiteVisitorsRoute
  '/_app/projects/$projectId/subcontracts/changes': typeof AppProjectsProjectIdSubcontractsChangesRoute
  '/_app/projects/$projectId/subcontracts/consents': typeof AppProjectsProjectIdSubcontractsConsentsRoute
  '/_app/projects/$projectId/subcontracts/daily-reports': typeof AppProjectsProjectIdSubcontractsDailyReportsRoute
  '/_app/projects/$projectId/subcontracts/overview': typeof AppProjectsProjectIdSubcontractsOverviewRoute
  '/_app/projects/$projectId/subcontracts/own-stock': typeof AppProjectsProjectIdSubcontractsOwnStockRoute
  '/_app/projects/$projectId/subcontracts/payments': typeof AppProjectsProjectIdSubcontractsPaymentsRoute
  '/_app/projects/$projectId/subcontracts/purchases': typeof AppProjectsProjectIdSubcontractsPurchasesRoute
  '/_app/projects/$projectId/tenders/$packageId': typeof AppProjectsProjectIdTendersPackageIdRoute
  '/_app/projects/$projectId/timeline/activity': typeof AppProjectsProjectIdTimelineActivityRoute
  '/_app/projects/$projectId/timeline/photos': typeof AppProjectsProjectIdTimelinePhotosRoute
  '/_app/projects/$projectId/workforce/crews': typeof AppProjectsProjectIdWorkforceCrewsRoute
  '/_app/projects/$projectId/workforce/productivity': typeof AppProjectsProjectIdWorkforceProductivityRoute
  '/_app/projects/$projectId/workforce/timesheets': typeof AppProjectsProjectIdWorkforceTimesheetsRoute
  '/_app/supplier/$orgId/customers/$customerId': typeof AppSupplierOrgIdCustomersCustomerIdRoute
  '/_app/supplier/$orgId/messages/$conversationId': typeof AppSupplierOrgIdMessagesConversationIdRoute
  '/_app/supplier/$orgId/orders/$poId': typeof AppSupplierOrgIdOrdersPoIdRoute
  '/_app/supplier/$orgId/rfqs/$rfqId': typeof AppSupplierOrgIdRfqsRfqIdRoute
  '/print/org/$orgId/reports/$reportKey': typeof PrintOrgOrgIdReportsReportKeyRoute
  '/print/projects/$projectId/certificates/$certificateId': typeof PrintProjectsProjectIdCertificatesCertificateIdRoute
  '/print/projects/$projectId/reports/$reportKey': typeof PrintProjectsProjectIdReportsReportKeyRoute
  '/print/projects/$projectId/site-visits/$visitId': typeof PrintProjectsProjectIdSiteVisitsVisitIdRoute
  '/_app/land/sell/$orgId/': typeof AppLandSellOrgIdIndexRoute
  '/_app/me/services/jobs/': typeof AppMeServicesJobsIndexRoute
  '/_app/me/services/quotes/': typeof AppMeServicesQuotesIndexRoute
  '/_app/me/services/tenders/': typeof AppMeServicesTendersIndexRoute
  '/_app/org/$orgId/reports/': typeof AppOrgOrgIdReportsIndexRoute
  '/_app/org/$orgId/tenders/': typeof AppOrgOrgIdTendersIndexRoute
  '/_app/projects/$projectId/closeout/': typeof AppProjectsProjectIdCloseoutIndexRoute
  '/_app/projects/$projectId/commercial/': typeof AppProjectsProjectIdCommercialIndexRoute
  '/_app/projects/$projectId/cost/': typeof AppProjectsProjectIdCostIndexRoute
  '/_app/projects/$projectId/decisions/': typeof AppProjectsProjectIdDecisionsIndexRoute
  '/_app/projects/$projectId/design/': typeof AppProjectsProjectIdDesignIndexRoute
  '/_app/projects/$projectId/hiring/': typeof AppProjectsProjectIdHiringIndexRoute
  '/_app/projects/$projectId/insights/': typeof AppProjectsProjectIdInsightsIndexRoute
  '/_app/projects/$projectId/labour-evidence/': typeof AppProjectsProjectIdLabourEvidenceIndexRoute
  '/_app/projects/$projectId/plan/': typeof AppProjectsProjectIdPlanIndexRoute
  '/_app/projects/$projectId/procurement/': typeof AppProjectsProjectIdProcurementIndexRoute
  '/_app/projects/$projectId/quality/': typeof AppProjectsProjectIdQualityIndexRoute
  '/_app/projects/$projectId/reports/': typeof AppProjectsProjectIdReportsIndexRoute
  '/_app/projects/$projectId/resources/': typeof AppProjectsProjectIdResourcesIndexRoute
  '/_app/projects/$projectId/safety/': typeof AppProjectsProjectIdSafetyIndexRoute
  '/_app/projects/$projectId/site/': typeof AppProjectsProjectIdSiteIndexRoute
  '/_app/projects/$projectId/subcontracts/': typeof AppProjectsProjectIdSubcontractsIndexRoute
  '/_app/projects/$projectId/tenders/': typeof AppProjectsProjectIdTendersIndexRoute
  '/_app/projects/$projectId/timeline/': typeof AppProjectsProjectIdTimelineIndexRoute
  '/_app/projects/$projectId/workforce/': typeof AppProjectsProjectIdWorkforceIndexRoute
  '/_app/supplier/$orgId/customers/': typeof AppSupplierOrgIdCustomersIndexRoute
  '/_app/supplier/$orgId/messages/': typeof AppSupplierOrgIdMessagesIndexRoute
  '/_app/supplier/$orgId/orders/': typeof AppSupplierOrgIdOrdersIndexRoute
  '/_app/supplier/$orgId/rfqs/': typeof AppSupplierOrgIdRfqsIndexRoute
  '/_app/land/sell/$orgId/listings/$listingId': typeof AppLandSellOrgIdListingsListingIdRoute
  '/_app/projects/$projectId/commercial/measure/$valuationId': typeof AppProjectsProjectIdCommercialMeasureValuationIdRoute
  '/_app/projects/$projectId/commercial/valuations/$valuationId': typeof AppProjectsProjectIdCommercialValuationsValuationIdRoute
  '/_app/projects/$projectId/cost/boq/$boqId': typeof AppProjectsProjectIdCostBoqBoqIdRoute
  '/_app/projects/$projectId/cost/scans/$extractionId': typeof AppProjectsProjectIdCostScansExtractionIdRoute
  '/_app/projects/$projectId/hiring/jobs/$jobId': typeof AppProjectsProjectIdHiringJobsJobIdRoute
  '/_app/projects/$projectId/hiring/openings/$openingId': typeof AppProjectsProjectIdHiringOpeningsOpeningIdRoute
  '/_app/projects/$projectId/hiring/quotes/$quoteId': typeof AppProjectsProjectIdHiringQuotesQuoteIdRoute
  '/_app/projects/$projectId/insights/weekly/$summaryId': typeof AppProjectsProjectIdInsightsWeeklySummaryIdRoute
  '/_app/projects/$projectId/labour-evidence/payroll/$runId': typeof AppProjectsProjectIdLabourEvidencePayrollRunIdRoute
  '/_app/projects/$projectId/procurement/orders/$poId': typeof AppProjectsProjectIdProcurementOrdersPoIdRoute
  '/_app/projects/$projectId/procurement/rfqs/$rfqId': typeof AppProjectsProjectIdProcurementRfqsRfqIdRoute
  '/_app/projects/$projectId/procurement/shop/$orgId': typeof AppProjectsProjectIdProcurementShopOrgIdRoute
  '/_app/projects/$projectId/quality/inspections/$inspectionId': typeof AppProjectsProjectIdQualityInspectionsInspectionIdRoute
  '/_app/projects/$projectId/safety/walks/$inspectionId': typeof AppProjectsProjectIdSafetyWalksInspectionIdRoute
  '/_app/projects/$projectId/subcontracts/contracts/$subcontractId': typeof AppProjectsProjectIdSubcontractsContractsSubcontractIdRoute
  '/_app/projects/$projectId/subcontracts/packages/$packageId': typeof AppProjectsProjectIdSubcontractsPackagesPackageIdRoute
  '/_app/projects/$projectId/workforce/crew/$engagementId': typeof AppProjectsProjectIdWorkforceCrewEngagementIdRoute
  '/_app/projects/$projectId/workforce/payroll/$runId': typeof AppProjectsProjectIdWorkforcePayrollRunIdRoute
  '/_app/projects/$projectId/commercial/valuations/': typeof AppProjectsProjectIdCommercialValuationsIndexRoute
  '/_app/projects/$projectId/cost/boq/': typeof AppProjectsProjectIdCostBoqIndexRoute
  '/_app/projects/$projectId/cost/scans/': typeof AppProjectsProjectIdCostScansIndexRoute
  '/_app/projects/$projectId/hiring/jobs/': typeof AppProjectsProjectIdHiringJobsIndexRoute
  '/_app/projects/$projectId/hiring/openings/': typeof AppProjectsProjectIdHiringOpeningsIndexRoute
  '/_app/projects/$projectId/hiring/quotes/': typeof AppProjectsProjectIdHiringQuotesIndexRoute
  '/_app/projects/$projectId/insights/weekly/': typeof AppProjectsProjectIdInsightsWeeklyIndexRoute
  '/_app/projects/$projectId/labour-evidence/payroll/': typeof AppProjectsProjectIdLabourEvidencePayrollIndexRoute
  '/_app/projects/$projectId/procurement/orders/': typeof AppProjectsProjectIdProcurementOrdersIndexRoute
  '/_app/projects/$projectId/procurement/rfqs/': typeof AppProjectsProjectIdProcurementRfqsIndexRoute
  '/_app/projects/$projectId/procurement/shop/': typeof AppProjectsProjectIdProcurementShopIndexRoute
  '/_app/projects/$projectId/quality/inspections/': typeof AppProjectsProjectIdQualityInspectionsIndexRoute
  '/_app/projects/$projectId/safety/walks/': typeof AppProjectsProjectIdSafetyWalksIndexRoute
  '/_app/projects/$projectId/subcontracts/packages/': typeof AppProjectsProjectIdSubcontractsPackagesIndexRoute
  '/_app/projects/$projectId/workforce/crew/': typeof AppProjectsProjectIdWorkforceCrewIndexRoute
  '/_app/projects/$projectId/workforce/payroll/': typeof AppProjectsProjectIdWorkforcePayrollIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/signed-out'
    | '/signin'
    | '/view-as'
    | '/account'
    | '/admin'
    | '/approvals'
    | '/companies'
    | '/directory'
    | '/home'
    | '/me'
    | '/notifications'
    | '/orders'
    | '/portfolio'
    | '/profile'
    | '/settings'
    | '/support'
    | '/sync'
    | '/auth/admin-signin'
    | '/auth/callback'
    | '/c/$slug'
    | '/invitations/accept'
    | '/p/$slug'
    | '/tenders/accept'
    | '/account/accounting'
    | '/account/approval-rules'
    | '/account/shortlist'
    | '/billing/return'
    | '/land/$listingId'
    | '/land/enquiries'
    | '/marketplace/labour-rates'
    | '/marketplace/professionals'
    | '/me/attendance'
    | '/me/earnings'
    | '/me/profile'
    | '/messages/$conversationId'
    | '/onboarding/$flow'
    | '/org/$orgId'
    | '/org/new'
    | '/projects/$projectId'
    | '/projects/new'
    | '/supplier/$orgId'
    | '/supplier/register'
    | '/organizations/invitations/accept'
    | '/land/'
    | '/marketplace/'
    | '/me/'
    | '/messages/'
    | '/onboarding/'
    | '/projects/'
    | '/marketplace/prices/$productId'
    | '/marketplace/suppliers/$orgId'
    | '/marketplace/workers/$workerId'
    | '/marketplace/workers/requests'
    | '/me/services/applications'
    | '/me/services/invitations'
    | '/me/services/openings'
    | '/me/work/certificates'
    | '/me/work/jobs'
    | '/me/work/listing'
    | '/me/work/requests'
    | '/me/work/reviews'
    | '/org/$orgId/approval-rules'
    | '/org/$orgId/audit'
    | '/org/$orgId/billing'
    | '/org/$orgId/clients'
    | '/org/$orgId/fees'
    | '/org/$orgId/integrations'
    | '/org/$orgId/jobs'
    | '/org/$orgId/members'
    | '/org/$orgId/overview'
    | '/org/$orgId/portfolio'
    | '/org/$orgId/profile'
    | '/org/$orgId/projects'
    | '/org/$orgId/roles'
    | '/org/$orgId/settings'
    | '/org/$orgId/shortlist'
    | '/org/$orgId/templates'
    | '/org/$orgId/workload'
    | '/projects/$projectId/closeout'
    | '/projects/$projectId/commercial'
    | '/projects/$projectId/cost'
    | '/projects/$projectId/decisions'
    | '/projects/$projectId/design'
    | '/projects/$projectId/documents'
    | '/projects/$projectId/handover'
    | '/projects/$projectId/hiring'
    | '/projects/$projectId/insights'
    | '/projects/$projectId/overview'
    | '/projects/$projectId/owner-plan'
    | '/projects/$projectId/plan'
    | '/projects/$projectId/procurement'
    | '/projects/$projectId/quality'
    | '/projects/$projectId/resources'
    | '/projects/$projectId/risks'
    | '/projects/$projectId/safety'
    | '/projects/$projectId/settings'
    | '/projects/$projectId/site'
    | '/projects/$projectId/subcontracts'
    | '/projects/$projectId/team'
    | '/projects/$projectId/timeline'
    | '/projects/$projectId/workforce'
    | '/supplier/$orgId/analytics'
    | '/supplier/$orgId/billing'
    | '/supplier/$orgId/branches'
    | '/supplier/$orgId/catalog'
    | '/supplier/$orgId/dashboard'
    | '/supplier/$orgId/deliveries'
    | '/supplier/$orgId/invoices'
    | '/supplier/$orgId/notifications'
    | '/supplier/$orgId/payments'
    | '/supplier/$orgId/profile'
    | '/supplier/$orgId/public'
    | '/supplier/$orgId/quotes'
    | '/supplier/$orgId/team'
    | '/land/sell/'
    | '/marketplace/prices/'
    | '/marketplace/suppliers/'
    | '/marketplace/workers/'
    | '/me/services/'
    | '/me/work/'
    | '/org/$orgId/'
    | '/projects/$projectId/'
    | '/supplier/$orgId/'
    | '/me/services/jobs/$jobId'
    | '/me/services/quotes/$responseId'
    | '/me/services/tenders/$packageId'
    | '/org/$orgId/reports/$reportKey'
    | '/org/$orgId/tenders/$packageId'
    | '/projects/$projectId/closeout/overview'
    | '/projects/$projectId/closeout/warranty'
    | '/projects/$projectId/commercial/certificates'
    | '/projects/$projectId/commercial/claims'
    | '/projects/$projectId/commercial/contract'
    | '/projects/$projectId/commercial/cost-control'
    | '/projects/$projectId/commercial/cost-plans'
    | '/projects/$projectId/commercial/final-account'
    | '/projects/$projectId/commercial/overview'
    | '/projects/$projectId/commercial/payments'
    | '/projects/$projectId/commercial/retention'
    | '/projects/$projectId/commercial/sums'
    | '/projects/$projectId/commercial/variations'
    | '/projects/$projectId/cost/expenses'
    | '/projects/$projectId/cost/materials-on-site'
    | '/projects/$projectId/cost/overview'
    | '/projects/$projectId/cost/variations'
    | '/projects/$projectId/decisions/change-requests'
    | '/projects/$projectId/decisions/selections'
    | '/projects/$projectId/design/compare'
    | '/projects/$projectId/design/completion'
    | '/projects/$projectId/design/coordination'
    | '/projects/$projectId/design/deliverables'
    | '/projects/$projectId/design/drawings'
    | '/projects/$projectId/design/overview'
    | '/projects/$projectId/design/rfis'
    | '/projects/$projectId/design/site-visits'
    | '/projects/$projectId/design/specifications'
    | '/projects/$projectId/design/submittals'
    | '/projects/$projectId/design/transmittals'
    | '/projects/$projectId/insights/flags'
    | '/projects/$projectId/insights/forecast'
    | '/projects/$projectId/labour-evidence/timesheets'
    | '/projects/$projectId/plan/baselines'
    | '/projects/$projectId/plan/constraints'
    | '/projects/$projectId/plan/lookahead'
    | '/projects/$projectId/plan/milestones'
    | '/projects/$projectId/plan/stages'
    | '/projects/$projectId/plan/tasks'
    | '/projects/$projectId/plan/weekly-plans'
    | '/projects/$projectId/plan/zones'
    | '/projects/$projectId/procurement/cart'
    | '/projects/$projectId/procurement/deliveries'
    | '/projects/$projectId/procurement/invoices'
    | '/projects/$projectId/procurement/requisitions'
    | '/projects/$projectId/quality/checklists'
    | '/projects/$projectId/quality/ncrs'
    | '/projects/$projectId/quality/rectifications'
    | '/projects/$projectId/quality/snags'
    | '/projects/$projectId/quality/tests'
    | '/projects/$projectId/reports/$reportKey'
    | '/projects/$projectId/resources/equipment'
    | '/projects/$projectId/resources/equipment-requests'
    | '/projects/$projectId/resources/requests'
    | '/projects/$projectId/resources/store'
    | '/projects/$projectId/resources/submittals'
    | '/projects/$projectId/safety/incidents'
    | '/projects/$projectId/safety/overview'
    | '/projects/$projectId/safety/ppe'
    | '/projects/$projectId/safety/toolbox'
    | '/projects/$projectId/site/attendance'
    | '/projects/$projectId/site/daily-plan'
    | '/projects/$projectId/site/day-close'
    | '/projects/$projectId/site/diary'
    | '/projects/$projectId/site/instructions'
    | '/projects/$projectId/site/issues'
    | '/projects/$projectId/site/meetings'
    | '/projects/$projectId/site/photos'
    | '/projects/$projectId/site/progress'
    | '/projects/$projectId/site/today'
    | '/projects/$projectId/site/visitors'
    | '/projects/$projectId/subcontracts/changes'
    | '/projects/$projectId/subcontracts/consents'
    | '/projects/$projectId/subcontracts/daily-reports'
    | '/projects/$projectId/subcontracts/overview'
    | '/projects/$projectId/subcontracts/own-stock'
    | '/projects/$projectId/subcontracts/payments'
    | '/projects/$projectId/subcontracts/purchases'
    | '/projects/$projectId/tenders/$packageId'
    | '/projects/$projectId/timeline/activity'
    | '/projects/$projectId/timeline/photos'
    | '/projects/$projectId/workforce/crews'
    | '/projects/$projectId/workforce/productivity'
    | '/projects/$projectId/workforce/timesheets'
    | '/supplier/$orgId/customers/$customerId'
    | '/supplier/$orgId/messages/$conversationId'
    | '/supplier/$orgId/orders/$poId'
    | '/supplier/$orgId/rfqs/$rfqId'
    | '/print/org/$orgId/reports/$reportKey'
    | '/print/projects/$projectId/certificates/$certificateId'
    | '/print/projects/$projectId/reports/$reportKey'
    | '/print/projects/$projectId/site-visits/$visitId'
    | '/land/sell/$orgId/'
    | '/me/services/jobs/'
    | '/me/services/quotes/'
    | '/me/services/tenders/'
    | '/org/$orgId/reports/'
    | '/org/$orgId/tenders/'
    | '/projects/$projectId/closeout/'
    | '/projects/$projectId/commercial/'
    | '/projects/$projectId/cost/'
    | '/projects/$projectId/decisions/'
    | '/projects/$projectId/design/'
    | '/projects/$projectId/hiring/'
    | '/projects/$projectId/insights/'
    | '/projects/$projectId/labour-evidence/'
    | '/projects/$projectId/plan/'
    | '/projects/$projectId/procurement/'
    | '/projects/$projectId/quality/'
    | '/projects/$projectId/reports/'
    | '/projects/$projectId/resources/'
    | '/projects/$projectId/safety/'
    | '/projects/$projectId/site/'
    | '/projects/$projectId/subcontracts/'
    | '/projects/$projectId/tenders/'
    | '/projects/$projectId/timeline/'
    | '/projects/$projectId/workforce/'
    | '/supplier/$orgId/customers/'
    | '/supplier/$orgId/messages/'
    | '/supplier/$orgId/orders/'
    | '/supplier/$orgId/rfqs/'
    | '/land/sell/$orgId/listings/$listingId'
    | '/projects/$projectId/commercial/measure/$valuationId'
    | '/projects/$projectId/commercial/valuations/$valuationId'
    | '/projects/$projectId/cost/boq/$boqId'
    | '/projects/$projectId/cost/scans/$extractionId'
    | '/projects/$projectId/hiring/jobs/$jobId'
    | '/projects/$projectId/hiring/openings/$openingId'
    | '/projects/$projectId/hiring/quotes/$quoteId'
    | '/projects/$projectId/insights/weekly/$summaryId'
    | '/projects/$projectId/labour-evidence/payroll/$runId'
    | '/projects/$projectId/procurement/orders/$poId'
    | '/projects/$projectId/procurement/rfqs/$rfqId'
    | '/projects/$projectId/procurement/shop/$orgId'
    | '/projects/$projectId/quality/inspections/$inspectionId'
    | '/projects/$projectId/safety/walks/$inspectionId'
    | '/projects/$projectId/subcontracts/contracts/$subcontractId'
    | '/projects/$projectId/subcontracts/packages/$packageId'
    | '/projects/$projectId/workforce/crew/$engagementId'
    | '/projects/$projectId/workforce/payroll/$runId'
    | '/projects/$projectId/commercial/valuations/'
    | '/projects/$projectId/cost/boq/'
    | '/projects/$projectId/cost/scans/'
    | '/projects/$projectId/hiring/jobs/'
    | '/projects/$projectId/hiring/openings/'
    | '/projects/$projectId/hiring/quotes/'
    | '/projects/$projectId/insights/weekly/'
    | '/projects/$projectId/labour-evidence/payroll/'
    | '/projects/$projectId/procurement/orders/'
    | '/projects/$projectId/procurement/rfqs/'
    | '/projects/$projectId/procurement/shop/'
    | '/projects/$projectId/quality/inspections/'
    | '/projects/$projectId/safety/walks/'
    | '/projects/$projectId/subcontracts/packages/'
    | '/projects/$projectId/workforce/crew/'
    | '/projects/$projectId/workforce/payroll/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/signed-out'
    | '/signin'
    | '/view-as'
    | '/account'
    | '/admin'
    | '/approvals'
    | '/companies'
    | '/directory'
    | '/home'
    | '/notifications'
    | '/orders'
    | '/portfolio'
    | '/profile'
    | '/settings'
    | '/support'
    | '/sync'
    | '/auth/admin-signin'
    | '/auth/callback'
    | '/c/$slug'
    | '/invitations/accept'
    | '/p/$slug'
    | '/tenders/accept'
    | '/account/accounting'
    | '/account/approval-rules'
    | '/account/shortlist'
    | '/billing/return'
    | '/land/$listingId'
    | '/land/enquiries'
    | '/marketplace/labour-rates'
    | '/marketplace/professionals'
    | '/me/attendance'
    | '/me/earnings'
    | '/me/profile'
    | '/messages/$conversationId'
    | '/onboarding/$flow'
    | '/org/new'
    | '/projects/new'
    | '/supplier/register'
    | '/organizations/invitations/accept'
    | '/land'
    | '/marketplace'
    | '/me'
    | '/messages'
    | '/onboarding'
    | '/projects'
    | '/marketplace/prices/$productId'
    | '/marketplace/suppliers/$orgId'
    | '/marketplace/workers/$workerId'
    | '/marketplace/workers/requests'
    | '/me/services/applications'
    | '/me/services/invitations'
    | '/me/services/openings'
    | '/me/work/certificates'
    | '/me/work/jobs'
    | '/me/work/listing'
    | '/me/work/requests'
    | '/me/work/reviews'
    | '/org/$orgId/approval-rules'
    | '/org/$orgId/audit'
    | '/org/$orgId/billing'
    | '/org/$orgId/clients'
    | '/org/$orgId/fees'
    | '/org/$orgId/integrations'
    | '/org/$orgId/jobs'
    | '/org/$orgId/members'
    | '/org/$orgId/overview'
    | '/org/$orgId/portfolio'
    | '/org/$orgId/profile'
    | '/org/$orgId/projects'
    | '/org/$orgId/roles'
    | '/org/$orgId/settings'
    | '/org/$orgId/shortlist'
    | '/org/$orgId/templates'
    | '/org/$orgId/workload'
    | '/projects/$projectId/documents'
    | '/projects/$projectId/handover'
    | '/projects/$projectId/overview'
    | '/projects/$projectId/owner-plan'
    | '/projects/$projectId/risks'
    | '/projects/$projectId/settings'
    | '/projects/$projectId/team'
    | '/supplier/$orgId/analytics'
    | '/supplier/$orgId/billing'
    | '/supplier/$orgId/branches'
    | '/supplier/$orgId/catalog'
    | '/supplier/$orgId/dashboard'
    | '/supplier/$orgId/deliveries'
    | '/supplier/$orgId/invoices'
    | '/supplier/$orgId/notifications'
    | '/supplier/$orgId/payments'
    | '/supplier/$orgId/profile'
    | '/supplier/$orgId/public'
    | '/supplier/$orgId/quotes'
    | '/supplier/$orgId/team'
    | '/land/sell'
    | '/marketplace/prices'
    | '/marketplace/suppliers'
    | '/marketplace/workers'
    | '/me/services'
    | '/me/work'
    | '/org/$orgId'
    | '/projects/$projectId'
    | '/supplier/$orgId'
    | '/me/services/jobs/$jobId'
    | '/me/services/quotes/$responseId'
    | '/me/services/tenders/$packageId'
    | '/org/$orgId/reports/$reportKey'
    | '/org/$orgId/tenders/$packageId'
    | '/projects/$projectId/closeout/overview'
    | '/projects/$projectId/closeout/warranty'
    | '/projects/$projectId/commercial/certificates'
    | '/projects/$projectId/commercial/claims'
    | '/projects/$projectId/commercial/contract'
    | '/projects/$projectId/commercial/cost-control'
    | '/projects/$projectId/commercial/cost-plans'
    | '/projects/$projectId/commercial/final-account'
    | '/projects/$projectId/commercial/overview'
    | '/projects/$projectId/commercial/payments'
    | '/projects/$projectId/commercial/retention'
    | '/projects/$projectId/commercial/sums'
    | '/projects/$projectId/commercial/variations'
    | '/projects/$projectId/cost/expenses'
    | '/projects/$projectId/cost/materials-on-site'
    | '/projects/$projectId/cost/overview'
    | '/projects/$projectId/cost/variations'
    | '/projects/$projectId/decisions/change-requests'
    | '/projects/$projectId/decisions/selections'
    | '/projects/$projectId/design/compare'
    | '/projects/$projectId/design/completion'
    | '/projects/$projectId/design/coordination'
    | '/projects/$projectId/design/deliverables'
    | '/projects/$projectId/design/drawings'
    | '/projects/$projectId/design/overview'
    | '/projects/$projectId/design/rfis'
    | '/projects/$projectId/design/site-visits'
    | '/projects/$projectId/design/specifications'
    | '/projects/$projectId/design/submittals'
    | '/projects/$projectId/design/transmittals'
    | '/projects/$projectId/insights/flags'
    | '/projects/$projectId/insights/forecast'
    | '/projects/$projectId/labour-evidence/timesheets'
    | '/projects/$projectId/plan/baselines'
    | '/projects/$projectId/plan/constraints'
    | '/projects/$projectId/plan/lookahead'
    | '/projects/$projectId/plan/milestones'
    | '/projects/$projectId/plan/stages'
    | '/projects/$projectId/plan/tasks'
    | '/projects/$projectId/plan/weekly-plans'
    | '/projects/$projectId/plan/zones'
    | '/projects/$projectId/procurement/cart'
    | '/projects/$projectId/procurement/deliveries'
    | '/projects/$projectId/procurement/invoices'
    | '/projects/$projectId/procurement/requisitions'
    | '/projects/$projectId/quality/checklists'
    | '/projects/$projectId/quality/ncrs'
    | '/projects/$projectId/quality/rectifications'
    | '/projects/$projectId/quality/snags'
    | '/projects/$projectId/quality/tests'
    | '/projects/$projectId/reports/$reportKey'
    | '/projects/$projectId/resources/equipment'
    | '/projects/$projectId/resources/equipment-requests'
    | '/projects/$projectId/resources/requests'
    | '/projects/$projectId/resources/store'
    | '/projects/$projectId/resources/submittals'
    | '/projects/$projectId/safety/incidents'
    | '/projects/$projectId/safety/overview'
    | '/projects/$projectId/safety/ppe'
    | '/projects/$projectId/safety/toolbox'
    | '/projects/$projectId/site/attendance'
    | '/projects/$projectId/site/daily-plan'
    | '/projects/$projectId/site/day-close'
    | '/projects/$projectId/site/diary'
    | '/projects/$projectId/site/instructions'
    | '/projects/$projectId/site/issues'
    | '/projects/$projectId/site/meetings'
    | '/projects/$projectId/site/photos'
    | '/projects/$projectId/site/progress'
    | '/projects/$projectId/site/today'
    | '/projects/$projectId/site/visitors'
    | '/projects/$projectId/subcontracts/changes'
    | '/projects/$projectId/subcontracts/consents'
    | '/projects/$projectId/subcontracts/daily-reports'
    | '/projects/$projectId/subcontracts/overview'
    | '/projects/$projectId/subcontracts/own-stock'
    | '/projects/$projectId/subcontracts/payments'
    | '/projects/$projectId/subcontracts/purchases'
    | '/projects/$projectId/tenders/$packageId'
    | '/projects/$projectId/timeline/activity'
    | '/projects/$projectId/timeline/photos'
    | '/projects/$projectId/workforce/crews'
    | '/projects/$projectId/workforce/productivity'
    | '/projects/$projectId/workforce/timesheets'
    | '/supplier/$orgId/customers/$customerId'
    | '/supplier/$orgId/messages/$conversationId'
    | '/supplier/$orgId/orders/$poId'
    | '/supplier/$orgId/rfqs/$rfqId'
    | '/print/org/$orgId/reports/$reportKey'
    | '/print/projects/$projectId/certificates/$certificateId'
    | '/print/projects/$projectId/reports/$reportKey'
    | '/print/projects/$projectId/site-visits/$visitId'
    | '/land/sell/$orgId'
    | '/me/services/jobs'
    | '/me/services/quotes'
    | '/me/services/tenders'
    | '/org/$orgId/reports'
    | '/org/$orgId/tenders'
    | '/projects/$projectId/closeout'
    | '/projects/$projectId/commercial'
    | '/projects/$projectId/cost'
    | '/projects/$projectId/decisions'
    | '/projects/$projectId/design'
    | '/projects/$projectId/hiring'
    | '/projects/$projectId/insights'
    | '/projects/$projectId/labour-evidence'
    | '/projects/$projectId/plan'
    | '/projects/$projectId/procurement'
    | '/projects/$projectId/quality'
    | '/projects/$projectId/reports'
    | '/projects/$projectId/resources'
    | '/projects/$projectId/safety'
    | '/projects/$projectId/site'
    | '/projects/$projectId/subcontracts'
    | '/projects/$projectId/tenders'
    | '/projects/$projectId/timeline'
    | '/projects/$projectId/workforce'
    | '/supplier/$orgId/customers'
    | '/supplier/$orgId/messages'
    | '/supplier/$orgId/orders'
    | '/supplier/$orgId/rfqs'
    | '/land/sell/$orgId/listings/$listingId'
    | '/projects/$projectId/commercial/measure/$valuationId'
    | '/projects/$projectId/commercial/valuations/$valuationId'
    | '/projects/$projectId/cost/boq/$boqId'
    | '/projects/$projectId/cost/scans/$extractionId'
    | '/projects/$projectId/hiring/jobs/$jobId'
    | '/projects/$projectId/hiring/openings/$openingId'
    | '/projects/$projectId/hiring/quotes/$quoteId'
    | '/projects/$projectId/insights/weekly/$summaryId'
    | '/projects/$projectId/labour-evidence/payroll/$runId'
    | '/projects/$projectId/procurement/orders/$poId'
    | '/projects/$projectId/procurement/rfqs/$rfqId'
    | '/projects/$projectId/procurement/shop/$orgId'
    | '/projects/$projectId/quality/inspections/$inspectionId'
    | '/projects/$projectId/safety/walks/$inspectionId'
    | '/projects/$projectId/subcontracts/contracts/$subcontractId'
    | '/projects/$projectId/subcontracts/packages/$packageId'
    | '/projects/$projectId/workforce/crew/$engagementId'
    | '/projects/$projectId/workforce/payroll/$runId'
    | '/projects/$projectId/commercial/valuations'
    | '/projects/$projectId/cost/boq'
    | '/projects/$projectId/cost/scans'
    | '/projects/$projectId/hiring/jobs'
    | '/projects/$projectId/hiring/openings'
    | '/projects/$projectId/hiring/quotes'
    | '/projects/$projectId/insights/weekly'
    | '/projects/$projectId/labour-evidence/payroll'
    | '/projects/$projectId/procurement/orders'
    | '/projects/$projectId/procurement/rfqs'
    | '/projects/$projectId/procurement/shop'
    | '/projects/$projectId/quality/inspections'
    | '/projects/$projectId/safety/walks'
    | '/projects/$projectId/subcontracts/packages'
    | '/projects/$projectId/workforce/crew'
    | '/projects/$projectId/workforce/payroll'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/signed-out'
    | '/signin'
    | '/view-as'
    | '/_app/account'
    | '/_app/admin'
    | '/_app/approvals'
    | '/_app/companies'
    | '/_app/directory'
    | '/_app/home'
    | '/_app/me'
    | '/_app/notifications'
    | '/_app/orders'
    | '/_app/portfolio'
    | '/_app/profile'
    | '/_app/settings'
    | '/_app/support'
    | '/_app/sync'
    | '/auth/admin-signin'
    | '/auth/callback'
    | '/c/$slug'
    | '/invitations/accept'
    | '/p/$slug'
    | '/tenders/accept'
    | '/_app/account/accounting'
    | '/_app/account/approval-rules'
    | '/_app/account/shortlist'
    | '/_app/billing/return'
    | '/_app/land/$listingId'
    | '/_app/land/enquiries'
    | '/_app/marketplace/labour-rates'
    | '/_app/marketplace/professionals'
    | '/_app/me/attendance'
    | '/_app/me/earnings'
    | '/_app/me/profile'
    | '/_app/messages/$conversationId'
    | '/_app/onboarding/$flow'
    | '/_app/org/$orgId'
    | '/_app/org/new'
    | '/_app/projects/$projectId'
    | '/_app/projects/new'
    | '/_app/supplier/$orgId'
    | '/_app/supplier/register'
    | '/organizations/invitations/accept'
    | '/_app/land/'
    | '/_app/marketplace/'
    | '/_app/me/'
    | '/_app/messages/'
    | '/_app/onboarding/'
    | '/_app/projects/'
    | '/_app/marketplace/prices/$productId'
    | '/_app/marketplace/suppliers/$orgId'
    | '/_app/marketplace/workers/$workerId'
    | '/_app/marketplace/workers/requests'
    | '/_app/me/services/applications'
    | '/_app/me/services/invitations'
    | '/_app/me/services/openings'
    | '/_app/me/work/certificates'
    | '/_app/me/work/jobs'
    | '/_app/me/work/listing'
    | '/_app/me/work/requests'
    | '/_app/me/work/reviews'
    | '/_app/org/$orgId/approval-rules'
    | '/_app/org/$orgId/audit'
    | '/_app/org/$orgId/billing'
    | '/_app/org/$orgId/clients'
    | '/_app/org/$orgId/fees'
    | '/_app/org/$orgId/integrations'
    | '/_app/org/$orgId/jobs'
    | '/_app/org/$orgId/members'
    | '/_app/org/$orgId/overview'
    | '/_app/org/$orgId/portfolio'
    | '/_app/org/$orgId/profile'
    | '/_app/org/$orgId/projects'
    | '/_app/org/$orgId/roles'
    | '/_app/org/$orgId/settings'
    | '/_app/org/$orgId/shortlist'
    | '/_app/org/$orgId/templates'
    | '/_app/org/$orgId/workload'
    | '/_app/projects/$projectId/closeout'
    | '/_app/projects/$projectId/commercial'
    | '/_app/projects/$projectId/cost'
    | '/_app/projects/$projectId/decisions'
    | '/_app/projects/$projectId/design'
    | '/_app/projects/$projectId/documents'
    | '/_app/projects/$projectId/handover'
    | '/_app/projects/$projectId/hiring'
    | '/_app/projects/$projectId/insights'
    | '/_app/projects/$projectId/overview'
    | '/_app/projects/$projectId/owner-plan'
    | '/_app/projects/$projectId/plan'
    | '/_app/projects/$projectId/procurement'
    | '/_app/projects/$projectId/quality'
    | '/_app/projects/$projectId/resources'
    | '/_app/projects/$projectId/risks'
    | '/_app/projects/$projectId/safety'
    | '/_app/projects/$projectId/settings'
    | '/_app/projects/$projectId/site'
    | '/_app/projects/$projectId/subcontracts'
    | '/_app/projects/$projectId/team'
    | '/_app/projects/$projectId/timeline'
    | '/_app/projects/$projectId/workforce'
    | '/_app/supplier/$orgId/analytics'
    | '/_app/supplier/$orgId/billing'
    | '/_app/supplier/$orgId/branches'
    | '/_app/supplier/$orgId/catalog'
    | '/_app/supplier/$orgId/dashboard'
    | '/_app/supplier/$orgId/deliveries'
    | '/_app/supplier/$orgId/invoices'
    | '/_app/supplier/$orgId/notifications'
    | '/_app/supplier/$orgId/payments'
    | '/_app/supplier/$orgId/profile'
    | '/_app/supplier/$orgId/public'
    | '/_app/supplier/$orgId/quotes'
    | '/_app/supplier/$orgId/team'
    | '/_app/land/sell/'
    | '/_app/marketplace/prices/'
    | '/_app/marketplace/suppliers/'
    | '/_app/marketplace/workers/'
    | '/_app/me/services/'
    | '/_app/me/work/'
    | '/_app/org/$orgId/'
    | '/_app/projects/$projectId/'
    | '/_app/supplier/$orgId/'
    | '/_app/me/services/jobs/$jobId'
    | '/_app/me/services/quotes/$responseId'
    | '/_app/me/services/tenders/$packageId'
    | '/_app/org/$orgId/reports/$reportKey'
    | '/_app/org/$orgId/tenders/$packageId'
    | '/_app/projects/$projectId/closeout/overview'
    | '/_app/projects/$projectId/closeout/warranty'
    | '/_app/projects/$projectId/commercial/certificates'
    | '/_app/projects/$projectId/commercial/claims'
    | '/_app/projects/$projectId/commercial/contract'
    | '/_app/projects/$projectId/commercial/cost-control'
    | '/_app/projects/$projectId/commercial/cost-plans'
    | '/_app/projects/$projectId/commercial/final-account'
    | '/_app/projects/$projectId/commercial/overview'
    | '/_app/projects/$projectId/commercial/payments'
    | '/_app/projects/$projectId/commercial/retention'
    | '/_app/projects/$projectId/commercial/sums'
    | '/_app/projects/$projectId/commercial/variations'
    | '/_app/projects/$projectId/cost/expenses'
    | '/_app/projects/$projectId/cost/materials-on-site'
    | '/_app/projects/$projectId/cost/overview'
    | '/_app/projects/$projectId/cost/variations'
    | '/_app/projects/$projectId/decisions/change-requests'
    | '/_app/projects/$projectId/decisions/selections'
    | '/_app/projects/$projectId/design/compare'
    | '/_app/projects/$projectId/design/completion'
    | '/_app/projects/$projectId/design/coordination'
    | '/_app/projects/$projectId/design/deliverables'
    | '/_app/projects/$projectId/design/drawings'
    | '/_app/projects/$projectId/design/overview'
    | '/_app/projects/$projectId/design/rfis'
    | '/_app/projects/$projectId/design/site-visits'
    | '/_app/projects/$projectId/design/specifications'
    | '/_app/projects/$projectId/design/submittals'
    | '/_app/projects/$projectId/design/transmittals'
    | '/_app/projects/$projectId/insights/flags'
    | '/_app/projects/$projectId/insights/forecast'
    | '/_app/projects/$projectId/labour-evidence/timesheets'
    | '/_app/projects/$projectId/plan/baselines'
    | '/_app/projects/$projectId/plan/constraints'
    | '/_app/projects/$projectId/plan/lookahead'
    | '/_app/projects/$projectId/plan/milestones'
    | '/_app/projects/$projectId/plan/stages'
    | '/_app/projects/$projectId/plan/tasks'
    | '/_app/projects/$projectId/plan/weekly-plans'
    | '/_app/projects/$projectId/plan/zones'
    | '/_app/projects/$projectId/procurement/cart'
    | '/_app/projects/$projectId/procurement/deliveries'
    | '/_app/projects/$projectId/procurement/invoices'
    | '/_app/projects/$projectId/procurement/requisitions'
    | '/_app/projects/$projectId/quality/checklists'
    | '/_app/projects/$projectId/quality/ncrs'
    | '/_app/projects/$projectId/quality/rectifications'
    | '/_app/projects/$projectId/quality/snags'
    | '/_app/projects/$projectId/quality/tests'
    | '/_app/projects/$projectId/reports/$reportKey'
    | '/_app/projects/$projectId/resources/equipment'
    | '/_app/projects/$projectId/resources/equipment-requests'
    | '/_app/projects/$projectId/resources/requests'
    | '/_app/projects/$projectId/resources/store'
    | '/_app/projects/$projectId/resources/submittals'
    | '/_app/projects/$projectId/safety/incidents'
    | '/_app/projects/$projectId/safety/overview'
    | '/_app/projects/$projectId/safety/ppe'
    | '/_app/projects/$projectId/safety/toolbox'
    | '/_app/projects/$projectId/site/attendance'
    | '/_app/projects/$projectId/site/daily-plan'
    | '/_app/projects/$projectId/site/day-close'
    | '/_app/projects/$projectId/site/diary'
    | '/_app/projects/$projectId/site/instructions'
    | '/_app/projects/$projectId/site/issues'
    | '/_app/projects/$projectId/site/meetings'
    | '/_app/projects/$projectId/site/photos'
    | '/_app/projects/$projectId/site/progress'
    | '/_app/projects/$projectId/site/today'
    | '/_app/projects/$projectId/site/visitors'
    | '/_app/projects/$projectId/subcontracts/changes'
    | '/_app/projects/$projectId/subcontracts/consents'
    | '/_app/projects/$projectId/subcontracts/daily-reports'
    | '/_app/projects/$projectId/subcontracts/overview'
    | '/_app/projects/$projectId/subcontracts/own-stock'
    | '/_app/projects/$projectId/subcontracts/payments'
    | '/_app/projects/$projectId/subcontracts/purchases'
    | '/_app/projects/$projectId/tenders/$packageId'
    | '/_app/projects/$projectId/timeline/activity'
    | '/_app/projects/$projectId/timeline/photos'
    | '/_app/projects/$projectId/workforce/crews'
    | '/_app/projects/$projectId/workforce/productivity'
    | '/_app/projects/$projectId/workforce/timesheets'
    | '/_app/supplier/$orgId/customers/$customerId'
    | '/_app/supplier/$orgId/messages/$conversationId'
    | '/_app/supplier/$orgId/orders/$poId'
    | '/_app/supplier/$orgId/rfqs/$rfqId'
    | '/print/org/$orgId/reports/$reportKey'
    | '/print/projects/$projectId/certificates/$certificateId'
    | '/print/projects/$projectId/reports/$reportKey'
    | '/print/projects/$projectId/site-visits/$visitId'
    | '/_app/land/sell/$orgId/'
    | '/_app/me/services/jobs/'
    | '/_app/me/services/quotes/'
    | '/_app/me/services/tenders/'
    | '/_app/org/$orgId/reports/'
    | '/_app/org/$orgId/tenders/'
    | '/_app/projects/$projectId/closeout/'
    | '/_app/projects/$projectId/commercial/'
    | '/_app/projects/$projectId/cost/'
    | '/_app/projects/$projectId/decisions/'
    | '/_app/projects/$projectId/design/'
    | '/_app/projects/$projectId/hiring/'
    | '/_app/projects/$projectId/insights/'
    | '/_app/projects/$projectId/labour-evidence/'
    | '/_app/projects/$projectId/plan/'
    | '/_app/projects/$projectId/procurement/'
    | '/_app/projects/$projectId/quality/'
    | '/_app/projects/$projectId/reports/'
    | '/_app/projects/$projectId/resources/'
    | '/_app/projects/$projectId/safety/'
    | '/_app/projects/$projectId/site/'
    | '/_app/projects/$projectId/subcontracts/'
    | '/_app/projects/$projectId/tenders/'
    | '/_app/projects/$projectId/timeline/'
    | '/_app/projects/$projectId/workforce/'
    | '/_app/supplier/$orgId/customers/'
    | '/_app/supplier/$orgId/messages/'
    | '/_app/supplier/$orgId/orders/'
    | '/_app/supplier/$orgId/rfqs/'
    | '/_app/land/sell/$orgId/listings/$listingId'
    | '/_app/projects/$projectId/commercial/measure/$valuationId'
    | '/_app/projects/$projectId/commercial/valuations/$valuationId'
    | '/_app/projects/$projectId/cost/boq/$boqId'
    | '/_app/projects/$projectId/cost/scans/$extractionId'
    | '/_app/projects/$projectId/hiring/jobs/$jobId'
    | '/_app/projects/$projectId/hiring/openings/$openingId'
    | '/_app/projects/$projectId/hiring/quotes/$quoteId'
    | '/_app/projects/$projectId/insights/weekly/$summaryId'
    | '/_app/projects/$projectId/labour-evidence/payroll/$runId'
    | '/_app/projects/$projectId/procurement/orders/$poId'
    | '/_app/projects/$projectId/procurement/rfqs/$rfqId'
    | '/_app/projects/$projectId/procurement/shop/$orgId'
    | '/_app/projects/$projectId/quality/inspections/$inspectionId'
    | '/_app/projects/$projectId/safety/walks/$inspectionId'
    | '/_app/projects/$projectId/subcontracts/contracts/$subcontractId'
    | '/_app/projects/$projectId/subcontracts/packages/$packageId'
    | '/_app/projects/$projectId/workforce/crew/$engagementId'
    | '/_app/projects/$projectId/workforce/payroll/$runId'
    | '/_app/projects/$projectId/commercial/valuations/'
    | '/_app/projects/$projectId/cost/boq/'
    | '/_app/projects/$projectId/cost/scans/'
    | '/_app/projects/$projectId/hiring/jobs/'
    | '/_app/projects/$projectId/hiring/openings/'
    | '/_app/projects/$projectId/hiring/quotes/'
    | '/_app/projects/$projectId/insights/weekly/'
    | '/_app/projects/$projectId/labour-evidence/payroll/'
    | '/_app/projects/$projectId/procurement/orders/'
    | '/_app/projects/$projectId/procurement/rfqs/'
    | '/_app/projects/$projectId/procurement/shop/'
    | '/_app/projects/$projectId/quality/inspections/'
    | '/_app/projects/$projectId/safety/walks/'
    | '/_app/projects/$projectId/subcontracts/packages/'
    | '/_app/projects/$projectId/workforce/crew/'
    | '/_app/projects/$projectId/workforce/payroll/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  SignedOutRoute: typeof SignedOutRoute
  SigninRoute: typeof SigninRoute
  ViewAsRoute: typeof ViewAsRoute
  AuthAdminSigninRoute: typeof AuthAdminSigninRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  CSlugRoute: typeof CSlugRoute
  InvitationsAcceptRoute: typeof InvitationsAcceptRoute
  PSlugRoute: typeof PSlugRoute
  TendersAcceptRoute: typeof TendersAcceptRoute
  OrganizationsInvitationsAcceptRoute: typeof OrganizationsInvitationsAcceptRoute
  PrintOrgOrgIdReportsReportKeyRoute: typeof PrintOrgOrgIdReportsReportKeyRoute
  PrintProjectsProjectIdCertificatesCertificateIdRoute: typeof PrintProjectsProjectIdCertificatesCertificateIdRoute
  PrintProjectsProjectIdReportsReportKeyRoute: typeof PrintProjectsProjectIdReportsReportKeyRoute
  PrintProjectsProjectIdSiteVisitsVisitIdRoute: typeof PrintProjectsProjectIdSiteVisitsVisitIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signed-out': {
      id: '/signed-out'
      path: '/signed-out'
      fullPath: '/signed-out'
      preLoaderRoute: typeof SignedOutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/view-as': {
      id: '/view-as'
      path: '/view-as'
      fullPath: '/view-as'
      preLoaderRoute: typeof ViewAsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/account': {
      id: '/_app/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AppAccountRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/approvals': {
      id: '/_app/approvals'
      path: '/approvals'
      fullPath: '/approvals'
      preLoaderRoute: typeof AppApprovalsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/companies': {
      id: '/_app/companies'
      path: '/companies'
      fullPath: '/companies'
      preLoaderRoute: typeof AppCompaniesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/directory': {
      id: '/_app/directory'
      path: '/directory'
      fullPath: '/directory'
      preLoaderRoute: typeof AppDirectoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/home': {
      id: '/_app/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AppHomeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me': {
      id: '/_app/me'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof AppMeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notifications': {
      id: '/_app/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders': {
      id: '/_app/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof AppOrdersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/portfolio': {
      id: '/_app/portfolio'
      path: '/portfolio'
      fullPath: '/portfolio'
      preLoaderRoute: typeof AppPortfolioRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/support': {
      id: '/_app/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof AppSupportRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sync': {
      id: '/_app/sync'
      path: '/sync'
      fullPath: '/sync'
      preLoaderRoute: typeof AppSyncRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/admin-signin': {
      id: '/auth/admin-signin'
      path: '/auth/admin-signin'
      fullPath: '/auth/admin-signin'
      preLoaderRoute: typeof AuthAdminSigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/c/$slug': {
      id: '/c/$slug'
      path: '/c/$slug'
      fullPath: '/c/$slug'
      preLoaderRoute: typeof CSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invitations/accept': {
      id: '/invitations/accept'
      path: '/invitations/accept'
      fullPath: '/invitations/accept'
      preLoaderRoute: typeof InvitationsAcceptRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/$slug': {
      id: '/p/$slug'
      path: '/p/$slug'
      fullPath: '/p/$slug'
      preLoaderRoute: typeof PSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tenders/accept': {
      id: '/tenders/accept'
      path: '/tenders/accept'
      fullPath: '/tenders/accept'
      preLoaderRoute: typeof TendersAcceptRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/account/accounting': {
      id: '/_app/account/accounting'
      path: '/accounting'
      fullPath: '/account/accounting'
      preLoaderRoute: typeof AppAccountAccountingRouteImport
      parentRoute: typeof AppAccountRoute
    }
    '/_app/account/approval-rules': {
      id: '/_app/account/approval-rules'
      path: '/approval-rules'
      fullPath: '/account/approval-rules'
      preLoaderRoute: typeof AppAccountApprovalRulesRouteImport
      parentRoute: typeof AppAccountRoute
    }
    '/_app/account/shortlist': {
      id: '/_app/account/shortlist'
      path: '/shortlist'
      fullPath: '/account/shortlist'
      preLoaderRoute: typeof AppAccountShortlistRouteImport
      parentRoute: typeof AppAccountRoute
    }
    '/_app/billing/return': {
      id: '/_app/billing/return'
      path: '/billing/return'
      fullPath: '/billing/return'
      preLoaderRoute: typeof AppBillingReturnRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/land/': {
      id: '/_app/land/'
      path: '/land'
      fullPath: '/land/'
      preLoaderRoute: typeof AppLandIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/land/$listingId': {
      id: '/_app/land/$listingId'
      path: '/land/$listingId'
      fullPath: '/land/$listingId'
      preLoaderRoute: typeof AppLandListingIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/land/enquiries': {
      id: '/_app/land/enquiries'
      path: '/land/enquiries'
      fullPath: '/land/enquiries'
      preLoaderRoute: typeof AppLandEnquiriesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketplace/': {
      id: '/_app/marketplace/'
      path: '/marketplace'
      fullPath: '/marketplace/'
      preLoaderRoute: typeof AppMarketplaceIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketplace/labour-rates': {
      id: '/_app/marketplace/labour-rates'
      path: '/marketplace/labour-rates'
      fullPath: '/marketplace/labour-rates'
      preLoaderRoute: typeof AppMarketplaceLabourRatesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketplace/professionals': {
      id: '/_app/marketplace/professionals'
      path: '/marketplace/professionals'
      fullPath: '/marketplace/professionals'
      preLoaderRoute: typeof AppMarketplaceProfessionalsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me/': {
      id: '/_app/me/'
      path: '/'
      fullPath: '/me/'
      preLoaderRoute: typeof AppMeIndexRouteImport
      parentRoute: typeof AppMeRoute
    }
    '/_app/me/attendance': {
      id: '/_app/me/attendance'
      path: '/attendance'
      fullPath: '/me/attendance'
      preLoaderRoute: typeof AppMeAttendanceRouteImport
      parentRoute: typeof AppMeRoute
    }
    '/_app/me/earnings': {
      id: '/_app/me/earnings'
      path: '/earnings'
      fullPath: '/me/earnings'
      preLoaderRoute: typeof AppMeEarningsRouteImport
      parentRoute: typeof AppMeRoute
    }
    '/_app/me/profile': {
      id: '/_app/me/profile'
      path: '/profile'
      fullPath: '/me/profile'
      preLoaderRoute: typeof AppMeProfileRouteImport
      parentRoute: typeof AppMeRoute
    }
    '/_app/messages/': {
      id: '/_app/messages/'
      path: '/messages'
      fullPath: '/messages/'
      preLoaderRoute: typeof AppMessagesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/messages/$conversationId': {
      id: '/_app/messages/$conversationId'
      path: '/messages/$conversationId'
      fullPath: '/messages/$conversationId'
      preLoaderRoute: typeof AppMessagesConversationIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/onboarding/': {
      id: '/_app/onboarding/'
      path: '/onboarding'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof AppOnboardingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/onboarding/$flow': {
      id: '/_app/onboarding/$flow'
      path: '/onboarding/$flow'
      fullPath: '/onboarding/$flow'
      preLoaderRoute: typeof AppOnboardingFlowRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/org/$orgId': {
      id: '/_app/org/$orgId'
      path: '/org/$orgId'
      fullPath: '/org/$orgId'
      preLoaderRoute: typeof AppOrgOrgIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/org/new': {
      id: '/_app/org/new'
      path: '/org/new'
      fullPath: '/org/new'
      preLoaderRoute: typeof AppOrgNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/': {
      id: '/_app/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AppProjectsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$projectId': {
      id: '/_app/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof AppProjectsProjectIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/new': {
      id: '/_app/projects/new'
      path: '/projects/new'
      fullPath: '/projects/new'
      preLoaderRoute: typeof AppProjectsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/supplier/$orgId': {
      id: '/_app/supplier/$orgId'
      path: '/supplier/$orgId'
      fullPath: '/supplier/$orgId'
      preLoaderRoute: typeof AppSupplierOrgIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/supplier/register': {
      id: '/_app/supplier/register'
      path: '/supplier/register'
      fullPath: '/supplier/register'
      preLoaderRoute: typeof AppSupplierRegisterRouteImport
      parentRoute: typeof AppRoute
    }
    '/organizations/invitations/accept': {
      id: '/organizations/invitations/accept'
      path: '/organizations/invitations/accept'
      fullPath: '/organizations/invitations/accept'
      preLoaderRoute: typeof OrganizationsInvitationsAcceptRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/land/sell/': {
      id: '/_app/land/sell/'
      path: '/land/sell'
      fullPath: '/land/sell/'
      preLoaderRoute: typeof AppLandSellIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketplace/prices/': {
      id: '/_app/marketplace/prices/'
      path: '/marketplace/prices'
      fullPath: '/marketplace/prices/'
      preLoaderRoute: typeof AppMarketplacePricesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketplace/prices/$productId': {
      id: '/_app/marketplace/prices/$productId'
      path: '/marketplace/prices/$productId'
      fullPath: '/marketplace/prices/$productId'
      preLoaderRoute: typeof AppMarketplacePricesProductIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketplace/suppliers/': {
      id: '/_app/marketplace/suppliers/'
      path: '/marketplace/suppliers'
      fullPath: '/marketplace/suppliers/'
      preLoaderRoute: typeof AppMarketplaceSuppliersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketplace/suppliers/$orgId': {
      id: '/_app/marketplace/suppliers/$orgId'
      path: '/marketplace/suppliers/$orgId'
      fullPath: '/marketplace/suppliers/$orgId'
      preLoaderRoute: typeof AppMarketplaceSuppliersOrgIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketplace/workers/': {
      id: '/_app/marketplace/workers/'
      path: '/marketplace/workers'
      fullPath: '/marketplace/workers/'
      preLoaderRoute: typeof AppMarketplaceWorkersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketplace/workers/$workerId': {
      id: '/_app/marketplace/workers/$workerId'
      path: '/marketplace/workers/$workerId'
      fullPath: '/marketplace/workers/$workerId'
      preLoaderRoute: typeof AppMarketplaceWorkersWorkerIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketplace/workers/requests': {
      id: '/_app/marketplace/workers/requests'
      path: '/marketplace/workers/requests'
      fullPath: '/marketplace/workers/requests'
      preLoaderRoute: typeof AppMarketplaceWorkersRequestsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me/services/': {
      id: '/_app/me/services/'
      path: '/services'
      fullPath: '/me/services/'
      preLoaderRoute: typeof AppMeServicesIndexRouteImport
      parentRoute: typeof AppMeRoute
    }
    '/_app/me/services/applications': {
      id: '/_app/me/services/applications'
      path: '/services/applications'
      fullPath: '/me/services/applications'
      preLoaderRoute: typeof AppMeServicesApplicationsRouteImport
      parentRoute: typeof AppMeRoute
    }
    '/_app/me/services/invitations': {
      id: '/_app/me/services/invitations'
      path: '/services/invitations'
      fullPath: '/me/services/invitations'
      preLoaderRoute: typeof AppMeServicesInvitationsRouteImport
      parentRoute: typeof AppMeRoute
    }
    '/_app/me/services/openings': {
      id: '/_app/me/services/openings'
      path: '/services/openings'
      fullPath: '/me/services/openings'
      preLoaderRoute: typeof AppMeServicesOpeningsRouteImport
      parentRoute: typeof AppMeRoute
    }
    '/_app/me/work/': {
      id: '/_app/me/work/'
      path: '/work'
      fullPath: '/me/work/'
      preLoaderRoute: typeof AppMeWorkIndexRouteImport
      parentRoute: typeof AppMeRoute
    }
    '/_app/me/work/certificates': {
      id: '/_app/me/work/certificates'
      path: '/work/certificates'
      fullPath: '/me/work/certificates'
      preLoaderRoute: typeof AppMeWorkCertificatesRouteImport
      parentRoute: typeof AppMeRoute
    }
    '/_app/me/work/jobs': {
      id: '/_app/me/work/jobs'
      path: '/work/jobs'
      fullPath: '/me/work/jobs'
      preLoaderRoute: typeof AppMeWorkJobsRouteImport
      parentRoute: typeof AppMeRoute
    }
    '/_app/me/work/listing': {
      id: '/_app/me/work/listing'
      path: '/work/listing'
      fullPath: '/me/work/listing'
      preLoaderRoute: typeof AppMeWorkListingRouteImport
      parentRoute: typeof AppMeRoute
    }
    '/_app/me/work/requests': {
      id: '/_app/me/work/requests'
      path: '/work/requests'
      fullPath: '/me/work/requests'
      preLoaderRoute: typeof AppMeWorkRequestsRouteImport
      parentRoute: typeof AppMeRoute
    }
    '/_app/me/work/reviews': {
      id: '/_app/me/work/reviews'
      path: '/work/reviews'
      fullPath: '/me/work/reviews'
      preLoaderRoute: typeof AppMeWorkReviewsRouteImport
      parentRoute: typeof AppMeRoute
    }
    '/_app/org/$orgId/': {
      id: '/_app/org/$orgId/'
      path: '/'
      fullPath: '/org/$orgId/'
      preLoaderRoute: typeof AppOrgOrgIdIndexRouteImport
      parentRoute: typeof AppOrgOrgIdRoute
    }
    '/_app/org/$orgId/approval-rules': {
      id: '/_app/org/$orgId/approval-rules'
      path: '/approval-rules'
      fullPath: '/org/$orgId/approval-rules'
      preLoaderRoute: typeof AppOrgOrgIdApprovalRulesRouteImport
      parentRoute: typeof AppOrgOrgIdRoute
    }
    '/_app/org/$orgId/audit': {
      id: '/_app/org/$orgId/audit'
      path: '/audit'
      fullPath: '/org/$orgId/audit'
      preLoaderRoute: typeof AppOrgOrgIdAuditRouteImport
      parentRoute: typeof AppOrgOrgIdRoute
    }
    '/_app/org/$orgId/billing': {
      id: '/_app/org/$orgId/billing'
      path: '/billing'
      fullPath: '/org/$orgId/billing'
      preLoaderRoute: typeof AppOrgOrgIdBillingRouteImport
      parentRoute: typeof AppOrgOrgIdRoute
    }
    '/_app/org/$orgId/clients': {
      id: '/_app/org/$orgId/clients'
      path: '/clients'
      fullPath: '/org/$orgId/clients'
      preLoaderRoute: typeof AppOrgOrgIdClientsRouteImport
      parentRoute: typeof AppOrgOrgIdRoute
    }
    '/_app/org/$orgId/fees': {
      id: '/_app/org/$orgId/fees'
      path: '/fees'
      fullPath: '/org/$orgId/fees'
      preLoaderRoute: typeof AppOrgOrgIdFeesRouteImport
      parentRoute: typeof AppOrgOrgIdRoute
    }
    '/_app/org/$orgId/integrations': {
      id: '/_app/org/$orgId/integrations'
      path: '/integrations'
      fullPath: '/org/$orgId/integrations'
      preLoaderRoute: typeof AppOrgOrgIdIntegrationsRouteImport
      parentRoute: typeof AppOrgOrgIdRoute
    }
    '/_app/org/$orgId/jobs': {
      id: '/_app/org/$orgId/jobs'
      path: '/jobs'
      fullPath: '/org/$orgId/jobs'
      preLoaderRoute: typeof AppOrgOrgIdJobsRouteImport
      parentRoute: typeof AppOrgOrgIdRoute
    }
    '/_app/org/$orgId/members': {
      id: '/_app/org/$orgId/members'
      path: '/members'
      fullPath: '/org/$orgId/members'
      preLoaderRoute: typeof AppOrgOrgIdMembersRouteImport
      parentRoute: typeof AppOrgOrgIdRoute
    }
    '/_app/org/$orgId/overview': {
      id: '/_app/org/$orgId/overview'
      path: '/overview'
      fullPath: '/org/$orgId/overview'
      preLoaderRoute: typeof AppOrgOrgIdOverviewRouteImport
      parentRoute: typeof AppOrgOrgIdRoute
    }
    '/_app/org/$orgId/portfolio': {
      id: '/_app/org/$orgId/portfolio'
      path: '/portfolio'
      fullPath: '/org/$orgId/portfolio'
      preLoaderRoute: typeof AppOrgOrgIdPortfolioRouteImport
      parentRoute: typeof AppOrgOrgIdRoute
    }
    '/_app/org/$orgId/profile': {
      id: '/_app/org/$orgId/profile'
      path: '/profile'
      fullPath: '/org/$orgId/profile'
      preLoaderRoute: typeof AppOrgOrgIdProfileRouteImport
      parentRoute: typeof AppOrgOrgIdRoute
    }
    '/_app/org/$orgId/projects': {
      id: '/_app/org/$orgId/projects'
      path: '/projects'
      fullPath: '/org/$orgId/projects'
      preLoaderRoute: typeof AppOrgOrgIdProjectsRouteImport
      parentRoute: typeof AppOrgOrgIdRoute
    }
    '/_app/org/$orgId/roles': {
      id: '/_app/org/$orgId/roles'
      path: '/roles'
      fullPath: '/org/$orgId/roles'
      preLoaderRoute: typeof AppOrgOrgIdRolesRouteImport
      parentRoute: typeof AppOrgOrgIdRoute
    }
    '/_app/org/$orgId/settings': {
      id: '/_app/org/$orgId/settings'
      path: '/settings'
      fullPath: '/org/$orgId/settings'
      preLoaderRoute: typeof AppOrgOrgIdSettingsRouteImport
      parentRoute: typeof AppOrgOrgIdRoute
    }
    '/_app/org/$orgId/shortlist': {
      id: '/_app/org/$orgId/shortlist'
      path: '/shortlist'
      fullPath: '/org/$orgId/shortlist'
      preLoaderRoute: typeof AppOrgOrgIdShortlistRouteImport
      parentRoute: typeof AppOrgOrgIdRoute
    }
    '/_app/org/$orgId/templates': {
      id: '/_app/org/$orgId/templates'
      path: '/templates'
      fullPath: '/org/$orgId/templates'
      preLoaderRoute: typeof AppOrgOrgIdTemplatesRouteImport
      parentRoute: typeof AppOrgOrgIdRoute
    }
    '/_app/org/$orgId/workload': {
      id: '/_app/org/$orgId/workload'
      path: '/workload'
      fullPath: '/org/$orgId/workload'
      preLoaderRoute: typeof AppOrgOrgIdWorkloadRouteImport
      parentRoute: typeof AppOrgOrgIdRoute
    }
    '/_app/projects/$projectId/': {
      id: '/_app/projects/$projectId/'
      path: '/'
      fullPath: '/projects/$projectId/'
      preLoaderRoute: typeof AppProjectsProjectIdIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/closeout': {
      id: '/_app/projects/$projectId/closeout'
      path: '/closeout'
      fullPath: '/projects/$projectId/closeout'
      preLoaderRoute: typeof AppProjectsProjectIdCloseoutRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/commercial': {
      id: '/_app/projects/$projectId/commercial'
      path: '/commercial'
      fullPath: '/projects/$projectId/commercial'
      preLoaderRoute: typeof AppProjectsProjectIdCommercialRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/cost': {
      id: '/_app/projects/$projectId/cost'
      path: '/cost'
      fullPath: '/projects/$projectId/cost'
      preLoaderRoute: typeof AppProjectsProjectIdCostRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/decisions': {
      id: '/_app/projects/$projectId/decisions'
      path: '/decisions'
      fullPath: '/projects/$projectId/decisions'
      preLoaderRoute: typeof AppProjectsProjectIdDecisionsRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/design': {
      id: '/_app/projects/$projectId/design'
      path: '/design'
      fullPath: '/projects/$projectId/design'
      preLoaderRoute: typeof AppProjectsProjectIdDesignRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/documents': {
      id: '/_app/projects/$projectId/documents'
      path: '/documents'
      fullPath: '/projects/$projectId/documents'
      preLoaderRoute: typeof AppProjectsProjectIdDocumentsRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/handover': {
      id: '/_app/projects/$projectId/handover'
      path: '/handover'
      fullPath: '/projects/$projectId/handover'
      preLoaderRoute: typeof AppProjectsProjectIdHandoverRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/hiring': {
      id: '/_app/projects/$projectId/hiring'
      path: '/hiring'
      fullPath: '/projects/$projectId/hiring'
      preLoaderRoute: typeof AppProjectsProjectIdHiringRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/insights': {
      id: '/_app/projects/$projectId/insights'
      path: '/insights'
      fullPath: '/projects/$projectId/insights'
      preLoaderRoute: typeof AppProjectsProjectIdInsightsRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/overview': {
      id: '/_app/projects/$projectId/overview'
      path: '/overview'
      fullPath: '/projects/$projectId/overview'
      preLoaderRoute: typeof AppProjectsProjectIdOverviewRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/owner-plan': {
      id: '/_app/projects/$projectId/owner-plan'
      path: '/owner-plan'
      fullPath: '/projects/$projectId/owner-plan'
      preLoaderRoute: typeof AppProjectsProjectIdOwnerPlanRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/plan': {
      id: '/_app/projects/$projectId/plan'
      path: '/plan'
      fullPath: '/projects/$projectId/plan'
      preLoaderRoute: typeof AppProjectsProjectIdPlanRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/procurement': {
      id: '/_app/projects/$projectId/procurement'
      path: '/procurement'
      fullPath: '/projects/$projectId/procurement'
      preLoaderRoute: typeof AppProjectsProjectIdProcurementRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/quality': {
      id: '/_app/projects/$projectId/quality'
      path: '/quality'
      fullPath: '/projects/$projectId/quality'
      preLoaderRoute: typeof AppProjectsProjectIdQualityRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/resources': {
      id: '/_app/projects/$projectId/resources'
      path: '/resources'
      fullPath: '/projects/$projectId/resources'
      preLoaderRoute: typeof AppProjectsProjectIdResourcesRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/risks': {
      id: '/_app/projects/$projectId/risks'
      path: '/risks'
      fullPath: '/projects/$projectId/risks'
      preLoaderRoute: typeof AppProjectsProjectIdRisksRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/safety': {
      id: '/_app/projects/$projectId/safety'
      path: '/safety'
      fullPath: '/projects/$projectId/safety'
      preLoaderRoute: typeof AppProjectsProjectIdSafetyRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/settings': {
      id: '/_app/projects/$projectId/settings'
      path: '/settings'
      fullPath: '/projects/$projectId/settings'
      preLoaderRoute: typeof AppProjectsProjectIdSettingsRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/site': {
      id: '/_app/projects/$projectId/site'
      path: '/site'
      fullPath: '/projects/$projectId/site'
      preLoaderRoute: typeof AppProjectsProjectIdSiteRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/subcontracts': {
      id: '/_app/projects/$projectId/subcontracts'
      path: '/subcontracts'
      fullPath: '/projects/$projectId/subcontracts'
      preLoaderRoute: typeof AppProjectsProjectIdSubcontractsRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/team': {
      id: '/_app/projects/$projectId/team'
      path: '/team'
      fullPath: '/projects/$projectId/team'
      preLoaderRoute: typeof AppProjectsProjectIdTeamRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/timeline': {
      id: '/_app/projects/$projectId/timeline'
      path: '/timeline'
      fullPath: '/projects/$projectId/timeline'
      preLoaderRoute: typeof AppProjectsProjectIdTimelineRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/workforce': {
      id: '/_app/projects/$projectId/workforce'
      path: '/workforce'
      fullPath: '/projects/$projectId/workforce'
      preLoaderRoute: typeof AppProjectsProjectIdWorkforceRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/supplier/$orgId/': {
      id: '/_app/supplier/$orgId/'
      path: '/'
      fullPath: '/supplier/$orgId/'
      preLoaderRoute: typeof AppSupplierOrgIdIndexRouteImport
      parentRoute: typeof AppSupplierOrgIdRoute
    }
    '/_app/supplier/$orgId/analytics': {
      id: '/_app/supplier/$orgId/analytics'
      path: '/analytics'
      fullPath: '/supplier/$orgId/analytics'
      preLoaderRoute: typeof AppSupplierOrgIdAnalyticsRouteImport
      parentRoute: typeof AppSupplierOrgIdRoute
    }
    '/_app/supplier/$orgId/billing': {
      id: '/_app/supplier/$orgId/billing'
      path: '/billing'
      fullPath: '/supplier/$orgId/billing'
      preLoaderRoute: typeof AppSupplierOrgIdBillingRouteImport
      parentRoute: typeof AppSupplierOrgIdRoute
    }
    '/_app/supplier/$orgId/branches': {
      id: '/_app/supplier/$orgId/branches'
      path: '/branches'
      fullPath: '/supplier/$orgId/branches'
      preLoaderRoute: typeof AppSupplierOrgIdBranchesRouteImport
      parentRoute: typeof AppSupplierOrgIdRoute
    }
    '/_app/supplier/$orgId/catalog': {
      id: '/_app/supplier/$orgId/catalog'
      path: '/catalog'
      fullPath: '/supplier/$orgId/catalog'
      preLoaderRoute: typeof AppSupplierOrgIdCatalogRouteImport
      parentRoute: typeof AppSupplierOrgIdRoute
    }
    '/_app/supplier/$orgId/dashboard': {
      id: '/_app/supplier/$orgId/dashboard'
      path: '/dashboard'
      fullPath: '/supplier/$orgId/dashboard'
      preLoaderRoute: typeof AppSupplierOrgIdDashboardRouteImport
      parentRoute: typeof AppSupplierOrgIdRoute
    }
    '/_app/supplier/$orgId/deliveries': {
      id: '/_app/supplier/$orgId/deliveries'
      path: '/deliveries'
      fullPath: '/supplier/$orgId/deliveries'
      preLoaderRoute: typeof AppSupplierOrgIdDeliveriesRouteImport
      parentRoute: typeof AppSupplierOrgIdRoute
    }
    '/_app/supplier/$orgId/invoices': {
      id: '/_app/supplier/$orgId/invoices'
      path: '/invoices'
      fullPath: '/supplier/$orgId/invoices'
      preLoaderRoute: typeof AppSupplierOrgIdInvoicesRouteImport
      parentRoute: typeof AppSupplierOrgIdRoute
    }
    '/_app/supplier/$orgId/notifications': {
      id: '/_app/supplier/$orgId/notifications'
      path: '/notifications'
      fullPath: '/supplier/$orgId/notifications'
      preLoaderRoute: typeof AppSupplierOrgIdNotificationsRouteImport
      parentRoute: typeof AppSupplierOrgIdRoute
    }
    '/_app/supplier/$orgId/payments': {
      id: '/_app/supplier/$orgId/payments'
      path: '/payments'
      fullPath: '/supplier/$orgId/payments'
      preLoaderRoute: typeof AppSupplierOrgIdPaymentsRouteImport
      parentRoute: typeof AppSupplierOrgIdRoute
    }
    '/_app/supplier/$orgId/profile': {
      id: '/_app/supplier/$orgId/profile'
      path: '/profile'
      fullPath: '/supplier/$orgId/profile'
      preLoaderRoute: typeof AppSupplierOrgIdProfileRouteImport
      parentRoute: typeof AppSupplierOrgIdRoute
    }
    '/_app/supplier/$orgId/public': {
      id: '/_app/supplier/$orgId/public'
      path: '/public'
      fullPath: '/supplier/$orgId/public'
      preLoaderRoute: typeof AppSupplierOrgIdPublicRouteImport
      parentRoute: typeof AppSupplierOrgIdRoute
    }
    '/_app/supplier/$orgId/quotes': {
      id: '/_app/supplier/$orgId/quotes'
      path: '/quotes'
      fullPath: '/supplier/$orgId/quotes'
      preLoaderRoute: typeof AppSupplierOrgIdQuotesRouteImport
      parentRoute: typeof AppSupplierOrgIdRoute
    }
    '/_app/supplier/$orgId/team': {
      id: '/_app/supplier/$orgId/team'
      path: '/team'
      fullPath: '/supplier/$orgId/team'
      preLoaderRoute: typeof AppSupplierOrgIdTeamRouteImport
      parentRoute: typeof AppSupplierOrgIdRoute
    }
    '/_app/land/sell/$orgId/': {
      id: '/_app/land/sell/$orgId/'
      path: '/land/sell/$orgId'
      fullPath: '/land/sell/$orgId/'
      preLoaderRoute: typeof AppLandSellOrgIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me/services/jobs/': {
      id: '/_app/me/services/jobs/'
      path: '/services/jobs'
      fullPath: '/me/services/jobs/'
      preLoaderRoute: typeof AppMeServicesJobsIndexRouteImport
      parentRoute: typeof AppMeRoute
    }
    '/_app/me/services/jobs/$jobId': {
      id: '/_app/me/services/jobs/$jobId'
      path: '/services/jobs/$jobId'
      fullPath: '/me/services/jobs/$jobId'
      preLoaderRoute: typeof AppMeServicesJobsJobIdRouteImport
      parentRoute: typeof AppMeRoute
    }
    '/_app/me/services/quotes/': {
      id: '/_app/me/services/quotes/'
      path: '/services/quotes'
      fullPath: '/me/services/quotes/'
      preLoaderRoute: typeof AppMeServicesQuotesIndexRouteImport
      parentRoute: typeof AppMeRoute
    }
    '/_app/me/services/quotes/$responseId': {
      id: '/_app/me/services/quotes/$responseId'
      path: '/services/quotes/$responseId'
      fullPath: '/me/services/quotes/$responseId'
      preLoaderRoute: typeof AppMeServicesQuotesResponseIdRouteImport
      parentRoute: typeof AppMeRoute
    }
    '/_app/me/services/tenders/': {
      id: '/_app/me/services/tenders/'
      path: '/services/tenders'
      fullPath: '/me/services/tenders/'
      preLoaderRoute: typeof AppMeServicesTendersIndexRouteImport
      parentRoute: typeof AppMeRoute
    }
    '/_app/me/services/tenders/$packageId': {
      id: '/_app/me/services/tenders/$packageId'
      path: '/services/tenders/$packageId'
      fullPath: '/me/services/tenders/$packageId'
      preLoaderRoute: typeof AppMeServicesTendersPackageIdRouteImport
      parentRoute: typeof AppMeRoute
    }
    '/_app/org/$orgId/reports/': {
      id: '/_app/org/$orgId/reports/'
      path: '/reports'
      fullPath: '/org/$orgId/reports/'
      preLoaderRoute: typeof AppOrgOrgIdReportsIndexRouteImport
      parentRoute: typeof AppOrgOrgIdRoute
    }
    '/_app/org/$orgId/reports/$reportKey': {
      id: '/_app/org/$orgId/reports/$reportKey'
      path: '/reports/$reportKey'
      fullPath: '/org/$orgId/reports/$reportKey'
      preLoaderRoute: typeof AppOrgOrgIdReportsReportKeyRouteImport
      parentRoute: typeof AppOrgOrgIdRoute
    }
    '/_app/org/$orgId/tenders/': {
      id: '/_app/org/$orgId/tenders/'
      path: '/tenders'
      fullPath: '/org/$orgId/tenders/'
      preLoaderRoute: typeof AppOrgOrgIdTendersIndexRouteImport
      parentRoute: typeof AppOrgOrgIdRoute
    }
    '/_app/org/$orgId/tenders/$packageId': {
      id: '/_app/org/$orgId/tenders/$packageId'
      path: '/tenders/$packageId'
      fullPath: '/org/$orgId/tenders/$packageId'
      preLoaderRoute: typeof AppOrgOrgIdTendersPackageIdRouteImport
      parentRoute: typeof AppOrgOrgIdRoute
    }
    '/_app/projects/$projectId/closeout/': {
      id: '/_app/projects/$projectId/closeout/'
      path: '/'
      fullPath: '/projects/$projectId/closeout/'
      preLoaderRoute: typeof AppProjectsProjectIdCloseoutIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdCloseoutRoute
    }
    '/_app/projects/$projectId/closeout/overview': {
      id: '/_app/projects/$projectId/closeout/overview'
      path: '/overview'
      fullPath: '/projects/$projectId/closeout/overview'
      preLoaderRoute: typeof AppProjectsProjectIdCloseoutOverviewRouteImport
      parentRoute: typeof AppProjectsProjectIdCloseoutRoute
    }
    '/_app/projects/$projectId/closeout/warranty': {
      id: '/_app/projects/$projectId/closeout/warranty'
      path: '/warranty'
      fullPath: '/projects/$projectId/closeout/warranty'
      preLoaderRoute: typeof AppProjectsProjectIdCloseoutWarrantyRouteImport
      parentRoute: typeof AppProjectsProjectIdCloseoutRoute
    }
    '/_app/projects/$projectId/commercial/': {
      id: '/_app/projects/$projectId/commercial/'
      path: '/'
      fullPath: '/projects/$projectId/commercial/'
      preLoaderRoute: typeof AppProjectsProjectIdCommercialIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdCommercialRoute
    }
    '/_app/projects/$projectId/commercial/certificates': {
      id: '/_app/projects/$projectId/commercial/certificates'
      path: '/certificates'
      fullPath: '/projects/$projectId/commercial/certificates'
      preLoaderRoute: typeof AppProjectsProjectIdCommercialCertificatesRouteImport
      parentRoute: typeof AppProjectsProjectIdCommercialRoute
    }
    '/_app/projects/$projectId/commercial/claims': {
      id: '/_app/projects/$projectId/commercial/claims'
      path: '/claims'
      fullPath: '/projects/$projectId/commercial/claims'
      preLoaderRoute: typeof AppProjectsProjectIdCommercialClaimsRouteImport
      parentRoute: typeof AppProjectsProjectIdCommercialRoute
    }
    '/_app/projects/$projectId/commercial/contract': {
      id: '/_app/projects/$projectId/commercial/contract'
      path: '/contract'
      fullPath: '/projects/$projectId/commercial/contract'
      preLoaderRoute: typeof AppProjectsProjectIdCommercialContractRouteImport
      parentRoute: typeof AppProjectsProjectIdCommercialRoute
    }
    '/_app/projects/$projectId/commercial/cost-control': {
      id: '/_app/projects/$projectId/commercial/cost-control'
      path: '/cost-control'
      fullPath: '/projects/$projectId/commercial/cost-control'
      preLoaderRoute: typeof AppProjectsProjectIdCommercialCostControlRouteImport
      parentRoute: typeof AppProjectsProjectIdCommercialRoute
    }
    '/_app/projects/$projectId/commercial/cost-plans': {
      id: '/_app/projects/$projectId/commercial/cost-plans'
      path: '/cost-plans'
      fullPath: '/projects/$projectId/commercial/cost-plans'
      preLoaderRoute: typeof AppProjectsProjectIdCommercialCostPlansRouteImport
      parentRoute: typeof AppProjectsProjectIdCommercialRoute
    }
    '/_app/projects/$projectId/commercial/final-account': {
      id: '/_app/projects/$projectId/commercial/final-account'
      path: '/final-account'
      fullPath: '/projects/$projectId/commercial/final-account'
      preLoaderRoute: typeof AppProjectsProjectIdCommercialFinalAccountRouteImport
      parentRoute: typeof AppProjectsProjectIdCommercialRoute
    }
    '/_app/projects/$projectId/commercial/overview': {
      id: '/_app/projects/$projectId/commercial/overview'
      path: '/overview'
      fullPath: '/projects/$projectId/commercial/overview'
      preLoaderRoute: typeof AppProjectsProjectIdCommercialOverviewRouteImport
      parentRoute: typeof AppProjectsProjectIdCommercialRoute
    }
    '/_app/projects/$projectId/commercial/payments': {
      id: '/_app/projects/$projectId/commercial/payments'
      path: '/payments'
      fullPath: '/projects/$projectId/commercial/payments'
      preLoaderRoute: typeof AppProjectsProjectIdCommercialPaymentsRouteImport
      parentRoute: typeof AppProjectsProjectIdCommercialRoute
    }
    '/_app/projects/$projectId/commercial/retention': {
      id: '/_app/projects/$projectId/commercial/retention'
      path: '/retention'
      fullPath: '/projects/$projectId/commercial/retention'
      preLoaderRoute: typeof AppProjectsProjectIdCommercialRetentionRouteImport
      parentRoute: typeof AppProjectsProjectIdCommercialRoute
    }
    '/_app/projects/$projectId/commercial/sums': {
      id: '/_app/projects/$projectId/commercial/sums'
      path: '/sums'
      fullPath: '/projects/$projectId/commercial/sums'
      preLoaderRoute: typeof AppProjectsProjectIdCommercialSumsRouteImport
      parentRoute: typeof AppProjectsProjectIdCommercialRoute
    }
    '/_app/projects/$projectId/commercial/variations': {
      id: '/_app/projects/$projectId/commercial/variations'
      path: '/variations'
      fullPath: '/projects/$projectId/commercial/variations'
      preLoaderRoute: typeof AppProjectsProjectIdCommercialVariationsRouteImport
      parentRoute: typeof AppProjectsProjectIdCommercialRoute
    }
    '/_app/projects/$projectId/cost/': {
      id: '/_app/projects/$projectId/cost/'
      path: '/'
      fullPath: '/projects/$projectId/cost/'
      preLoaderRoute: typeof AppProjectsProjectIdCostIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdCostRoute
    }
    '/_app/projects/$projectId/cost/expenses': {
      id: '/_app/projects/$projectId/cost/expenses'
      path: '/expenses'
      fullPath: '/projects/$projectId/cost/expenses'
      preLoaderRoute: typeof AppProjectsProjectIdCostExpensesRouteImport
      parentRoute: typeof AppProjectsProjectIdCostRoute
    }
    '/_app/projects/$projectId/cost/materials-on-site': {
      id: '/_app/projects/$projectId/cost/materials-on-site'
      path: '/materials-on-site'
      fullPath: '/projects/$projectId/cost/materials-on-site'
      preLoaderRoute: typeof AppProjectsProjectIdCostMaterialsOnSiteRouteImport
      parentRoute: typeof AppProjectsProjectIdCostRoute
    }
    '/_app/projects/$projectId/cost/overview': {
      id: '/_app/projects/$projectId/cost/overview'
      path: '/overview'
      fullPath: '/projects/$projectId/cost/overview'
      preLoaderRoute: typeof AppProjectsProjectIdCostOverviewRouteImport
      parentRoute: typeof AppProjectsProjectIdCostRoute
    }
    '/_app/projects/$projectId/cost/variations': {
      id: '/_app/projects/$projectId/cost/variations'
      path: '/variations'
      fullPath: '/projects/$projectId/cost/variations'
      preLoaderRoute: typeof AppProjectsProjectIdCostVariationsRouteImport
      parentRoute: typeof AppProjectsProjectIdCostRoute
    }
    '/_app/projects/$projectId/decisions/': {
      id: '/_app/projects/$projectId/decisions/'
      path: '/'
      fullPath: '/projects/$projectId/decisions/'
      preLoaderRoute: typeof AppProjectsProjectIdDecisionsIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdDecisionsRoute
    }
    '/_app/projects/$projectId/decisions/change-requests': {
      id: '/_app/projects/$projectId/decisions/change-requests'
      path: '/change-requests'
      fullPath: '/projects/$projectId/decisions/change-requests'
      preLoaderRoute: typeof AppProjectsProjectIdDecisionsChangeRequestsRouteImport
      parentRoute: typeof AppProjectsProjectIdDecisionsRoute
    }
    '/_app/projects/$projectId/decisions/selections': {
      id: '/_app/projects/$projectId/decisions/selections'
      path: '/selections'
      fullPath: '/projects/$projectId/decisions/selections'
      preLoaderRoute: typeof AppProjectsProjectIdDecisionsSelectionsRouteImport
      parentRoute: typeof AppProjectsProjectIdDecisionsRoute
    }
    '/_app/projects/$projectId/design/': {
      id: '/_app/projects/$projectId/design/'
      path: '/'
      fullPath: '/projects/$projectId/design/'
      preLoaderRoute: typeof AppProjectsProjectIdDesignIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdDesignRoute
    }
    '/_app/projects/$projectId/design/compare': {
      id: '/_app/projects/$projectId/design/compare'
      path: '/compare'
      fullPath: '/projects/$projectId/design/compare'
      preLoaderRoute: typeof AppProjectsProjectIdDesignCompareRouteImport
      parentRoute: typeof AppProjectsProjectIdDesignRoute
    }
    '/_app/projects/$projectId/design/completion': {
      id: '/_app/projects/$projectId/design/completion'
      path: '/completion'
      fullPath: '/projects/$projectId/design/completion'
      preLoaderRoute: typeof AppProjectsProjectIdDesignCompletionRouteImport
      parentRoute: typeof AppProjectsProjectIdDesignRoute
    }
    '/_app/projects/$projectId/design/coordination': {
      id: '/_app/projects/$projectId/design/coordination'
      path: '/coordination'
      fullPath: '/projects/$projectId/design/coordination'
      preLoaderRoute: typeof AppProjectsProjectIdDesignCoordinationRouteImport
      parentRoute: typeof AppProjectsProjectIdDesignRoute
    }
    '/_app/projects/$projectId/design/deliverables': {
      id: '/_app/projects/$projectId/design/deliverables'
      path: '/deliverables'
      fullPath: '/projects/$projectId/design/deliverables'
      preLoaderRoute: typeof AppProjectsProjectIdDesignDeliverablesRouteImport
      parentRoute: typeof AppProjectsProjectIdDesignRoute
    }
    '/_app/projects/$projectId/design/drawings': {
      id: '/_app/projects/$projectId/design/drawings'
      path: '/drawings'
      fullPath: '/projects/$projectId/design/drawings'
      preLoaderRoute: typeof AppProjectsProjectIdDesignDrawingsRouteImport
      parentRoute: typeof AppProjectsProjectIdDesignRoute
    }
    '/_app/projects/$projectId/design/overview': {
      id: '/_app/projects/$projectId/design/overview'
      path: '/overview'
      fullPath: '/projects/$projectId/design/overview'
      preLoaderRoute: typeof AppProjectsProjectIdDesignOverviewRouteImport
      parentRoute: typeof AppProjectsProjectIdDesignRoute
    }
    '/_app/projects/$projectId/design/rfis': {
      id: '/_app/projects/$projectId/design/rfis'
      path: '/rfis'
      fullPath: '/projects/$projectId/design/rfis'
      preLoaderRoute: typeof AppProjectsProjectIdDesignRfisRouteImport
      parentRoute: typeof AppProjectsProjectIdDesignRoute
    }
    '/_app/projects/$projectId/design/site-visits': {
      id: '/_app/projects/$projectId/design/site-visits'
      path: '/site-visits'
      fullPath: '/projects/$projectId/design/site-visits'
      preLoaderRoute: typeof AppProjectsProjectIdDesignSiteVisitsRouteImport
      parentRoute: typeof AppProjectsProjectIdDesignRoute
    }
    '/_app/projects/$projectId/design/specifications': {
      id: '/_app/projects/$projectId/design/specifications'
      path: '/specifications'
      fullPath: '/projects/$projectId/design/specifications'
      preLoaderRoute: typeof AppProjectsProjectIdDesignSpecificationsRouteImport
      parentRoute: typeof AppProjectsProjectIdDesignRoute
    }
    '/_app/projects/$projectId/design/submittals': {
      id: '/_app/projects/$projectId/design/submittals'
      path: '/submittals'
      fullPath: '/projects/$projectId/design/submittals'
      preLoaderRoute: typeof AppProjectsProjectIdDesignSubmittalsRouteImport
      parentRoute: typeof AppProjectsProjectIdDesignRoute
    }
    '/_app/projects/$projectId/design/transmittals': {
      id: '/_app/projects/$projectId/design/transmittals'
      path: '/transmittals'
      fullPath: '/projects/$projectId/design/transmittals'
      preLoaderRoute: typeof AppProjectsProjectIdDesignTransmittalsRouteImport
      parentRoute: typeof AppProjectsProjectIdDesignRoute
    }
    '/_app/projects/$projectId/hiring/': {
      id: '/_app/projects/$projectId/hiring/'
      path: '/'
      fullPath: '/projects/$projectId/hiring/'
      preLoaderRoute: typeof AppProjectsProjectIdHiringIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdHiringRoute
    }
    '/_app/projects/$projectId/insights/': {
      id: '/_app/projects/$projectId/insights/'
      path: '/'
      fullPath: '/projects/$projectId/insights/'
      preLoaderRoute: typeof AppProjectsProjectIdInsightsIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdInsightsRoute
    }
    '/_app/projects/$projectId/insights/flags': {
      id: '/_app/projects/$projectId/insights/flags'
      path: '/flags'
      fullPath: '/projects/$projectId/insights/flags'
      preLoaderRoute: typeof AppProjectsProjectIdInsightsFlagsRouteImport
      parentRoute: typeof AppProjectsProjectIdInsightsRoute
    }
    '/_app/projects/$projectId/insights/forecast': {
      id: '/_app/projects/$projectId/insights/forecast'
      path: '/forecast'
      fullPath: '/projects/$projectId/insights/forecast'
      preLoaderRoute: typeof AppProjectsProjectIdInsightsForecastRouteImport
      parentRoute: typeof AppProjectsProjectIdInsightsRoute
    }
    '/_app/projects/$projectId/labour-evidence/': {
      id: '/_app/projects/$projectId/labour-evidence/'
      path: '/labour-evidence'
      fullPath: '/projects/$projectId/labour-evidence/'
      preLoaderRoute: typeof AppProjectsProjectIdLabourEvidenceIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/labour-evidence/timesheets': {
      id: '/_app/projects/$projectId/labour-evidence/timesheets'
      path: '/labour-evidence/timesheets'
      fullPath: '/projects/$projectId/labour-evidence/timesheets'
      preLoaderRoute: typeof AppProjectsProjectIdLabourEvidenceTimesheetsRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/plan/': {
      id: '/_app/projects/$projectId/plan/'
      path: '/'
      fullPath: '/projects/$projectId/plan/'
      preLoaderRoute: typeof AppProjectsProjectIdPlanIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdPlanRoute
    }
    '/_app/projects/$projectId/plan/baselines': {
      id: '/_app/projects/$projectId/plan/baselines'
      path: '/baselines'
      fullPath: '/projects/$projectId/plan/baselines'
      preLoaderRoute: typeof AppProjectsProjectIdPlanBaselinesRouteImport
      parentRoute: typeof AppProjectsProjectIdPlanRoute
    }
    '/_app/projects/$projectId/plan/constraints': {
      id: '/_app/projects/$projectId/plan/constraints'
      path: '/constraints'
      fullPath: '/projects/$projectId/plan/constraints'
      preLoaderRoute: typeof AppProjectsProjectIdPlanConstraintsRouteImport
      parentRoute: typeof AppProjectsProjectIdPlanRoute
    }
    '/_app/projects/$projectId/plan/lookahead': {
      id: '/_app/projects/$projectId/plan/lookahead'
      path: '/lookahead'
      fullPath: '/projects/$projectId/plan/lookahead'
      preLoaderRoute: typeof AppProjectsProjectIdPlanLookaheadRouteImport
      parentRoute: typeof AppProjectsProjectIdPlanRoute
    }
    '/_app/projects/$projectId/plan/milestones': {
      id: '/_app/projects/$projectId/plan/milestones'
      path: '/milestones'
      fullPath: '/projects/$projectId/plan/milestones'
      preLoaderRoute: typeof AppProjectsProjectIdPlanMilestonesRouteImport
      parentRoute: typeof AppProjectsProjectIdPlanRoute
    }
    '/_app/projects/$projectId/plan/stages': {
      id: '/_app/projects/$projectId/plan/stages'
      path: '/stages'
      fullPath: '/projects/$projectId/plan/stages'
      preLoaderRoute: typeof AppProjectsProjectIdPlanStagesRouteImport
      parentRoute: typeof AppProjectsProjectIdPlanRoute
    }
    '/_app/projects/$projectId/plan/tasks': {
      id: '/_app/projects/$projectId/plan/tasks'
      path: '/tasks'
      fullPath: '/projects/$projectId/plan/tasks'
      preLoaderRoute: typeof AppProjectsProjectIdPlanTasksRouteImport
      parentRoute: typeof AppProjectsProjectIdPlanRoute
    }
    '/_app/projects/$projectId/plan/weekly-plans': {
      id: '/_app/projects/$projectId/plan/weekly-plans'
      path: '/weekly-plans'
      fullPath: '/projects/$projectId/plan/weekly-plans'
      preLoaderRoute: typeof AppProjectsProjectIdPlanWeeklyPlansRouteImport
      parentRoute: typeof AppProjectsProjectIdPlanRoute
    }
    '/_app/projects/$projectId/plan/zones': {
      id: '/_app/projects/$projectId/plan/zones'
      path: '/zones'
      fullPath: '/projects/$projectId/plan/zones'
      preLoaderRoute: typeof AppProjectsProjectIdPlanZonesRouteImport
      parentRoute: typeof AppProjectsProjectIdPlanRoute
    }
    '/_app/projects/$projectId/procurement/': {
      id: '/_app/projects/$projectId/procurement/'
      path: '/'
      fullPath: '/projects/$projectId/procurement/'
      preLoaderRoute: typeof AppProjectsProjectIdProcurementIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdProcurementRoute
    }
    '/_app/projects/$projectId/procurement/cart': {
      id: '/_app/projects/$projectId/procurement/cart'
      path: '/cart'
      fullPath: '/projects/$projectId/procurement/cart'
      preLoaderRoute: typeof AppProjectsProjectIdProcurementCartRouteImport
      parentRoute: typeof AppProjectsProjectIdProcurementRoute
    }
    '/_app/projects/$projectId/procurement/deliveries': {
      id: '/_app/projects/$projectId/procurement/deliveries'
      path: '/deliveries'
      fullPath: '/projects/$projectId/procurement/deliveries'
      preLoaderRoute: typeof AppProjectsProjectIdProcurementDeliveriesRouteImport
      parentRoute: typeof AppProjectsProjectIdProcurementRoute
    }
    '/_app/projects/$projectId/procurement/invoices': {
      id: '/_app/projects/$projectId/procurement/invoices'
      path: '/invoices'
      fullPath: '/projects/$projectId/procurement/invoices'
      preLoaderRoute: typeof AppProjectsProjectIdProcurementInvoicesRouteImport
      parentRoute: typeof AppProjectsProjectIdProcurementRoute
    }
    '/_app/projects/$projectId/procurement/requisitions': {
      id: '/_app/projects/$projectId/procurement/requisitions'
      path: '/requisitions'
      fullPath: '/projects/$projectId/procurement/requisitions'
      preLoaderRoute: typeof AppProjectsProjectIdProcurementRequisitionsRouteImport
      parentRoute: typeof AppProjectsProjectIdProcurementRoute
    }
    '/_app/projects/$projectId/quality/': {
      id: '/_app/projects/$projectId/quality/'
      path: '/'
      fullPath: '/projects/$projectId/quality/'
      preLoaderRoute: typeof AppProjectsProjectIdQualityIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdQualityRoute
    }
    '/_app/projects/$projectId/quality/checklists': {
      id: '/_app/projects/$projectId/quality/checklists'
      path: '/checklists'
      fullPath: '/projects/$projectId/quality/checklists'
      preLoaderRoute: typeof AppProjectsProjectIdQualityChecklistsRouteImport
      parentRoute: typeof AppProjectsProjectIdQualityRoute
    }
    '/_app/projects/$projectId/quality/ncrs': {
      id: '/_app/projects/$projectId/quality/ncrs'
      path: '/ncrs'
      fullPath: '/projects/$projectId/quality/ncrs'
      preLoaderRoute: typeof AppProjectsProjectIdQualityNcrsRouteImport
      parentRoute: typeof AppProjectsProjectIdQualityRoute
    }
    '/_app/projects/$projectId/quality/rectifications': {
      id: '/_app/projects/$projectId/quality/rectifications'
      path: '/rectifications'
      fullPath: '/projects/$projectId/quality/rectifications'
      preLoaderRoute: typeof AppProjectsProjectIdQualityRectificationsRouteImport
      parentRoute: typeof AppProjectsProjectIdQualityRoute
    }
    '/_app/projects/$projectId/quality/snags': {
      id: '/_app/projects/$projectId/quality/snags'
      path: '/snags'
      fullPath: '/projects/$projectId/quality/snags'
      preLoaderRoute: typeof AppProjectsProjectIdQualitySnagsRouteImport
      parentRoute: typeof AppProjectsProjectIdQualityRoute
    }
    '/_app/projects/$projectId/quality/tests': {
      id: '/_app/projects/$projectId/quality/tests'
      path: '/tests'
      fullPath: '/projects/$projectId/quality/tests'
      preLoaderRoute: typeof AppProjectsProjectIdQualityTestsRouteImport
      parentRoute: typeof AppProjectsProjectIdQualityRoute
    }
    '/_app/projects/$projectId/reports/': {
      id: '/_app/projects/$projectId/reports/'
      path: '/reports'
      fullPath: '/projects/$projectId/reports/'
      preLoaderRoute: typeof AppProjectsProjectIdReportsIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/reports/$reportKey': {
      id: '/_app/projects/$projectId/reports/$reportKey'
      path: '/reports/$reportKey'
      fullPath: '/projects/$projectId/reports/$reportKey'
      preLoaderRoute: typeof AppProjectsProjectIdReportsReportKeyRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/resources/': {
      id: '/_app/projects/$projectId/resources/'
      path: '/'
      fullPath: '/projects/$projectId/resources/'
      preLoaderRoute: typeof AppProjectsProjectIdResourcesIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdResourcesRoute
    }
    '/_app/projects/$projectId/resources/equipment': {
      id: '/_app/projects/$projectId/resources/equipment'
      path: '/equipment'
      fullPath: '/projects/$projectId/resources/equipment'
      preLoaderRoute: typeof AppProjectsProjectIdResourcesEquipmentRouteImport
      parentRoute: typeof AppProjectsProjectIdResourcesRoute
    }
    '/_app/projects/$projectId/resources/equipment-requests': {
      id: '/_app/projects/$projectId/resources/equipment-requests'
      path: '/equipment-requests'
      fullPath: '/projects/$projectId/resources/equipment-requests'
      preLoaderRoute: typeof AppProjectsProjectIdResourcesEquipmentRequestsRouteImport
      parentRoute: typeof AppProjectsProjectIdResourcesRoute
    }
    '/_app/projects/$projectId/resources/requests': {
      id: '/_app/projects/$projectId/resources/requests'
      path: '/requests'
      fullPath: '/projects/$projectId/resources/requests'
      preLoaderRoute: typeof AppProjectsProjectIdResourcesRequestsRouteImport
      parentRoute: typeof AppProjectsProjectIdResourcesRoute
    }
    '/_app/projects/$projectId/resources/store': {
      id: '/_app/projects/$projectId/resources/store'
      path: '/store'
      fullPath: '/projects/$projectId/resources/store'
      preLoaderRoute: typeof AppProjectsProjectIdResourcesStoreRouteImport
      parentRoute: typeof AppProjectsProjectIdResourcesRoute
    }
    '/_app/projects/$projectId/resources/submittals': {
      id: '/_app/projects/$projectId/resources/submittals'
      path: '/submittals'
      fullPath: '/projects/$projectId/resources/submittals'
      preLoaderRoute: typeof AppProjectsProjectIdResourcesSubmittalsRouteImport
      parentRoute: typeof AppProjectsProjectIdResourcesRoute
    }
    '/_app/projects/$projectId/safety/': {
      id: '/_app/projects/$projectId/safety/'
      path: '/'
      fullPath: '/projects/$projectId/safety/'
      preLoaderRoute: typeof AppProjectsProjectIdSafetyIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdSafetyRoute
    }
    '/_app/projects/$projectId/safety/incidents': {
      id: '/_app/projects/$projectId/safety/incidents'
      path: '/incidents'
      fullPath: '/projects/$projectId/safety/incidents'
      preLoaderRoute: typeof AppProjectsProjectIdSafetyIncidentsRouteImport
      parentRoute: typeof AppProjectsProjectIdSafetyRoute
    }
    '/_app/projects/$projectId/safety/overview': {
      id: '/_app/projects/$projectId/safety/overview'
      path: '/overview'
      fullPath: '/projects/$projectId/safety/overview'
      preLoaderRoute: typeof AppProjectsProjectIdSafetyOverviewRouteImport
      parentRoute: typeof AppProjectsProjectIdSafetyRoute
    }
    '/_app/projects/$projectId/safety/ppe': {
      id: '/_app/projects/$projectId/safety/ppe'
      path: '/ppe'
      fullPath: '/projects/$projectId/safety/ppe'
      preLoaderRoute: typeof AppProjectsProjectIdSafetyPpeRouteImport
      parentRoute: typeof AppProjectsProjectIdSafetyRoute
    }
    '/_app/projects/$projectId/safety/toolbox': {
      id: '/_app/projects/$projectId/safety/toolbox'
      path: '/toolbox'
      fullPath: '/projects/$projectId/safety/toolbox'
      preLoaderRoute: typeof AppProjectsProjectIdSafetyToolboxRouteImport
      parentRoute: typeof AppProjectsProjectIdSafetyRoute
    }
    '/_app/projects/$projectId/site/': {
      id: '/_app/projects/$projectId/site/'
      path: '/'
      fullPath: '/projects/$projectId/site/'
      preLoaderRoute: typeof AppProjectsProjectIdSiteIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdSiteRoute
    }
    '/_app/projects/$projectId/site/attendance': {
      id: '/_app/projects/$projectId/site/attendance'
      path: '/attendance'
      fullPath: '/projects/$projectId/site/attendance'
      preLoaderRoute: typeof AppProjectsProjectIdSiteAttendanceRouteImport
      parentRoute: typeof AppProjectsProjectIdSiteRoute
    }
    '/_app/projects/$projectId/site/daily-plan': {
      id: '/_app/projects/$projectId/site/daily-plan'
      path: '/daily-plan'
      fullPath: '/projects/$projectId/site/daily-plan'
      preLoaderRoute: typeof AppProjectsProjectIdSiteDailyPlanRouteImport
      parentRoute: typeof AppProjectsProjectIdSiteRoute
    }
    '/_app/projects/$projectId/site/day-close': {
      id: '/_app/projects/$projectId/site/day-close'
      path: '/day-close'
      fullPath: '/projects/$projectId/site/day-close'
      preLoaderRoute: typeof AppProjectsProjectIdSiteDayCloseRouteImport
      parentRoute: typeof AppProjectsProjectIdSiteRoute
    }
    '/_app/projects/$projectId/site/diary': {
      id: '/_app/projects/$projectId/site/diary'
      path: '/diary'
      fullPath: '/projects/$projectId/site/diary'
      preLoaderRoute: typeof AppProjectsProjectIdSiteDiaryRouteImport
      parentRoute: typeof AppProjectsProjectIdSiteRoute
    }
    '/_app/projects/$projectId/site/instructions': {
      id: '/_app/projects/$projectId/site/instructions'
      path: '/instructions'
      fullPath: '/projects/$projectId/site/instructions'
      preLoaderRoute: typeof AppProjectsProjectIdSiteInstructionsRouteImport
      parentRoute: typeof AppProjectsProjectIdSiteRoute
    }
    '/_app/projects/$projectId/site/issues': {
      id: '/_app/projects/$projectId/site/issues'
      path: '/issues'
      fullPath: '/projects/$projectId/site/issues'
      preLoaderRoute: typeof AppProjectsProjectIdSiteIssuesRouteImport
      parentRoute: typeof AppProjectsProjectIdSiteRoute
    }
    '/_app/projects/$projectId/site/meetings': {
      id: '/_app/projects/$projectId/site/meetings'
      path: '/meetings'
      fullPath: '/projects/$projectId/site/meetings'
      preLoaderRoute: typeof AppProjectsProjectIdSiteMeetingsRouteImport
      parentRoute: typeof AppProjectsProjectIdSiteRoute
    }
    '/_app/projects/$projectId/site/photos': {
      id: '/_app/projects/$projectId/site/photos'
      path: '/photos'
      fullPath: '/projects/$projectId/site/photos'
      preLoaderRoute: typeof AppProjectsProjectIdSitePhotosRouteImport
      parentRoute: typeof AppProjectsProjectIdSiteRoute
    }
    '/_app/projects/$projectId/site/progress': {
      id: '/_app/projects/$projectId/site/progress'
      path: '/progress'
      fullPath: '/projects/$projectId/site/progress'
      preLoaderRoute: typeof AppProjectsProjectIdSiteProgressRouteImport
      parentRoute: typeof AppProjectsProjectIdSiteRoute
    }
    '/_app/projects/$projectId/site/today': {
      id: '/_app/projects/$projectId/site/today'
      path: '/today'
      fullPath: '/projects/$projectId/site/today'
      preLoaderRoute: typeof AppProjectsProjectIdSiteTodayRouteImport
      parentRoute: typeof AppProjectsProjectIdSiteRoute
    }
    '/_app/projects/$projectId/site/visitors': {
      id: '/_app/projects/$projectId/site/visitors'
      path: '/visitors'
      fullPath: '/projects/$projectId/site/visitors'
      preLoaderRoute: typeof AppProjectsProjectIdSiteVisitorsRouteImport
      parentRoute: typeof AppProjectsProjectIdSiteRoute
    }
    '/_app/projects/$projectId/subcontracts/': {
      id: '/_app/projects/$projectId/subcontracts/'
      path: '/'
      fullPath: '/projects/$projectId/subcontracts/'
      preLoaderRoute: typeof AppProjectsProjectIdSubcontractsIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdSubcontractsRoute
    }
    '/_app/projects/$projectId/subcontracts/changes': {
      id: '/_app/projects/$projectId/subcontracts/changes'
      path: '/changes'
      fullPath: '/projects/$projectId/subcontracts/changes'
      preLoaderRoute: typeof AppProjectsProjectIdSubcontractsChangesRouteImport
      parentRoute: typeof AppProjectsProjectIdSubcontractsRoute
    }
    '/_app/projects/$projectId/subcontracts/consents': {
      id: '/_app/projects/$projectId/subcontracts/consents'
      path: '/consents'
      fullPath: '/projects/$projectId/subcontracts/consents'
      preLoaderRoute: typeof AppProjectsProjectIdSubcontractsConsentsRouteImport
      parentRoute: typeof AppProjectsProjectIdSubcontractsRoute
    }
    '/_app/projects/$projectId/subcontracts/daily-reports': {
      id: '/_app/projects/$projectId/subcontracts/daily-reports'
      path: '/daily-reports'
      fullPath: '/projects/$projectId/subcontracts/daily-reports'
      preLoaderRoute: typeof AppProjectsProjectIdSubcontractsDailyReportsRouteImport
      parentRoute: typeof AppProjectsProjectIdSubcontractsRoute
    }
    '/_app/projects/$projectId/subcontracts/overview': {
      id: '/_app/projects/$projectId/subcontracts/overview'
      path: '/overview'
      fullPath: '/projects/$projectId/subcontracts/overview'
      preLoaderRoute: typeof AppProjectsProjectIdSubcontractsOverviewRouteImport
      parentRoute: typeof AppProjectsProjectIdSubcontractsRoute
    }
    '/_app/projects/$projectId/subcontracts/own-stock': {
      id: '/_app/projects/$projectId/subcontracts/own-stock'
      path: '/own-stock'
      fullPath: '/projects/$projectId/subcontracts/own-stock'
      preLoaderRoute: typeof AppProjectsProjectIdSubcontractsOwnStockRouteImport
      parentRoute: typeof AppProjectsProjectIdSubcontractsRoute
    }
    '/_app/projects/$projectId/subcontracts/payments': {
      id: '/_app/projects/$projectId/subcontracts/payments'
      path: '/payments'
      fullPath: '/projects/$projectId/subcontracts/payments'
      preLoaderRoute: typeof AppProjectsProjectIdSubcontractsPaymentsRouteImport
      parentRoute: typeof AppProjectsProjectIdSubcontractsRoute
    }
    '/_app/projects/$projectId/subcontracts/purchases': {
      id: '/_app/projects/$projectId/subcontracts/purchases'
      path: '/purchases'
      fullPath: '/projects/$projectId/subcontracts/purchases'
      preLoaderRoute: typeof AppProjectsProjectIdSubcontractsPurchasesRouteImport
      parentRoute: typeof AppProjectsProjectIdSubcontractsRoute
    }
    '/_app/projects/$projectId/tenders/': {
      id: '/_app/projects/$projectId/tenders/'
      path: '/tenders'
      fullPath: '/projects/$projectId/tenders/'
      preLoaderRoute: typeof AppProjectsProjectIdTendersIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/tenders/$packageId': {
      id: '/_app/projects/$projectId/tenders/$packageId'
      path: '/tenders/$packageId'
      fullPath: '/projects/$projectId/tenders/$packageId'
      preLoaderRoute: typeof AppProjectsProjectIdTendersPackageIdRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/timeline/': {
      id: '/_app/projects/$projectId/timeline/'
      path: '/'
      fullPath: '/projects/$projectId/timeline/'
      preLoaderRoute: typeof AppProjectsProjectIdTimelineIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdTimelineRoute
    }
    '/_app/projects/$projectId/timeline/activity': {
      id: '/_app/projects/$projectId/timeline/activity'
      path: '/activity'
      fullPath: '/projects/$projectId/timeline/activity'
      preLoaderRoute: typeof AppProjectsProjectIdTimelineActivityRouteImport
      parentRoute: typeof AppProjectsProjectIdTimelineRoute
    }
    '/_app/projects/$projectId/timeline/photos': {
      id: '/_app/projects/$projectId/timeline/photos'
      path: '/photos'
      fullPath: '/projects/$projectId/timeline/photos'
      preLoaderRoute: typeof AppProjectsProjectIdTimelinePhotosRouteImport
      parentRoute: typeof AppProjectsProjectIdTimelineRoute
    }
    '/_app/projects/$projectId/workforce/': {
      id: '/_app/projects/$projectId/workforce/'
      path: '/'
      fullPath: '/projects/$projectId/workforce/'
      preLoaderRoute: typeof AppProjectsProjectIdWorkforceIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdWorkforceRoute
    }
    '/_app/projects/$projectId/workforce/crews': {
      id: '/_app/projects/$projectId/workforce/crews'
      path: '/crews'
      fullPath: '/projects/$projectId/workforce/crews'
      preLoaderRoute: typeof AppProjectsProjectIdWorkforceCrewsRouteImport
      parentRoute: typeof AppProjectsProjectIdWorkforceRoute
    }
    '/_app/projects/$projectId/workforce/productivity': {
      id: '/_app/projects/$projectId/workforce/productivity'
      path: '/productivity'
      fullPath: '/projects/$projectId/workforce/productivity'
      preLoaderRoute: typeof AppProjectsProjectIdWorkforceProductivityRouteImport
      parentRoute: typeof AppProjectsProjectIdWorkforceRoute
    }
    '/_app/projects/$projectId/workforce/timesheets': {
      id: '/_app/projects/$projectId/workforce/timesheets'
      path: '/timesheets'
      fullPath: '/projects/$projectId/workforce/timesheets'
      preLoaderRoute: typeof AppProjectsProjectIdWorkforceTimesheetsRouteImport
      parentRoute: typeof AppProjectsProjectIdWorkforceRoute
    }
    '/_app/supplier/$orgId/customers/': {
      id: '/_app/supplier/$orgId/customers/'
      path: '/customers'
      fullPath: '/supplier/$orgId/customers/'
      preLoaderRoute: typeof AppSupplierOrgIdCustomersIndexRouteImport
      parentRoute: typeof AppSupplierOrgIdRoute
    }
    '/_app/supplier/$orgId/customers/$customerId': {
      id: '/_app/supplier/$orgId/customers/$customerId'
      path: '/customers/$customerId'
      fullPath: '/supplier/$orgId/customers/$customerId'
      preLoaderRoute: typeof AppSupplierOrgIdCustomersCustomerIdRouteImport
      parentRoute: typeof AppSupplierOrgIdRoute
    }
    '/_app/supplier/$orgId/messages/': {
      id: '/_app/supplier/$orgId/messages/'
      path: '/messages'
      fullPath: '/supplier/$orgId/messages/'
      preLoaderRoute: typeof AppSupplierOrgIdMessagesIndexRouteImport
      parentRoute: typeof AppSupplierOrgIdRoute
    }
    '/_app/supplier/$orgId/messages/$conversationId': {
      id: '/_app/supplier/$orgId/messages/$conversationId'
      path: '/messages/$conversationId'
      fullPath: '/supplier/$orgId/messages/$conversationId'
      preLoaderRoute: typeof AppSupplierOrgIdMessagesConversationIdRouteImport
      parentRoute: typeof AppSupplierOrgIdRoute
    }
    '/_app/supplier/$orgId/orders/': {
      id: '/_app/supplier/$orgId/orders/'
      path: '/orders'
      fullPath: '/supplier/$orgId/orders/'
      preLoaderRoute: typeof AppSupplierOrgIdOrdersIndexRouteImport
      parentRoute: typeof AppSupplierOrgIdRoute
    }
    '/_app/supplier/$orgId/orders/$poId': {
      id: '/_app/supplier/$orgId/orders/$poId'
      path: '/orders/$poId'
      fullPath: '/supplier/$orgId/orders/$poId'
      preLoaderRoute: typeof AppSupplierOrgIdOrdersPoIdRouteImport
      parentRoute: typeof AppSupplierOrgIdRoute
    }
    '/_app/supplier/$orgId/rfqs/': {
      id: '/_app/supplier/$orgId/rfqs/'
      path: '/rfqs'
      fullPath: '/supplier/$orgId/rfqs/'
      preLoaderRoute: typeof AppSupplierOrgIdRfqsIndexRouteImport
      parentRoute: typeof AppSupplierOrgIdRoute
    }
    '/_app/supplier/$orgId/rfqs/$rfqId': {
      id: '/_app/supplier/$orgId/rfqs/$rfqId'
      path: '/rfqs/$rfqId'
      fullPath: '/supplier/$orgId/rfqs/$rfqId'
      preLoaderRoute: typeof AppSupplierOrgIdRfqsRfqIdRouteImport
      parentRoute: typeof AppSupplierOrgIdRoute
    }
    '/print/org/$orgId/reports/$reportKey': {
      id: '/print/org/$orgId/reports/$reportKey'
      path: '/print/org/$orgId/reports/$reportKey'
      fullPath: '/print/org/$orgId/reports/$reportKey'
      preLoaderRoute: typeof PrintOrgOrgIdReportsReportKeyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/print/projects/$projectId/certificates/$certificateId': {
      id: '/print/projects/$projectId/certificates/$certificateId'
      path: '/print/projects/$projectId/certificates/$certificateId'
      fullPath: '/print/projects/$projectId/certificates/$certificateId'
      preLoaderRoute: typeof PrintProjectsProjectIdCertificatesCertificateIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/print/projects/$projectId/reports/$reportKey': {
      id: '/print/projects/$projectId/reports/$reportKey'
      path: '/print/projects/$projectId/reports/$reportKey'
      fullPath: '/print/projects/$projectId/reports/$reportKey'
      preLoaderRoute: typeof PrintProjectsProjectIdReportsReportKeyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/print/projects/$projectId/site-visits/$visitId': {
      id: '/print/projects/$projectId/site-visits/$visitId'
      path: '/print/projects/$projectId/site-visits/$visitId'
      fullPath: '/print/projects/$projectId/site-visits/$visitId'
      preLoaderRoute: typeof PrintProjectsProjectIdSiteVisitsVisitIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/land/sell/$orgId/listings/$listingId': {
      id: '/_app/land/sell/$orgId/listings/$listingId'
      path: '/land/sell/$orgId/listings/$listingId'
      fullPath: '/land/sell/$orgId/listings/$listingId'
      preLoaderRoute: typeof AppLandSellOrgIdListingsListingIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$projectId/commercial/measure/$valuationId': {
      id: '/_app/projects/$projectId/commercial/measure/$valuationId'
      path: '/measure/$valuationId'
      fullPath: '/projects/$projectId/commercial/measure/$valuationId'
      preLoaderRoute: typeof AppProjectsProjectIdCommercialMeasureValuationIdRouteImport
      parentRoute: typeof AppProjectsProjectIdCommercialRoute
    }
    '/_app/projects/$projectId/commercial/valuations/': {
      id: '/_app/projects/$projectId/commercial/valuations/'
      path: '/valuations'
      fullPath: '/projects/$projectId/commercial/valuations/'
      preLoaderRoute: typeof AppProjectsProjectIdCommercialValuationsIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdCommercialRoute
    }
    '/_app/projects/$projectId/commercial/valuations/$valuationId': {
      id: '/_app/projects/$projectId/commercial/valuations/$valuationId'
      path: '/valuations/$valuationId'
      fullPath: '/projects/$projectId/commercial/valuations/$valuationId'
      preLoaderRoute: typeof AppProjectsProjectIdCommercialValuationsValuationIdRouteImport
      parentRoute: typeof AppProjectsProjectIdCommercialRoute
    }
    '/_app/projects/$projectId/cost/boq/': {
      id: '/_app/projects/$projectId/cost/boq/'
      path: '/boq'
      fullPath: '/projects/$projectId/cost/boq/'
      preLoaderRoute: typeof AppProjectsProjectIdCostBoqIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdCostRoute
    }
    '/_app/projects/$projectId/cost/boq/$boqId': {
      id: '/_app/projects/$projectId/cost/boq/$boqId'
      path: '/boq/$boqId'
      fullPath: '/projects/$projectId/cost/boq/$boqId'
      preLoaderRoute: typeof AppProjectsProjectIdCostBoqBoqIdRouteImport
      parentRoute: typeof AppProjectsProjectIdCostRoute
    }
    '/_app/projects/$projectId/cost/scans/': {
      id: '/_app/projects/$projectId/cost/scans/'
      path: '/scans'
      fullPath: '/projects/$projectId/cost/scans/'
      preLoaderRoute: typeof AppProjectsProjectIdCostScansIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdCostRoute
    }
    '/_app/projects/$projectId/cost/scans/$extractionId': {
      id: '/_app/projects/$projectId/cost/scans/$extractionId'
      path: '/scans/$extractionId'
      fullPath: '/projects/$projectId/cost/scans/$extractionId'
      preLoaderRoute: typeof AppProjectsProjectIdCostScansExtractionIdRouteImport
      parentRoute: typeof AppProjectsProjectIdCostRoute
    }
    '/_app/projects/$projectId/hiring/jobs/': {
      id: '/_app/projects/$projectId/hiring/jobs/'
      path: '/jobs'
      fullPath: '/projects/$projectId/hiring/jobs/'
      preLoaderRoute: typeof AppProjectsProjectIdHiringJobsIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdHiringRoute
    }
    '/_app/projects/$projectId/hiring/jobs/$jobId': {
      id: '/_app/projects/$projectId/hiring/jobs/$jobId'
      path: '/jobs/$jobId'
      fullPath: '/projects/$projectId/hiring/jobs/$jobId'
      preLoaderRoute: typeof AppProjectsProjectIdHiringJobsJobIdRouteImport
      parentRoute: typeof AppProjectsProjectIdHiringRoute
    }
    '/_app/projects/$projectId/hiring/openings/': {
      id: '/_app/projects/$projectId/hiring/openings/'
      path: '/openings'
      fullPath: '/projects/$projectId/hiring/openings/'
      preLoaderRoute: typeof AppProjectsProjectIdHiringOpeningsIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdHiringRoute
    }
    '/_app/projects/$projectId/hiring/openings/$openingId': {
      id: '/_app/projects/$projectId/hiring/openings/$openingId'
      path: '/openings/$openingId'
      fullPath: '/projects/$projectId/hiring/openings/$openingId'
      preLoaderRoute: typeof AppProjectsProjectIdHiringOpeningsOpeningIdRouteImport
      parentRoute: typeof AppProjectsProjectIdHiringRoute
    }
    '/_app/projects/$projectId/hiring/quotes/': {
      id: '/_app/projects/$projectId/hiring/quotes/'
      path: '/quotes'
      fullPath: '/projects/$projectId/hiring/quotes/'
      preLoaderRoute: typeof AppProjectsProjectIdHiringQuotesIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdHiringRoute
    }
    '/_app/projects/$projectId/hiring/quotes/$quoteId': {
      id: '/_app/projects/$projectId/hiring/quotes/$quoteId'
      path: '/quotes/$quoteId'
      fullPath: '/projects/$projectId/hiring/quotes/$quoteId'
      preLoaderRoute: typeof AppProjectsProjectIdHiringQuotesQuoteIdRouteImport
      parentRoute: typeof AppProjectsProjectIdHiringRoute
    }
    '/_app/projects/$projectId/insights/weekly/': {
      id: '/_app/projects/$projectId/insights/weekly/'
      path: '/weekly'
      fullPath: '/projects/$projectId/insights/weekly/'
      preLoaderRoute: typeof AppProjectsProjectIdInsightsWeeklyIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdInsightsRoute
    }
    '/_app/projects/$projectId/insights/weekly/$summaryId': {
      id: '/_app/projects/$projectId/insights/weekly/$summaryId'
      path: '/weekly/$summaryId'
      fullPath: '/projects/$projectId/insights/weekly/$summaryId'
      preLoaderRoute: typeof AppProjectsProjectIdInsightsWeeklySummaryIdRouteImport
      parentRoute: typeof AppProjectsProjectIdInsightsRoute
    }
    '/_app/projects/$projectId/labour-evidence/payroll/': {
      id: '/_app/projects/$projectId/labour-evidence/payroll/'
      path: '/labour-evidence/payroll'
      fullPath: '/projects/$projectId/labour-evidence/payroll/'
      preLoaderRoute: typeof AppProjectsProjectIdLabourEvidencePayrollIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/labour-evidence/payroll/$runId': {
      id: '/_app/projects/$projectId/labour-evidence/payroll/$runId'
      path: '/labour-evidence/payroll/$runId'
      fullPath: '/projects/$projectId/labour-evidence/payroll/$runId'
      preLoaderRoute: typeof AppProjectsProjectIdLabourEvidencePayrollRunIdRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/procurement/orders/': {
      id: '/_app/projects/$projectId/procurement/orders/'
      path: '/orders'
      fullPath: '/projects/$projectId/procurement/orders/'
      preLoaderRoute: typeof AppProjectsProjectIdProcurementOrdersIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdProcurementRoute
    }
    '/_app/projects/$projectId/procurement/orders/$poId': {
      id: '/_app/projects/$projectId/procurement/orders/$poId'
      path: '/orders/$poId'
      fullPath: '/projects/$projectId/procurement/orders/$poId'
      preLoaderRoute: typeof AppProjectsProjectIdProcurementOrdersPoIdRouteImport
      parentRoute: typeof AppProjectsProjectIdProcurementRoute
    }
    '/_app/projects/$projectId/procurement/rfqs/': {
      id: '/_app/projects/$projectId/procurement/rfqs/'
      path: '/rfqs'
      fullPath: '/projects/$projectId/procurement/rfqs/'
      preLoaderRoute: typeof AppProjectsProjectIdProcurementRfqsIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdProcurementRoute
    }
    '/_app/projects/$projectId/procurement/rfqs/$rfqId': {
      id: '/_app/projects/$projectId/procurement/rfqs/$rfqId'
      path: '/rfqs/$rfqId'
      fullPath: '/projects/$projectId/procurement/rfqs/$rfqId'
      preLoaderRoute: typeof AppProjectsProjectIdProcurementRfqsRfqIdRouteImport
      parentRoute: typeof AppProjectsProjectIdProcurementRoute
    }
    '/_app/projects/$projectId/procurement/shop/': {
      id: '/_app/projects/$projectId/procurement/shop/'
      path: '/shop'
      fullPath: '/projects/$projectId/procurement/shop/'
      preLoaderRoute: typeof AppProjectsProjectIdProcurementShopIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdProcurementRoute
    }
    '/_app/projects/$projectId/procurement/shop/$orgId': {
      id: '/_app/projects/$projectId/procurement/shop/$orgId'
      path: '/shop/$orgId'
      fullPath: '/projects/$projectId/procurement/shop/$orgId'
      preLoaderRoute: typeof AppProjectsProjectIdProcurementShopOrgIdRouteImport
      parentRoute: typeof AppProjectsProjectIdProcurementRoute
    }
    '/_app/projects/$projectId/quality/inspections/': {
      id: '/_app/projects/$projectId/quality/inspections/'
      path: '/inspections'
      fullPath: '/projects/$projectId/quality/inspections/'
      preLoaderRoute: typeof AppProjectsProjectIdQualityInspectionsIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdQualityRoute
    }
    '/_app/projects/$projectId/quality/inspections/$inspectionId': {
      id: '/_app/projects/$projectId/quality/inspections/$inspectionId'
      path: '/inspections/$inspectionId'
      fullPath: '/projects/$projectId/quality/inspections/$inspectionId'
      preLoaderRoute: typeof AppProjectsProjectIdQualityInspectionsInspectionIdRouteImport
      parentRoute: typeof AppProjectsProjectIdQualityRoute
    }
    '/_app/projects/$projectId/safety/walks/': {
      id: '/_app/projects/$projectId/safety/walks/'
      path: '/walks'
      fullPath: '/projects/$projectId/safety/walks/'
      preLoaderRoute: typeof AppProjectsProjectIdSafetyWalksIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdSafetyRoute
    }
    '/_app/projects/$projectId/safety/walks/$inspectionId': {
      id: '/_app/projects/$projectId/safety/walks/$inspectionId'
      path: '/walks/$inspectionId'
      fullPath: '/projects/$projectId/safety/walks/$inspectionId'
      preLoaderRoute: typeof AppProjectsProjectIdSafetyWalksInspectionIdRouteImport
      parentRoute: typeof AppProjectsProjectIdSafetyRoute
    }
    '/_app/projects/$projectId/subcontracts/contracts/$subcontractId': {
      id: '/_app/projects/$projectId/subcontracts/contracts/$subcontractId'
      path: '/contracts/$subcontractId'
      fullPath: '/projects/$projectId/subcontracts/contracts/$subcontractId'
      preLoaderRoute: typeof AppProjectsProjectIdSubcontractsContractsSubcontractIdRouteImport
      parentRoute: typeof AppProjectsProjectIdSubcontractsRoute
    }
    '/_app/projects/$projectId/subcontracts/packages/': {
      id: '/_app/projects/$projectId/subcontracts/packages/'
      path: '/packages'
      fullPath: '/projects/$projectId/subcontracts/packages/'
      preLoaderRoute: typeof AppProjectsProjectIdSubcontractsPackagesIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdSubcontractsRoute
    }
    '/_app/projects/$projectId/subcontracts/packages/$packageId': {
      id: '/_app/projects/$projectId/subcontracts/packages/$packageId'
      path: '/packages/$packageId'
      fullPath: '/projects/$projectId/subcontracts/packages/$packageId'
      preLoaderRoute: typeof AppProjectsProjectIdSubcontractsPackagesPackageIdRouteImport
      parentRoute: typeof AppProjectsProjectIdSubcontractsRoute
    }
    '/_app/projects/$projectId/workforce/crew/': {
      id: '/_app/projects/$projectId/workforce/crew/'
      path: '/crew'
      fullPath: '/projects/$projectId/workforce/crew/'
      preLoaderRoute: typeof AppProjectsProjectIdWorkforceCrewIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdWorkforceRoute
    }
    '/_app/projects/$projectId/workforce/crew/$engagementId': {
      id: '/_app/projects/$projectId/workforce/crew/$engagementId'
      path: '/crew/$engagementId'
      fullPath: '/projects/$projectId/workforce/crew/$engagementId'
      preLoaderRoute: typeof AppProjectsProjectIdWorkforceCrewEngagementIdRouteImport
      parentRoute: typeof AppProjectsProjectIdWorkforceRoute
    }
    '/_app/projects/$projectId/workforce/payroll/': {
      id: '/_app/projects/$projectId/workforce/payroll/'
      path: '/payroll'
      fullPath: '/projects/$projectId/workforce/payroll/'
      preLoaderRoute: typeof AppProjectsProjectIdWorkforcePayrollIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdWorkforceRoute
    }
    '/_app/projects/$projectId/workforce/payroll/$runId': {
      id: '/_app/projects/$projectId/workforce/payroll/$runId'
      path: '/payroll/$runId'
      fullPath: '/projects/$projectId/workforce/payroll/$runId'
      preLoaderRoute: typeof AppProjectsProjectIdWorkforcePayrollRunIdRouteImport
      parentRoute: typeof AppProjectsProjectIdWorkforceRoute
    }
  }
}

interface AppAccountRouteChildren {
  AppAccountAccountingRoute: typeof AppAccountAccountingRoute
  AppAccountApprovalRulesRoute: typeof AppAccountApprovalRulesRoute
  AppAccountShortlistRoute: typeof AppAccountShortlistRoute
}

const AppAccountRouteChildren: AppAccountRouteChildren = {
  AppAccountAccountingRoute: AppAccountAccountingRoute,
  AppAccountApprovalRulesRoute: AppAccountApprovalRulesRoute,
  AppAccountShortlistRoute: AppAccountShortlistRoute,
}

const AppAccountRouteWithChildren = AppAccountRoute._addFileChildren(
  AppAccountRouteChildren,
)

interface AppMeRouteChildren {
  AppMeAttendanceRoute: typeof AppMeAttendanceRoute
  AppMeEarningsRoute: typeof AppMeEarningsRoute
  AppMeProfileRoute: typeof AppMeProfileRoute
  AppMeIndexRoute: typeof AppMeIndexRoute
  AppMeServicesApplicationsRoute: typeof AppMeServicesApplicationsRoute
  AppMeServicesInvitationsRoute: typeof AppMeServicesInvitationsRoute
  AppMeServicesOpeningsRoute: typeof AppMeServicesOpeningsRoute
  AppMeWorkCertificatesRoute: typeof AppMeWorkCertificatesRoute
  AppMeWorkJobsRoute: typeof AppMeWorkJobsRoute
  AppMeWorkListingRoute: typeof AppMeWorkListingRoute
  AppMeWorkRequestsRoute: typeof AppMeWorkRequestsRoute
  AppMeWorkReviewsRoute: typeof AppMeWorkReviewsRoute
  AppMeServicesIndexRoute: typeof AppMeServicesIndexRoute
  AppMeWorkIndexRoute: typeof AppMeWorkIndexRoute
  AppMeServicesJobsJobIdRoute: typeof AppMeServicesJobsJobIdRoute
  AppMeServicesQuotesResponseIdRoute: typeof AppMeServicesQuotesResponseIdRoute
  AppMeServicesTendersPackageIdRoute: typeof AppMeServicesTendersPackageIdRoute
  AppMeServicesJobsIndexRoute: typeof AppMeServicesJobsIndexRoute
  AppMeServicesQuotesIndexRoute: typeof AppMeServicesQuotesIndexRoute
  AppMeServicesTendersIndexRoute: typeof AppMeServicesTendersIndexRoute
}

const AppMeRouteChildren: AppMeRouteChildren = {
  AppMeAttendanceRoute: AppMeAttendanceRoute,
  AppMeEarningsRoute: AppMeEarningsRoute,
  AppMeProfileRoute: AppMeProfileRoute,
  AppMeIndexRoute: AppMeIndexRoute,
  AppMeServicesApplicationsRoute: AppMeServicesApplicationsRoute,
  AppMeServicesInvitationsRoute: AppMeServicesInvitationsRoute,
  AppMeServicesOpeningsRoute: AppMeServicesOpeningsRoute,
  AppMeWorkCertificatesRoute: AppMeWorkCertificatesRoute,
  AppMeWorkJobsRoute: AppMeWorkJobsRoute,
  AppMeWorkListingRoute: AppMeWorkListingRoute,
  AppMeWorkRequestsRoute: AppMeWorkRequestsRoute,
  AppMeWorkReviewsRoute: AppMeWorkReviewsRoute,
  AppMeServicesIndexRoute: AppMeServicesIndexRoute,
  AppMeWorkIndexRoute: AppMeWorkIndexRoute,
  AppMeServicesJobsJobIdRoute: AppMeServicesJobsJobIdRoute,
  AppMeServicesQuotesResponseIdRoute: AppMeServicesQuotesResponseIdRoute,
  AppMeServicesTendersPackageIdRoute: AppMeServicesTendersPackageIdRoute,
  AppMeServicesJobsIndexRoute: AppMeServicesJobsIndexRoute,
  AppMeServicesQuotesIndexRoute: AppMeServicesQuotesIndexRoute,
  AppMeServicesTendersIndexRoute: AppMeServicesTendersIndexRoute,
}

const AppMeRouteWithChildren = AppMeRoute._addFileChildren(AppMeRouteChildren)

interface AppOrgOrgIdRouteChildren {
  AppOrgOrgIdApprovalRulesRoute: typeof AppOrgOrgIdApprovalRulesRoute
  AppOrgOrgIdAuditRoute: typeof AppOrgOrgIdAuditRoute
  AppOrgOrgIdBillingRoute: typeof AppOrgOrgIdBillingRoute
  AppOrgOrgIdClientsRoute: typeof AppOrgOrgIdClientsRoute
  AppOrgOrgIdFeesRoute: typeof AppOrgOrgIdFeesRoute
  AppOrgOrgIdIntegrationsRoute: typeof AppOrgOrgIdIntegrationsRoute
  AppOrgOrgIdJobsRoute: typeof AppOrgOrgIdJobsRoute
  AppOrgOrgIdMembersRoute: typeof AppOrgOrgIdMembersRoute
  AppOrgOrgIdOverviewRoute: typeof AppOrgOrgIdOverviewRoute
  AppOrgOrgIdPortfolioRoute: typeof AppOrgOrgIdPortfolioRoute
  AppOrgOrgIdProfileRoute: typeof AppOrgOrgIdProfileRoute
  AppOrgOrgIdProjectsRoute: typeof AppOrgOrgIdProjectsRoute
  AppOrgOrgIdRolesRoute: typeof AppOrgOrgIdRolesRoute
  AppOrgOrgIdSettingsRoute: typeof AppOrgOrgIdSettingsRoute
  AppOrgOrgIdShortlistRoute: typeof AppOrgOrgIdShortlistRoute
  AppOrgOrgIdTemplatesRoute: typeof AppOrgOrgIdTemplatesRoute
  AppOrgOrgIdWorkloadRoute: typeof AppOrgOrgIdWorkloadRoute
  AppOrgOrgIdIndexRoute: typeof AppOrgOrgIdIndexRoute
  AppOrgOrgIdReportsReportKeyRoute: typeof AppOrgOrgIdReportsReportKeyRoute
  AppOrgOrgIdTendersPackageIdRoute: typeof AppOrgOrgIdTendersPackageIdRoute
  AppOrgOrgIdReportsIndexRoute: typeof AppOrgOrgIdReportsIndexRoute
  AppOrgOrgIdTendersIndexRoute: typeof AppOrgOrgIdTendersIndexRoute
}

const AppOrgOrgIdRouteChildren: AppOrgOrgIdRouteChildren = {
  AppOrgOrgIdApprovalRulesRoute: AppOrgOrgIdApprovalRulesRoute,
  AppOrgOrgIdAuditRoute: AppOrgOrgIdAuditRoute,
  AppOrgOrgIdBillingRoute: AppOrgOrgIdBillingRoute,
  AppOrgOrgIdClientsRoute: AppOrgOrgIdClientsRoute,
  AppOrgOrgIdFeesRoute: AppOrgOrgIdFeesRoute,
  AppOrgOrgIdIntegrationsRoute: AppOrgOrgIdIntegrationsRoute,
  AppOrgOrgIdJobsRoute: AppOrgOrgIdJobsRoute,
  AppOrgOrgIdMembersRoute: AppOrgOrgIdMembersRoute,
  AppOrgOrgIdOverviewRoute: AppOrgOrgIdOverviewRoute,
  AppOrgOrgIdPortfolioRoute: AppOrgOrgIdPortfolioRoute,
  AppOrgOrgIdProfileRoute: AppOrgOrgIdProfileRoute,
  AppOrgOrgIdProjectsRoute: AppOrgOrgIdProjectsRoute,
  AppOrgOrgIdRolesRoute: AppOrgOrgIdRolesRoute,
  AppOrgOrgIdSettingsRoute: AppOrgOrgIdSettingsRoute,
  AppOrgOrgIdShortlistRoute: AppOrgOrgIdShortlistRoute,
  AppOrgOrgIdTemplatesRoute: AppOrgOrgIdTemplatesRoute,
  AppOrgOrgIdWorkloadRoute: AppOrgOrgIdWorkloadRoute,
  AppOrgOrgIdIndexRoute: AppOrgOrgIdIndexRoute,
  AppOrgOrgIdReportsReportKeyRoute: AppOrgOrgIdReportsReportKeyRoute,
  AppOrgOrgIdTendersPackageIdRoute: AppOrgOrgIdTendersPackageIdRoute,
  AppOrgOrgIdReportsIndexRoute: AppOrgOrgIdReportsIndexRoute,
  AppOrgOrgIdTendersIndexRoute: AppOrgOrgIdTendersIndexRoute,
}

const AppOrgOrgIdRouteWithChildren = AppOrgOrgIdRoute._addFileChildren(
  AppOrgOrgIdRouteChildren,
)

interface AppProjectsProjectIdCloseoutRouteChildren {
  AppProjectsProjectIdCloseoutOverviewRoute: typeof AppProjectsProjectIdCloseoutOverviewRoute
  AppProjectsProjectIdCloseoutWarrantyRoute: typeof AppProjectsProjectIdCloseoutWarrantyRoute
  AppProjectsProjectIdCloseoutIndexRoute: typeof AppProjectsProjectIdCloseoutIndexRoute
}

const AppProjectsProjectIdCloseoutRouteChildren: AppProjectsProjectIdCloseoutRouteChildren =
  {
    AppProjectsProjectIdCloseoutOverviewRoute:
      AppProjectsProjectIdCloseoutOverviewRoute,
    AppProjectsProjectIdCloseoutWarrantyRoute:
      AppProjectsProjectIdCloseoutWarrantyRoute,
    AppProjectsProjectIdCloseoutIndexRoute:
      AppProjectsProjectIdCloseoutIndexRoute,
  }

const AppProjectsProjectIdCloseoutRouteWithChildren =
  AppProjectsProjectIdCloseoutRoute._addFileChildren(
    AppProjectsProjectIdCloseoutRouteChildren,
  )

interface AppProjectsProjectIdCommercialRouteChildren {
  AppProjectsProjectIdCommercialCertificatesRoute: typeof AppProjectsProjectIdCommercialCertificatesRoute
  AppProjectsProjectIdCommercialClaimsRoute: typeof AppProjectsProjectIdCommercialClaimsRoute
  AppProjectsProjectIdCommercialContractRoute: typeof AppProjectsProjectIdCommercialContractRoute
  AppProjectsProjectIdCommercialCostControlRoute: typeof AppProjectsProjectIdCommercialCostControlRoute
  AppProjectsProjectIdCommercialCostPlansRoute: typeof AppProjectsProjectIdCommercialCostPlansRoute
  AppProjectsProjectIdCommercialFinalAccountRoute: typeof AppProjectsProjectIdCommercialFinalAccountRoute
  AppProjectsProjectIdCommercialOverviewRoute: typeof AppProjectsProjectIdCommercialOverviewRoute
  AppProjectsProjectIdCommercialPaymentsRoute: typeof AppProjectsProjectIdCommercialPaymentsRoute
  AppProjectsProjectIdCommercialRetentionRoute: typeof AppProjectsProjectIdCommercialRetentionRoute
  AppProjectsProjectIdCommercialSumsRoute: typeof AppProjectsProjectIdCommercialSumsRoute
  AppProjectsProjectIdCommercialVariationsRoute: typeof AppProjectsProjectIdCommercialVariationsRoute
  AppProjectsProjectIdCommercialIndexRoute: typeof AppProjectsProjectIdCommercialIndexRoute
  AppProjectsProjectIdCommercialMeasureValuationIdRoute: typeof AppProjectsProjectIdCommercialMeasureValuationIdRoute
  AppProjectsProjectIdCommercialValuationsValuationIdRoute: typeof AppProjectsProjectIdCommercialValuationsValuationIdRoute
  AppProjectsProjectIdCommercialValuationsIndexRoute: typeof AppProjectsProjectIdCommercialValuationsIndexRoute
}

const AppProjectsProjectIdCommercialRouteChildren: AppProjectsProjectIdCommercialRouteChildren =
  {
    AppProjectsProjectIdCommercialCertificatesRoute:
      AppProjectsProjectIdCommercialCertificatesRoute,
    AppProjectsProjectIdCommercialClaimsRoute:
      AppProjectsProjectIdCommercialClaimsRoute,
    AppProjectsProjectIdCommercialContractRoute:
      AppProjectsProjectIdCommercialContractRoute,
    AppProjectsProjectIdCommercialCostControlRoute:
      AppProjectsProjectIdCommercialCostControlRoute,
    AppProjectsProjectIdCommercialCostPlansRoute:
      AppProjectsProjectIdCommercialCostPlansRoute,
    AppProjectsProjectIdCommercialFinalAccountRoute:
      AppProjectsProjectIdCommercialFinalAccountRoute,
    AppProjectsProjectIdCommercialOverviewRoute:
      AppProjectsProjectIdCommercialOverviewRoute,
    AppProjectsProjectIdCommercialPaymentsRoute:
      AppProjectsProjectIdCommercialPaymentsRoute,
    AppProjectsProjectIdCommercialRetentionRoute:
      AppProjectsProjectIdCommercialRetentionRoute,
    AppProjectsProjectIdCommercialSumsRoute:
      AppProjectsProjectIdCommercialSumsRoute,
    AppProjectsProjectIdCommercialVariationsRoute:
      AppProjectsProjectIdCommercialVariationsRoute,
    AppProjectsProjectIdCommercialIndexRoute:
      AppProjectsProjectIdCommercialIndexRoute,
    AppProjectsProjectIdCommercialMeasureValuationIdRoute:
      AppProjectsProjectIdCommercialMeasureValuationIdRoute,
    AppProjectsProjectIdCommercialValuationsValuationIdRoute:
      AppProjectsProjectIdCommercialValuationsValuationIdRoute,
    AppProjectsProjectIdCommercialValuationsIndexRoute:
      AppProjectsProjectIdCommercialValuationsIndexRoute,
  }

const AppProjectsProjectIdCommercialRouteWithChildren =
  AppProjectsProjectIdCommercialRoute._addFileChildren(
    AppProjectsProjectIdCommercialRouteChildren,
  )

interface AppProjectsProjectIdCostRouteChildren {
  AppProjectsProjectIdCostExpensesRoute: typeof AppProjectsProjectIdCostExpensesRoute
  AppProjectsProjectIdCostMaterialsOnSiteRoute: typeof AppProjectsProjectIdCostMaterialsOnSiteRoute
  AppProjectsProjectIdCostOverviewRoute: typeof AppProjectsProjectIdCostOverviewRoute
  AppProjectsProjectIdCostVariationsRoute: typeof AppProjectsProjectIdCostVariationsRoute
  AppProjectsProjectIdCostIndexRoute: typeof AppProjectsProjectIdCostIndexRoute
  AppProjectsProjectIdCostBoqBoqIdRoute: typeof AppProjectsProjectIdCostBoqBoqIdRoute
  AppProjectsProjectIdCostScansExtractionIdRoute: typeof AppProjectsProjectIdCostScansExtractionIdRoute
  AppProjectsProjectIdCostBoqIndexRoute: typeof AppProjectsProjectIdCostBoqIndexRoute
  AppProjectsProjectIdCostScansIndexRoute: typeof AppProjectsProjectIdCostScansIndexRoute
}

const AppProjectsProjectIdCostRouteChildren: AppProjectsProjectIdCostRouteChildren =
  {
    AppProjectsProjectIdCostExpensesRoute:
      AppProjectsProjectIdCostExpensesRoute,
    AppProjectsProjectIdCostMaterialsOnSiteRoute:
      AppProjectsProjectIdCostMaterialsOnSiteRoute,
    AppProjectsProjectIdCostOverviewRoute:
      AppProjectsProjectIdCostOverviewRoute,
    AppProjectsProjectIdCostVariationsRoute:
      AppProjectsProjectIdCostVariationsRoute,
    AppProjectsProjectIdCostIndexRoute: AppProjectsProjectIdCostIndexRoute,
    AppProjectsProjectIdCostBoqBoqIdRoute:
      AppProjectsProjectIdCostBoqBoqIdRoute,
    AppProjectsProjectIdCostScansExtractionIdRoute:
      AppProjectsProjectIdCostScansExtractionIdRoute,
    AppProjectsProjectIdCostBoqIndexRoute:
      AppProjectsProjectIdCostBoqIndexRoute,
    AppProjectsProjectIdCostScansIndexRoute:
      AppProjectsProjectIdCostScansIndexRoute,
  }

const AppProjectsProjectIdCostRouteWithChildren =
  AppProjectsProjectIdCostRoute._addFileChildren(
    AppProjectsProjectIdCostRouteChildren,
  )

interface AppProjectsProjectIdDecisionsRouteChildren {
  AppProjectsProjectIdDecisionsChangeRequestsRoute: typeof AppProjectsProjectIdDecisionsChangeRequestsRoute
  AppProjectsProjectIdDecisionsSelectionsRoute: typeof AppProjectsProjectIdDecisionsSelectionsRoute
  AppProjectsProjectIdDecisionsIndexRoute: typeof AppProjectsProjectIdDecisionsIndexRoute
}

const AppProjectsProjectIdDecisionsRouteChildren: AppProjectsProjectIdDecisionsRouteChildren =
  {
    AppProjectsProjectIdDecisionsChangeRequestsRoute:
      AppProjectsProjectIdDecisionsChangeRequestsRoute,
    AppProjectsProjectIdDecisionsSelectionsRoute:
      AppProjectsProjectIdDecisionsSelectionsRoute,
    AppProjectsProjectIdDecisionsIndexRoute:
      AppProjectsProjectIdDecisionsIndexRoute,
  }

const AppProjectsProjectIdDecisionsRouteWithChildren =
  AppProjectsProjectIdDecisionsRoute._addFileChildren(
    AppProjectsProjectIdDecisionsRouteChildren,
  )

interface AppProjectsProjectIdDesignRouteChildren {
  AppProjectsProjectIdDesignCompareRoute: typeof AppProjectsProjectIdDesignCompareRoute
  AppProjectsProjectIdDesignCompletionRoute: typeof AppProjectsProjectIdDesignCompletionRoute
  AppProjectsProjectIdDesignCoordinationRoute: typeof AppProjectsProjectIdDesignCoordinationRoute
  AppProjectsProjectIdDesignDeliverablesRoute: typeof AppProjectsProjectIdDesignDeliverablesRoute
  AppProjectsProjectIdDesignDrawingsRoute: typeof AppProjectsProjectIdDesignDrawingsRoute
  AppProjectsProjectIdDesignOverviewRoute: typeof AppProjectsProjectIdDesignOverviewRoute
  AppProjectsProjectIdDesignRfisRoute: typeof AppProjectsProjectIdDesignRfisRoute
  AppProjectsProjectIdDesignSiteVisitsRoute: typeof AppProjectsProjectIdDesignSiteVisitsRoute
  AppProjectsProjectIdDesignSpecificationsRoute: typeof AppProjectsProjectIdDesignSpecificationsRoute
  AppProjectsProjectIdDesignSubmittalsRoute: typeof AppProjectsProjectIdDesignSubmittalsRoute
  AppProjectsProjectIdDesignTransmittalsRoute: typeof AppProjectsProjectIdDesignTransmittalsRoute
  AppProjectsProjectIdDesignIndexRoute: typeof AppProjectsProjectIdDesignIndexRoute
}

const AppProjectsProjectIdDesignRouteChildren: AppProjectsProjectIdDesignRouteChildren =
  {
    AppProjectsProjectIdDesignCompareRoute:
      AppProjectsProjectIdDesignCompareRoute,
    AppProjectsProjectIdDesignCompletionRoute:
      AppProjectsProjectIdDesignCompletionRoute,
    AppProjectsProjectIdDesignCoordinationRoute:
      AppProjectsProjectIdDesignCoordinationRoute,
    AppProjectsProjectIdDesignDeliverablesRoute:
      AppProjectsProjectIdDesignDeliverablesRoute,
    AppProjectsProjectIdDesignDrawingsRoute:
      AppProjectsProjectIdDesignDrawingsRoute,
    AppProjectsProjectIdDesignOverviewRoute:
      AppProjectsProjectIdDesignOverviewRoute,
    AppProjectsProjectIdDesignRfisRoute: AppProjectsProjectIdDesignRfisRoute,
    AppProjectsProjectIdDesignSiteVisitsRoute:
      AppProjectsProjectIdDesignSiteVisitsRoute,
    AppProjectsProjectIdDesignSpecificationsRoute:
      AppProjectsProjectIdDesignSpecificationsRoute,
    AppProjectsProjectIdDesignSubmittalsRoute:
      AppProjectsProjectIdDesignSubmittalsRoute,
    AppProjectsProjectIdDesignTransmittalsRoute:
      AppProjectsProjectIdDesignTransmittalsRoute,
    AppProjectsProjectIdDesignIndexRoute: AppProjectsProjectIdDesignIndexRoute,
  }

const AppProjectsProjectIdDesignRouteWithChildren =
  AppProjectsProjectIdDesignRoute._addFileChildren(
    AppProjectsProjectIdDesignRouteChildren,
  )

interface AppProjectsProjectIdHiringRouteChildren {
  AppProjectsProjectIdHiringIndexRoute: typeof AppProjectsProjectIdHiringIndexRoute
  AppProjectsProjectIdHiringJobsJobIdRoute: typeof AppProjectsProjectIdHiringJobsJobIdRoute
  AppProjectsProjectIdHiringOpeningsOpeningIdRoute: typeof AppProjectsProjectIdHiringOpeningsOpeningIdRoute
  AppProjectsProjectIdHiringQuotesQuoteIdRoute: typeof AppProjectsProjectIdHiringQuotesQuoteIdRoute
  AppProjectsProjectIdHiringJobsIndexRoute: typeof AppProjectsProjectIdHiringJobsIndexRoute
  AppProjectsProjectIdHiringOpeningsIndexRoute: typeof AppProjectsProjectIdHiringOpeningsIndexRoute
  AppProjectsProjectIdHiringQuotesIndexRoute: typeof AppProjectsProjectIdHiringQuotesIndexRoute
}

const AppProjectsProjectIdHiringRouteChildren: AppProjectsProjectIdHiringRouteChildren =
  {
    AppProjectsProjectIdHiringIndexRoute: AppProjectsProjectIdHiringIndexRoute,
    AppProjectsProjectIdHiringJobsJobIdRoute:
      AppProjectsProjectIdHiringJobsJobIdRoute,
    AppProjectsProjectIdHiringOpeningsOpeningIdRoute:
      AppProjectsProjectIdHiringOpeningsOpeningIdRoute,
    AppProjectsProjectIdHiringQuotesQuoteIdRoute:
      AppProjectsProjectIdHiringQuotesQuoteIdRoute,
    AppProjectsProjectIdHiringJobsIndexRoute:
      AppProjectsProjectIdHiringJobsIndexRoute,
    AppProjectsProjectIdHiringOpeningsIndexRoute:
      AppProjectsProjectIdHiringOpeningsIndexRoute,
    AppProjectsProjectIdHiringQuotesIndexRoute:
      AppProjectsProjectIdHiringQuotesIndexRoute,
  }

const AppProjectsProjectIdHiringRouteWithChildren =
  AppProjectsProjectIdHiringRoute._addFileChildren(
    AppProjectsProjectIdHiringRouteChildren,
  )

interface AppProjectsProjectIdInsightsRouteChildren {
  AppProjectsProjectIdInsightsFlagsRoute: typeof AppProjectsProjectIdInsightsFlagsRoute
  AppProjectsProjectIdInsightsForecastRoute: typeof AppProjectsProjectIdInsightsForecastRoute
  AppProjectsProjectIdInsightsIndexRoute: typeof AppProjectsProjectIdInsightsIndexRoute
  AppProjectsProjectIdInsightsWeeklySummaryIdRoute: typeof AppProjectsProjectIdInsightsWeeklySummaryIdRoute
  AppProjectsProjectIdInsightsWeeklyIndexRoute: typeof AppProjectsProjectIdInsightsWeeklyIndexRoute
}

const AppProjectsProjectIdInsightsRouteChildren: AppProjectsProjectIdInsightsRouteChildren =
  {
    AppProjectsProjectIdInsightsFlagsRoute:
      AppProjectsProjectIdInsightsFlagsRoute,
    AppProjectsProjectIdInsightsForecastRoute:
      AppProjectsProjectIdInsightsForecastRoute,
    AppProjectsProjectIdInsightsIndexRoute:
      AppProjectsProjectIdInsightsIndexRoute,
    AppProjectsProjectIdInsightsWeeklySummaryIdRoute:
      AppProjectsProjectIdInsightsWeeklySummaryIdRoute,
    AppProjectsProjectIdInsightsWeeklyIndexRoute:
      AppProjectsProjectIdInsightsWeeklyIndexRoute,
  }

const AppProjectsProjectIdInsightsRouteWithChildren =
  AppProjectsProjectIdInsightsRoute._addFileChildren(
    AppProjectsProjectIdInsightsRouteChildren,
  )

interface AppProjectsProjectIdPlanRouteChildren {
  AppProjectsProjectIdPlanBaselinesRoute: typeof AppProjectsProjectIdPlanBaselinesRoute
  AppProjectsProjectIdPlanConstraintsRoute: typeof AppProjectsProjectIdPlanConstraintsRoute
  AppProjectsProjectIdPlanLookaheadRoute: typeof AppProjectsProjectIdPlanLookaheadRoute
  AppProjectsProjectIdPlanMilestonesRoute: typeof AppProjectsProjectIdPlanMilestonesRoute
  AppProjectsProjectIdPlanStagesRoute: typeof AppProjectsProjectIdPlanStagesRoute
  AppProjectsProjectIdPlanTasksRoute: typeof AppProjectsProjectIdPlanTasksRoute
  AppProjectsProjectIdPlanWeeklyPlansRoute: typeof AppProjectsProjectIdPlanWeeklyPlansRoute
  AppProjectsProjectIdPlanZonesRoute: typeof AppProjectsProjectIdPlanZonesRoute
  AppProjectsProjectIdPlanIndexRoute: typeof AppProjectsProjectIdPlanIndexRoute
}

const AppProjectsProjectIdPlanRouteChildren: AppProjectsProjectIdPlanRouteChildren =
  {
    AppProjectsProjectIdPlanBaselinesRoute:
      AppProjectsProjectIdPlanBaselinesRoute,
    AppProjectsProjectIdPlanConstraintsRoute:
      AppProjectsProjectIdPlanConstraintsRoute,
    AppProjectsProjectIdPlanLookaheadRoute:
      AppProjectsProjectIdPlanLookaheadRoute,
    AppProjectsProjectIdPlanMilestonesRoute:
      AppProjectsProjectIdPlanMilestonesRoute,
    AppProjectsProjectIdPlanStagesRoute: AppProjectsProjectIdPlanStagesRoute,
    AppProjectsProjectIdPlanTasksRoute: AppProjectsProjectIdPlanTasksRoute,
    AppProjectsProjectIdPlanWeeklyPlansRoute:
      AppProjectsProjectIdPlanWeeklyPlansRoute,
    AppProjectsProjectIdPlanZonesRoute: AppProjectsProjectIdPlanZonesRoute,
    AppProjectsProjectIdPlanIndexRoute: AppProjectsProjectIdPlanIndexRoute,
  }

const AppProjectsProjectIdPlanRouteWithChildren =
  AppProjectsProjectIdPlanRoute._addFileChildren(
    AppProjectsProjectIdPlanRouteChildren,
  )

interface AppProjectsProjectIdProcurementRouteChildren {
  AppProjectsProjectIdProcurementCartRoute: typeof AppProjectsProjectIdProcurementCartRoute
  AppProjectsProjectIdProcurementDeliveriesRoute: typeof AppProjectsProjectIdProcurementDeliveriesRoute
  AppProjectsProjectIdProcurementInvoicesRoute: typeof AppProjectsProjectIdProcurementInvoicesRoute
  AppProjectsProjectIdProcurementRequisitionsRoute: typeof AppProjectsProjectIdProcurementRequisitionsRoute
  AppProjectsProjectIdProcurementIndexRoute: typeof AppProjectsProjectIdProcurementIndexRoute
  AppProjectsProjectIdProcurementOrdersPoIdRoute: typeof AppProjectsProjectIdProcurementOrdersPoIdRoute
  AppProjectsProjectIdProcurementRfqsRfqIdRoute: typeof AppProjectsProjectIdProcurementRfqsRfqIdRoute
  AppProjectsProjectIdProcurementShopOrgIdRoute: typeof AppProjectsProjectIdProcurementShopOrgIdRoute
  AppProjectsProjectIdProcurementOrdersIndexRoute: typeof AppProjectsProjectIdProcurementOrdersIndexRoute
  AppProjectsProjectIdProcurementRfqsIndexRoute: typeof AppProjectsProjectIdProcurementRfqsIndexRoute
  AppProjectsProjectIdProcurementShopIndexRoute: typeof AppProjectsProjectIdProcurementShopIndexRoute
}

const AppProjectsProjectIdProcurementRouteChildren: AppProjectsProjectIdProcurementRouteChildren =
  {
    AppProjectsProjectIdProcurementCartRoute:
      AppProjectsProjectIdProcurementCartRoute,
    AppProjectsProjectIdProcurementDeliveriesRoute:
      AppProjectsProjectIdProcurementDeliveriesRoute,
    AppProjectsProjectIdProcurementInvoicesRoute:
      AppProjectsProjectIdProcurementInvoicesRoute,
    AppProjectsProjectIdProcurementRequisitionsRoute:
      AppProjectsProjectIdProcurementRequisitionsRoute,
    AppProjectsProjectIdProcurementIndexRoute:
      AppProjectsProjectIdProcurementIndexRoute,
    AppProjectsProjectIdProcurementOrdersPoIdRoute:
      AppProjectsProjectIdProcurementOrdersPoIdRoute,
    AppProjectsProjectIdProcurementRfqsRfqIdRoute:
      AppProjectsProjectIdProcurementRfqsRfqIdRoute,
    AppProjectsProjectIdProcurementShopOrgIdRoute:
      AppProjectsProjectIdProcurementShopOrgIdRoute,
    AppProjectsProjectIdProcurementOrdersIndexRoute:
      AppProjectsProjectIdProcurementOrdersIndexRoute,
    AppProjectsProjectIdProcurementRfqsIndexRoute:
      AppProjectsProjectIdProcurementRfqsIndexRoute,
    AppProjectsProjectIdProcurementShopIndexRoute:
      AppProjectsProjectIdProcurementShopIndexRoute,
  }

const AppProjectsProjectIdProcurementRouteWithChildren =
  AppProjectsProjectIdProcurementRoute._addFileChildren(
    AppProjectsProjectIdProcurementRouteChildren,
  )

interface AppProjectsProjectIdQualityRouteChildren {
  AppProjectsProjectIdQualityChecklistsRoute: typeof AppProjectsProjectIdQualityChecklistsRoute
  AppProjectsProjectIdQualityNcrsRoute: typeof AppProjectsProjectIdQualityNcrsRoute
  AppProjectsProjectIdQualityRectificationsRoute: typeof AppProjectsProjectIdQualityRectificationsRoute
  AppProjectsProjectIdQualitySnagsRoute: typeof AppProjectsProjectIdQualitySnagsRoute
  AppProjectsProjectIdQualityTestsRoute: typeof AppProjectsProjectIdQualityTestsRoute
  AppProjectsProjectIdQualityIndexRoute: typeof AppProjectsProjectIdQualityIndexRoute
  AppProjectsProjectIdQualityInspectionsInspectionIdRoute: typeof AppProjectsProjectIdQualityInspectionsInspectionIdRoute
  AppProjectsProjectIdQualityInspectionsIndexRoute: typeof AppProjectsProjectIdQualityInspectionsIndexRoute
}

const AppProjectsProjectIdQualityRouteChildren: AppProjectsProjectIdQualityRouteChildren =
  {
    AppProjectsProjectIdQualityChecklistsRoute:
      AppProjectsProjectIdQualityChecklistsRoute,
    AppProjectsProjectIdQualityNcrsRoute: AppProjectsProjectIdQualityNcrsRoute,
    AppProjectsProjectIdQualityRectificationsRoute:
      AppProjectsProjectIdQualityRectificationsRoute,
    AppProjectsProjectIdQualitySnagsRoute:
      AppProjectsProjectIdQualitySnagsRoute,
    AppProjectsProjectIdQualityTestsRoute:
      AppProjectsProjectIdQualityTestsRoute,
    AppProjectsProjectIdQualityIndexRoute:
      AppProjectsProjectIdQualityIndexRoute,
    AppProjectsProjectIdQualityInspectionsInspectionIdRoute:
      AppProjectsProjectIdQualityInspectionsInspectionIdRoute,
    AppProjectsProjectIdQualityInspectionsIndexRoute:
      AppProjectsProjectIdQualityInspectionsIndexRoute,
  }

const AppProjectsProjectIdQualityRouteWithChildren =
  AppProjectsProjectIdQualityRoute._addFileChildren(
    AppProjectsProjectIdQualityRouteChildren,
  )

interface AppProjectsProjectIdResourcesRouteChildren {
  AppProjectsProjectIdResourcesEquipmentRoute: typeof AppProjectsProjectIdResourcesEquipmentRoute
  AppProjectsProjectIdResourcesEquipmentRequestsRoute: typeof AppProjectsProjectIdResourcesEquipmentRequestsRoute
  AppProjectsProjectIdResourcesRequestsRoute: typeof AppProjectsProjectIdResourcesRequestsRoute
  AppProjectsProjectIdResourcesStoreRoute: typeof AppProjectsProjectIdResourcesStoreRoute
  AppProjectsProjectIdResourcesSubmittalsRoute: typeof AppProjectsProjectIdResourcesSubmittalsRoute
  AppProjectsProjectIdResourcesIndexRoute: typeof AppProjectsProjectIdResourcesIndexRoute
}

const AppProjectsProjectIdResourcesRouteChildren: AppProjectsProjectIdResourcesRouteChildren =
  {
    AppProjectsProjectIdResourcesEquipmentRoute:
      AppProjectsProjectIdResourcesEquipmentRoute,
    AppProjectsProjectIdResourcesEquipmentRequestsRoute:
      AppProjectsProjectIdResourcesEquipmentRequestsRoute,
    AppProjectsProjectIdResourcesRequestsRoute:
      AppProjectsProjectIdResourcesRequestsRoute,
    AppProjectsProjectIdResourcesStoreRoute:
      AppProjectsProjectIdResourcesStoreRoute,
    AppProjectsProjectIdResourcesSubmittalsRoute:
      AppProjectsProjectIdResourcesSubmittalsRoute,
    AppProjectsProjectIdResourcesIndexRoute:
      AppProjectsProjectIdResourcesIndexRoute,
  }

const AppProjectsProjectIdResourcesRouteWithChildren =
  AppProjectsProjectIdResourcesRoute._addFileChildren(
    AppProjectsProjectIdResourcesRouteChildren,
  )

interface AppProjectsProjectIdSafetyRouteChildren {
  AppProjectsProjectIdSafetyIncidentsRoute: typeof AppProjectsProjectIdSafetyIncidentsRoute
  AppProjectsProjectIdSafetyOverviewRoute: typeof AppProjectsProjectIdSafetyOverviewRoute
  AppProjectsProjectIdSafetyPpeRoute: typeof AppProjectsProjectIdSafetyPpeRoute
  AppProjectsProjectIdSafetyToolboxRoute: typeof AppProjectsProjectIdSafetyToolboxRoute
  AppProjectsProjectIdSafetyIndexRoute: typeof AppProjectsProjectIdSafetyIndexRoute
  AppProjectsProjectIdSafetyWalksInspectionIdRoute: typeof AppProjectsProjectIdSafetyWalksInspectionIdRoute
  AppProjectsProjectIdSafetyWalksIndexRoute: typeof AppProjectsProjectIdSafetyWalksIndexRoute
}

const AppProjectsProjectIdSafetyRouteChildren: AppProjectsProjectIdSafetyRouteChildren =
  {
    AppProjectsProjectIdSafetyIncidentsRoute:
      AppProjectsProjectIdSafetyIncidentsRoute,
    AppProjectsProjectIdSafetyOverviewRoute:
      AppProjectsProjectIdSafetyOverviewRoute,
    AppProjectsProjectIdSafetyPpeRoute: AppProjectsProjectIdSafetyPpeRoute,
    AppProjectsProjectIdSafetyToolboxRoute:
      AppProjectsProjectIdSafetyToolboxRoute,
    AppProjectsProjectIdSafetyIndexRoute: AppProjectsProjectIdSafetyIndexRoute,
    AppProjectsProjectIdSafetyWalksInspectionIdRoute:
      AppProjectsProjectIdSafetyWalksInspectionIdRoute,
    AppProjectsProjectIdSafetyWalksIndexRoute:
      AppProjectsProjectIdSafetyWalksIndexRoute,
  }

const AppProjectsProjectIdSafetyRouteWithChildren =
  AppProjectsProjectIdSafetyRoute._addFileChildren(
    AppProjectsProjectIdSafetyRouteChildren,
  )

interface AppProjectsProjectIdSiteRouteChildren {
  AppProjectsProjectIdSiteAttendanceRoute: typeof AppProjectsProjectIdSiteAttendanceRoute
  AppProjectsProjectIdSiteDailyPlanRoute: typeof AppProjectsProjectIdSiteDailyPlanRoute
  AppProjectsProjectIdSiteDayCloseRoute: typeof AppProjectsProjectIdSiteDayCloseRoute
  AppProjectsProjectIdSiteDiaryRoute: typeof AppProjectsProjectIdSiteDiaryRoute
  AppProjectsProjectIdSiteInstructionsRoute: typeof AppProjectsProjectIdSiteInstructionsRoute
  AppProjectsProjectIdSiteIssuesRoute: typeof AppProjectsProjectIdSiteIssuesRoute
  AppProjectsProjectIdSiteMeetingsRoute: typeof AppProjectsProjectIdSiteMeetingsRoute
  AppProjectsProjectIdSitePhotosRoute: typeof AppProjectsProjectIdSitePhotosRoute
  AppProjectsProjectIdSiteProgressRoute: typeof AppProjectsProjectIdSiteProgressRoute
  AppProjectsProjectIdSiteTodayRoute: typeof AppProjectsProjectIdSiteTodayRoute
  AppProjectsProjectIdSiteVisitorsRoute: typeof AppProjectsProjectIdSiteVisitorsRoute
  AppProjectsProjectIdSiteIndexRoute: typeof AppProjectsProjectIdSiteIndexRoute
}

const AppProjectsProjectIdSiteRouteChildren: AppProjectsProjectIdSiteRouteChildren =
  {
    AppProjectsProjectIdSiteAttendanceRoute:
      AppProjectsProjectIdSiteAttendanceRoute,
    AppProjectsProjectIdSiteDailyPlanRoute:
      AppProjectsProjectIdSiteDailyPlanRoute,
    AppProjectsProjectIdSiteDayCloseRoute:
      AppProjectsProjectIdSiteDayCloseRoute,
    AppProjectsProjectIdSiteDiaryRoute: AppProjectsProjectIdSiteDiaryRoute,
    AppProjectsProjectIdSiteInstructionsRoute:
      AppProjectsProjectIdSiteInstructionsRoute,
    AppProjectsProjectIdSiteIssuesRoute: AppProjectsProjectIdSiteIssuesRoute,
    AppProjectsProjectIdSiteMeetingsRoute:
      AppProjectsProjectIdSiteMeetingsRoute,
    AppProjectsProjectIdSitePhotosRoute: AppProjectsProjectIdSitePhotosRoute,
    AppProjectsProjectIdSiteProgressRoute:
      AppProjectsProjectIdSiteProgressRoute,
    AppProjectsProjectIdSiteTodayRoute: AppProjectsProjectIdSiteTodayRoute,
    AppProjectsProjectIdSiteVisitorsRoute:
      AppProjectsProjectIdSiteVisitorsRoute,
    AppProjectsProjectIdSiteIndexRoute: AppProjectsProjectIdSiteIndexRoute,
  }

const AppProjectsProjectIdSiteRouteWithChildren =
  AppProjectsProjectIdSiteRoute._addFileChildren(
    AppProjectsProjectIdSiteRouteChildren,
  )

interface AppProjectsProjectIdSubcontractsRouteChildren {
  AppProjectsProjectIdSubcontractsChangesRoute: typeof AppProjectsProjectIdSubcontractsChangesRoute
  AppProjectsProjectIdSubcontractsConsentsRoute: typeof AppProjectsProjectIdSubcontractsConsentsRoute
  AppProjectsProjectIdSubcontractsDailyReportsRoute: typeof AppProjectsProjectIdSubcontractsDailyReportsRoute
  AppProjectsProjectIdSubcontractsOverviewRoute: typeof AppProjectsProjectIdSubcontractsOverviewRoute
  AppProjectsProjectIdSubcontractsOwnStockRoute: typeof AppProjectsProjectIdSubcontractsOwnStockRoute
  AppProjectsProjectIdSubcontractsPaymentsRoute: typeof AppProjectsProjectIdSubcontractsPaymentsRoute
  AppProjectsProjectIdSubcontractsPurchasesRoute: typeof AppProjectsProjectIdSubcontractsPurchasesRoute
  AppProjectsProjectIdSubcontractsIndexRoute: typeof AppProjectsProjectIdSubcontractsIndexRoute
  AppProjectsProjectIdSubcontractsContractsSubcontractIdRoute: typeof AppProjectsProjectIdSubcontractsContractsSubcontractIdRoute
  AppProjectsProjectIdSubcontractsPackagesPackageIdRoute: typeof AppProjectsProjectIdSubcontractsPackagesPackageIdRoute
  AppProjectsProjectIdSubcontractsPackagesIndexRoute: typeof AppProjectsProjectIdSubcontractsPackagesIndexRoute
}

const AppProjectsProjectIdSubcontractsRouteChildren: AppProjectsProjectIdSubcontractsRouteChildren =
  {
    AppProjectsProjectIdSubcontractsChangesRoute:
      AppProjectsProjectIdSubcontractsChangesRoute,
    AppProjectsProjectIdSubcontractsConsentsRoute:
      AppProjectsProjectIdSubcontractsConsentsRoute,
    AppProjectsProjectIdSubcontractsDailyReportsRoute:
      AppProjectsProjectIdSubcontractsDailyReportsRoute,
    AppProjectsProjectIdSubcontractsOverviewRoute:
      AppProjectsProjectIdSubcontractsOverviewRoute,
    AppProjectsProjectIdSubcontractsOwnStockRoute:
      AppProjectsProjectIdSubcontractsOwnStockRoute,
    AppProjectsProjectIdSubcontractsPaymentsRoute:
      AppProjectsProjectIdSubcontractsPaymentsRoute,
    AppProjectsProjectIdSubcontractsPurchasesRoute:
      AppProjectsProjectIdSubcontractsPurchasesRoute,
    AppProjectsProjectIdSubcontractsIndexRoute:
      AppProjectsProjectIdSubcontractsIndexRoute,
    AppProjectsProjectIdSubcontractsContractsSubcontractIdRoute:
      AppProjectsProjectIdSubcontractsContractsSubcontractIdRoute,
    AppProjectsProjectIdSubcontractsPackagesPackageIdRoute:
      AppProjectsProjectIdSubcontractsPackagesPackageIdRoute,
    AppProjectsProjectIdSubcontractsPackagesIndexRoute:
      AppProjectsProjectIdSubcontractsPackagesIndexRoute,
  }

const AppProjectsProjectIdSubcontractsRouteWithChildren =
  AppProjectsProjectIdSubcontractsRoute._addFileChildren(
    AppProjectsProjectIdSubcontractsRouteChildren,
  )

interface AppProjectsProjectIdTimelineRouteChildren {
  AppProjectsProjectIdTimelineActivityRoute: typeof AppProjectsProjectIdTimelineActivityRoute
  AppProjectsProjectIdTimelinePhotosRoute: typeof AppProjectsProjectIdTimelinePhotosRoute
  AppProjectsProjectIdTimelineIndexRoute: typeof AppProjectsProjectIdTimelineIndexRoute
}

const AppProjectsProjectIdTimelineRouteChildren: AppProjectsProjectIdTimelineRouteChildren =
  {
    AppProjectsProjectIdTimelineActivityRoute:
      AppProjectsProjectIdTimelineActivityRoute,
    AppProjectsProjectIdTimelinePhotosRoute:
      AppProjectsProjectIdTimelinePhotosRoute,
    AppProjectsProjectIdTimelineIndexRoute:
      AppProjectsProjectIdTimelineIndexRoute,
  }

const AppProjectsProjectIdTimelineRouteWithChildren =
  AppProjectsProjectIdTimelineRoute._addFileChildren(
    AppProjectsProjectIdTimelineRouteChildren,
  )

interface AppProjectsProjectIdWorkforceRouteChildren {
  AppProjectsProjectIdWorkforceCrewsRoute: typeof AppProjectsProjectIdWorkforceCrewsRoute
  AppProjectsProjectIdWorkforceProductivityRoute: typeof AppProjectsProjectIdWorkforceProductivityRoute
  AppProjectsProjectIdWorkforceTimesheetsRoute: typeof AppProjectsProjectIdWorkforceTimesheetsRoute
  AppProjectsProjectIdWorkforceIndexRoute: typeof AppProjectsProjectIdWorkforceIndexRoute
  AppProjectsProjectIdWorkforceCrewEngagementIdRoute: typeof AppProjectsProjectIdWorkforceCrewEngagementIdRoute
  AppProjectsProjectIdWorkforcePayrollRunIdRoute: typeof AppProjectsProjectIdWorkforcePayrollRunIdRoute
  AppProjectsProjectIdWorkforceCrewIndexRoute: typeof AppProjectsProjectIdWorkforceCrewIndexRoute
  AppProjectsProjectIdWorkforcePayrollIndexRoute: typeof AppProjectsProjectIdWorkforcePayrollIndexRoute
}

const AppProjectsProjectIdWorkforceRouteChildren: AppProjectsProjectIdWorkforceRouteChildren =
  {
    AppProjectsProjectIdWorkforceCrewsRoute:
      AppProjectsProjectIdWorkforceCrewsRoute,
    AppProjectsProjectIdWorkforceProductivityRoute:
      AppProjectsProjectIdWorkforceProductivityRoute,
    AppProjectsProjectIdWorkforceTimesheetsRoute:
      AppProjectsProjectIdWorkforceTimesheetsRoute,
    AppProjectsProjectIdWorkforceIndexRoute:
      AppProjectsProjectIdWorkforceIndexRoute,
    AppProjectsProjectIdWorkforceCrewEngagementIdRoute:
      AppProjectsProjectIdWorkforceCrewEngagementIdRoute,
    AppProjectsProjectIdWorkforcePayrollRunIdRoute:
      AppProjectsProjectIdWorkforcePayrollRunIdRoute,
    AppProjectsProjectIdWorkforceCrewIndexRoute:
      AppProjectsProjectIdWorkforceCrewIndexRoute,
    AppProjectsProjectIdWorkforcePayrollIndexRoute:
      AppProjectsProjectIdWorkforcePayrollIndexRoute,
  }

const AppProjectsProjectIdWorkforceRouteWithChildren =
  AppProjectsProjectIdWorkforceRoute._addFileChildren(
    AppProjectsProjectIdWorkforceRouteChildren,
  )

interface AppProjectsProjectIdRouteChildren {
  AppProjectsProjectIdCloseoutRoute: typeof AppProjectsProjectIdCloseoutRouteWithChildren
  AppProjectsProjectIdCommercialRoute: typeof AppProjectsProjectIdCommercialRouteWithChildren
  AppProjectsProjectIdCostRoute: typeof AppProjectsProjectIdCostRouteWithChildren
  AppProjectsProjectIdDecisionsRoute: typeof AppProjectsProjectIdDecisionsRouteWithChildren
  AppProjectsProjectIdDesignRoute: typeof AppProjectsProjectIdDesignRouteWithChildren
  AppProjectsProjectIdDocumentsRoute: typeof AppProjectsProjectIdDocumentsRoute
  AppProjectsProjectIdHandoverRoute: typeof AppProjectsProjectIdHandoverRoute
  AppProjectsProjectIdHiringRoute: typeof AppProjectsProjectIdHiringRouteWithChildren
  AppProjectsProjectIdInsightsRoute: typeof AppProjectsProjectIdInsightsRouteWithChildren
  AppProjectsProjectIdOverviewRoute: typeof AppProjectsProjectIdOverviewRoute
  AppProjectsProjectIdOwnerPlanRoute: typeof AppProjectsProjectIdOwnerPlanRoute
  AppProjectsProjectIdPlanRoute: typeof AppProjectsProjectIdPlanRouteWithChildren
  AppProjectsProjectIdProcurementRoute: typeof AppProjectsProjectIdProcurementRouteWithChildren
  AppProjectsProjectIdQualityRoute: typeof AppProjectsProjectIdQualityRouteWithChildren
  AppProjectsProjectIdResourcesRoute: typeof AppProjectsProjectIdResourcesRouteWithChildren
  AppProjectsProjectIdRisksRoute: typeof AppProjectsProjectIdRisksRoute
  AppProjectsProjectIdSafetyRoute: typeof AppProjectsProjectIdSafetyRouteWithChildren
  AppProjectsProjectIdSettingsRoute: typeof AppProjectsProjectIdSettingsRoute
  AppProjectsProjectIdSiteRoute: typeof AppProjectsProjectIdSiteRouteWithChildren
  AppProjectsProjectIdSubcontractsRoute: typeof AppProjectsProjectIdSubcontractsRouteWithChildren
  AppProjectsProjectIdTeamRoute: typeof AppProjectsProjectIdTeamRoute
  AppProjectsProjectIdTimelineRoute: typeof AppProjectsProjectIdTimelineRouteWithChildren
  AppProjectsProjectIdWorkforceRoute: typeof AppProjectsProjectIdWorkforceRouteWithChildren
  AppProjectsProjectIdIndexRoute: typeof AppProjectsProjectIdIndexRoute
  AppProjectsProjectIdLabourEvidenceTimesheetsRoute: typeof AppProjectsProjectIdLabourEvidenceTimesheetsRoute
  AppProjectsProjectIdReportsReportKeyRoute: typeof AppProjectsProjectIdReportsReportKeyRoute
  AppProjectsProjectIdTendersPackageIdRoute: typeof AppProjectsProjectIdTendersPackageIdRoute
  AppProjectsProjectIdLabourEvidenceIndexRoute: typeof AppProjectsProjectIdLabourEvidenceIndexRoute
  AppProjectsProjectIdReportsIndexRoute: typeof AppProjectsProjectIdReportsIndexRoute
  AppProjectsProjectIdTendersIndexRoute: typeof AppProjectsProjectIdTendersIndexRoute
  AppProjectsProjectIdLabourEvidencePayrollRunIdRoute: typeof AppProjectsProjectIdLabourEvidencePayrollRunIdRoute
  AppProjectsProjectIdLabourEvidencePayrollIndexRoute: typeof AppProjectsProjectIdLabourEvidencePayrollIndexRoute
}

const AppProjectsProjectIdRouteChildren: AppProjectsProjectIdRouteChildren = {
  AppProjectsProjectIdCloseoutRoute:
    AppProjectsProjectIdCloseoutRouteWithChildren,
  AppProjectsProjectIdCommercialRoute:
    AppProjectsProjectIdCommercialRouteWithChildren,
  AppProjectsProjectIdCostRoute: AppProjectsProjectIdCostRouteWithChildren,
  AppProjectsProjectIdDecisionsRoute:
    AppProjectsProjectIdDecisionsRouteWithChildren,
  AppProjectsProjectIdDesignRoute: AppProjectsProjectIdDesignRouteWithChildren,
  AppProjectsProjectIdDocumentsRoute: AppProjectsProjectIdDocumentsRoute,
  AppProjectsProjectIdHandoverRoute: AppProjectsProjectIdHandoverRoute,
  AppProjectsProjectIdHiringRoute: AppProjectsProjectIdHiringRouteWithChildren,
  AppProjectsProjectIdInsightsRoute:
    AppProjectsProjectIdInsightsRouteWithChildren,
  AppProjectsProjectIdOverviewRoute: AppProjectsProjectIdOverviewRoute,
  AppProjectsProjectIdOwnerPlanRoute: AppProjectsProjectIdOwnerPlanRoute,
  AppProjectsProjectIdPlanRoute: AppProjectsProjectIdPlanRouteWithChildren,
  AppProjectsProjectIdProcurementRoute:
    AppProjectsProjectIdProcurementRouteWithChildren,
  AppProjectsProjectIdQualityRoute:
    AppProjectsProjectIdQualityRouteWithChildren,
  AppProjectsProjectIdResourcesRoute:
    AppProjectsProjectIdResourcesRouteWithChildren,
  AppProjectsProjectIdRisksRoute: AppProjectsProjectIdRisksRoute,
  AppProjectsProjectIdSafetyRoute: AppProjectsProjectIdSafetyRouteWithChildren,
  AppProjectsProjectIdSettingsRoute: AppProjectsProjectIdSettingsRoute,
  AppProjectsProjectIdSiteRoute: AppProjectsProjectIdSiteRouteWithChildren,
  AppProjectsProjectIdSubcontractsRoute:
    AppProjectsProjectIdSubcontractsRouteWithChildren,
  AppProjectsProjectIdTeamRoute: AppProjectsProjectIdTeamRoute,
  AppProjectsProjectIdTimelineRoute:
    AppProjectsProjectIdTimelineRouteWithChildren,
  AppProjectsProjectIdWorkforceRoute:
    AppProjectsProjectIdWorkforceRouteWithChildren,
  AppProjectsProjectIdIndexRoute: AppProjectsProjectIdIndexRoute,
  AppProjectsProjectIdLabourEvidenceTimesheetsRoute:
    AppProjectsProjectIdLabourEvidenceTimesheetsRoute,
  AppProjectsProjectIdReportsReportKeyRoute:
    AppProjectsProjectIdReportsReportKeyRoute,
  AppProjectsProjectIdTendersPackageIdRoute:
    AppProjectsProjectIdTendersPackageIdRoute,
  AppProjectsProjectIdLabourEvidenceIndexRoute:
    AppProjectsProjectIdLabourEvidenceIndexRoute,
  AppProjectsProjectIdReportsIndexRoute: AppProjectsProjectIdReportsIndexRoute,
  AppProjectsProjectIdTendersIndexRoute: AppProjectsProjectIdTendersIndexRoute,
  AppProjectsProjectIdLabourEvidencePayrollRunIdRoute:
    AppProjectsProjectIdLabourEvidencePayrollRunIdRoute,
  AppProjectsProjectIdLabourEvidencePayrollIndexRoute:
    AppProjectsProjectIdLabourEvidencePayrollIndexRoute,
}

const AppProjectsProjectIdRouteWithChildren =
  AppProjectsProjectIdRoute._addFileChildren(AppProjectsProjectIdRouteChildren)

interface AppSupplierOrgIdRouteChildren {
  AppSupplierOrgIdAnalyticsRoute: typeof AppSupplierOrgIdAnalyticsRoute
  AppSupplierOrgIdBillingRoute: typeof AppSupplierOrgIdBillingRoute
  AppSupplierOrgIdBranchesRoute: typeof AppSupplierOrgIdBranchesRoute
  AppSupplierOrgIdCatalogRoute: typeof AppSupplierOrgIdCatalogRoute
  AppSupplierOrgIdDashboardRoute: typeof AppSupplierOrgIdDashboardRoute
  AppSupplierOrgIdDeliveriesRoute: typeof AppSupplierOrgIdDeliveriesRoute
  AppSupplierOrgIdInvoicesRoute: typeof AppSupplierOrgIdInvoicesRoute
  AppSupplierOrgIdNotificationsRoute: typeof AppSupplierOrgIdNotificationsRoute
  AppSupplierOrgIdPaymentsRoute: typeof AppSupplierOrgIdPaymentsRoute
  AppSupplierOrgIdProfileRoute: typeof AppSupplierOrgIdProfileRoute
  AppSupplierOrgIdPublicRoute: typeof AppSupplierOrgIdPublicRoute
  AppSupplierOrgIdQuotesRoute: typeof AppSupplierOrgIdQuotesRoute
  AppSupplierOrgIdTeamRoute: typeof AppSupplierOrgIdTeamRoute
  AppSupplierOrgIdIndexRoute: typeof AppSupplierOrgIdIndexRoute
  AppSupplierOrgIdCustomersCustomerIdRoute: typeof AppSupplierOrgIdCustomersCustomerIdRoute
  AppSupplierOrgIdMessagesConversationIdRoute: typeof AppSupplierOrgIdMessagesConversationIdRoute
  AppSupplierOrgIdOrdersPoIdRoute: typeof AppSupplierOrgIdOrdersPoIdRoute
  AppSupplierOrgIdRfqsRfqIdRoute: typeof AppSupplierOrgIdRfqsRfqIdRoute
  AppSupplierOrgIdCustomersIndexRoute: typeof AppSupplierOrgIdCustomersIndexRoute
  AppSupplierOrgIdMessagesIndexRoute: typeof AppSupplierOrgIdMessagesIndexRoute
  AppSupplierOrgIdOrdersIndexRoute: typeof AppSupplierOrgIdOrdersIndexRoute
  AppSupplierOrgIdRfqsIndexRoute: typeof AppSupplierOrgIdRfqsIndexRoute
}

const AppSupplierOrgIdRouteChildren: AppSupplierOrgIdRouteChildren = {
  AppSupplierOrgIdAnalyticsRoute: AppSupplierOrgIdAnalyticsRoute,
  AppSupplierOrgIdBillingRoute: AppSupplierOrgIdBillingRoute,
  AppSupplierOrgIdBranchesRoute: AppSupplierOrgIdBranchesRoute,
  AppSupplierOrgIdCatalogRoute: AppSupplierOrgIdCatalogRoute,
  AppSupplierOrgIdDashboardRoute: AppSupplierOrgIdDashboardRoute,
  AppSupplierOrgIdDeliveriesRoute: AppSupplierOrgIdDeliveriesRoute,
  AppSupplierOrgIdInvoicesRoute: AppSupplierOrgIdInvoicesRoute,
  AppSupplierOrgIdNotificationsRoute: AppSupplierOrgIdNotificationsRoute,
  AppSupplierOrgIdPaymentsRoute: AppSupplierOrgIdPaymentsRoute,
  AppSupplierOrgIdProfileRoute: AppSupplierOrgIdProfileRoute,
  AppSupplierOrgIdPublicRoute: AppSupplierOrgIdPublicRoute,
  AppSupplierOrgIdQuotesRoute: AppSupplierOrgIdQuotesRoute,
  AppSupplierOrgIdTeamRoute: AppSupplierOrgIdTeamRoute,
  AppSupplierOrgIdIndexRoute: AppSupplierOrgIdIndexRoute,
  AppSupplierOrgIdCustomersCustomerIdRoute:
    AppSupplierOrgIdCustomersCustomerIdRoute,
  AppSupplierOrgIdMessagesConversationIdRoute:
    AppSupplierOrgIdMessagesConversationIdRoute,
  AppSupplierOrgIdOrdersPoIdRoute: AppSupplierOrgIdOrdersPoIdRoute,
  AppSupplierOrgIdRfqsRfqIdRoute: AppSupplierOrgIdRfqsRfqIdRoute,
  AppSupplierOrgIdCustomersIndexRoute: AppSupplierOrgIdCustomersIndexRoute,
  AppSupplierOrgIdMessagesIndexRoute: AppSupplierOrgIdMessagesIndexRoute,
  AppSupplierOrgIdOrdersIndexRoute: AppSupplierOrgIdOrdersIndexRoute,
  AppSupplierOrgIdRfqsIndexRoute: AppSupplierOrgIdRfqsIndexRoute,
}

const AppSupplierOrgIdRouteWithChildren =
  AppSupplierOrgIdRoute._addFileChildren(AppSupplierOrgIdRouteChildren)

interface AppRouteChildren {
  AppAccountRoute: typeof AppAccountRouteWithChildren
  AppAdminRoute: typeof AppAdminRoute
  AppApprovalsRoute: typeof AppApprovalsRoute
  AppCompaniesRoute: typeof AppCompaniesRoute
  AppDirectoryRoute: typeof AppDirectoryRoute
  AppHomeRoute: typeof AppHomeRoute
  AppMeRoute: typeof AppMeRouteWithChildren
  AppNotificationsRoute: typeof AppNotificationsRoute
  AppOrdersRoute: typeof AppOrdersRoute
  AppPortfolioRoute: typeof AppPortfolioRoute
  AppProfileRoute: typeof AppProfileRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppSupportRoute: typeof AppSupportRoute
  AppSyncRoute: typeof AppSyncRoute
  AppBillingReturnRoute: typeof AppBillingReturnRoute
  AppLandListingIdRoute: typeof AppLandListingIdRoute
  AppLandEnquiriesRoute: typeof AppLandEnquiriesRoute
  AppMarketplaceLabourRatesRoute: typeof AppMarketplaceLabourRatesRoute
  AppMarketplaceProfessionalsRoute: typeof AppMarketplaceProfessionalsRoute
  AppMessagesConversationIdRoute: typeof AppMessagesConversationIdRoute
  AppOnboardingFlowRoute: typeof AppOnboardingFlowRoute
  AppOrgOrgIdRoute: typeof AppOrgOrgIdRouteWithChildren
  AppOrgNewRoute: typeof AppOrgNewRoute
  AppProjectsProjectIdRoute: typeof AppProjectsProjectIdRouteWithChildren
  AppProjectsNewRoute: typeof AppProjectsNewRoute
  AppSupplierOrgIdRoute: typeof AppSupplierOrgIdRouteWithChildren
  AppSupplierRegisterRoute: typeof AppSupplierRegisterRoute
  AppLandIndexRoute: typeof AppLandIndexRoute
  AppMarketplaceIndexRoute: typeof AppMarketplaceIndexRoute
  AppMessagesIndexRoute: typeof AppMessagesIndexRoute
  AppOnboardingIndexRoute: typeof AppOnboardingIndexRoute
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
  AppMarketplacePricesProductIdRoute: typeof AppMarketplacePricesProductIdRoute
  AppMarketplaceSuppliersOrgIdRoute: typeof AppMarketplaceSuppliersOrgIdRoute
  AppMarketplaceWorkersWorkerIdRoute: typeof AppMarketplaceWorkersWorkerIdRoute
  AppMarketplaceWorkersRequestsRoute: typeof AppMarketplaceWorkersRequestsRoute
  AppLandSellIndexRoute: typeof AppLandSellIndexRoute
  AppMarketplacePricesIndexRoute: typeof AppMarketplacePricesIndexRoute
  AppMarketplaceSuppliersIndexRoute: typeof AppMarketplaceSuppliersIndexRoute
  AppMarketplaceWorkersIndexRoute: typeof AppMarketplaceWorkersIndexRoute
  AppLandSellOrgIdIndexRoute: typeof AppLandSellOrgIdIndexRoute
  AppLandSellOrgIdListingsListingIdRoute: typeof AppLandSellOrgIdListingsListingIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountRoute: AppAccountRouteWithChildren,
  AppAdminRoute: AppAdminRoute,
  AppApprovalsRoute: AppApprovalsRoute,
  AppCompaniesRoute: AppCompaniesRoute,
  AppDirectoryRoute: AppDirectoryRoute,
  AppHomeRoute: AppHomeRoute,
  AppMeRoute: AppMeRouteWithChildren,
  AppNotificationsRoute: AppNotificationsRoute,
  AppOrdersRoute: AppOrdersRoute,
  AppPortfolioRoute: AppPortfolioRoute,
  AppProfileRoute: AppProfileRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppSupportRoute: AppSupportRoute,
  AppSyncRoute: AppSyncRoute,
  AppBillingReturnRoute: AppBillingReturnRoute,
  AppLandListingIdRoute: AppLandListingIdRoute,
  AppLandEnquiriesRoute: AppLandEnquiriesRoute,
  AppMarketplaceLabourRatesRoute: AppMarketplaceLabourRatesRoute,
  AppMarketplaceProfessionalsRoute: AppMarketplaceProfessionalsRoute,
  AppMessagesConversationIdRoute: AppMessagesConversationIdRoute,
  AppOnboardingFlowRoute: AppOnboardingFlowRoute,
  AppOrgOrgIdRoute: AppOrgOrgIdRouteWithChildren,
  AppOrgNewRoute: AppOrgNewRoute,
  AppProjectsProjectIdRoute: AppProjectsProjectIdRouteWithChildren,
  AppProjectsNewRoute: AppProjectsNewRoute,
  AppSupplierOrgIdRoute: AppSupplierOrgIdRouteWithChildren,
  AppSupplierRegisterRoute: AppSupplierRegisterRoute,
  AppLandIndexRoute: AppLandIndexRoute,
  AppMarketplaceIndexRoute: AppMarketplaceIndexRoute,
  AppMessagesIndexRoute: AppMessagesIndexRoute,
  AppOnboardingIndexRoute: AppOnboardingIndexRoute,
  AppProjectsIndexRoute: AppProjectsIndexRoute,
  AppMarketplacePricesProductIdRoute: AppMarketplacePricesProductIdRoute,
  AppMarketplaceSuppliersOrgIdRoute: AppMarketplaceSuppliersOrgIdRoute,
  AppMarketplaceWorkersWorkerIdRoute: AppMarketplaceWorkersWorkerIdRoute,
  AppMarketplaceWorkersRequestsRoute: AppMarketplaceWorkersRequestsRoute,
  AppLandSellIndexRoute: AppLandSellIndexRoute,
  AppMarketplacePricesIndexRoute: AppMarketplacePricesIndexRoute,
  AppMarketplaceSuppliersIndexRoute: AppMarketplaceSuppliersIndexRoute,
  AppMarketplaceWorkersIndexRoute: AppMarketplaceWorkersIndexRoute,
  AppLandSellOrgIdIndexRoute: AppLandSellOrgIdIndexRoute,
  AppLandSellOrgIdListingsListingIdRoute:
    AppLandSellOrgIdListingsListingIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  SignedOutRoute: SignedOutRoute,
  SigninRoute: SigninRoute,
  ViewAsRoute: ViewAsRoute,
  AuthAdminSigninRoute: AuthAdminSigninRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  CSlugRoute: CSlugRoute,
  InvitationsAcceptRoute: InvitationsAcceptRoute,
  PSlugRoute: PSlugRoute,
  TendersAcceptRoute: TendersAcceptRoute,
  OrganizationsInvitationsAcceptRoute: OrganizationsInvitationsAcceptRoute,
  PrintOrgOrgIdReportsReportKeyRoute: PrintOrgOrgIdReportsReportKeyRoute,
  PrintProjectsProjectIdCertificatesCertificateIdRoute:
    PrintProjectsProjectIdCertificatesCertificateIdRoute,
  PrintProjectsProjectIdReportsReportKeyRoute:
    PrintProjectsProjectIdReportsReportKeyRoute,
  PrintProjectsProjectIdSiteVisitsVisitIdRoute:
    PrintProjectsProjectIdSiteVisitsVisitIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
